(function () {
  'use strict';
  //var myApp = angular.module('creduc.app', []);
  angular.module('creduc.app', [
    'ngAnimate',
    'ngSanitize',
    'ngAria',

    'ui.router',
    'ui.bootstrap',
    'ui.select',
    'ui.utils.masks',
    'ui.utils.masks.br',

    'ngFileUpload',

    'creduc.config',
    'creduc.constants',
    'creduc.routes',
    'creduc.filters',
    'creduc.services',
    'creduc.components',
    'creduc.directives',
    'creduc.controllers'
  ]);

  angular.module('creduc.config', []);
  angular.module('creduc.constants', []);
  angular.module('creduc.routes', []);
  angular.module('creduc.filters', []);
  angular.module('creduc.services', []);
  angular.module('creduc.components', []);
  angular.module('creduc.directives', []);
  angular.module('creduc.controllers', []);

})();

(function () {
  'use strict';

  angular
    .module('creduc.controllers')
    .controller('ModalUploadController', ModalUploadController);

  /** @ngInject */
  function ModalUploadController($scope, $API, DialogService) {
    var self = this;

    self.file = {};
    self.documentos = [];
    self.documentosObrigatorios = [];
    self.documentosObrigatoriosSlug = [];
    self.progressPercentage = 50;
    self.uploading = false;

    self.name = 'modal-upload';
    self.title = 'Adicione documentos das pessoas consideradas na composição da renda informada';

    self.$onInit = function () {
      self.lead = self.resolve.lead;
      self.instituicao = self.resolve.instituicao;
      self.documentos = self.resolve.instituicao.docs;

      self.getDocumentosObrigatorios();

      angular.forEach(self.documentos, function (e) {
        self.file[e.NOME] = null;
      });
    };

    self.ok = function () {
      self.close({ $value: '' });
    };

    self.cancel = function () {
      self.dismiss({ $value: 'cancel' });
    };

    self.filesLength = function () {
      var c = 0;
      angular.forEach(Object.keys(self.file), function (e) {
        if (self.file.hasOwnProperty(e) && self.file[e])
          c++;
      });
      return c;
    };

    self.getDocumentosObrigatorios = function () {
      self.documentosObrigatorios = [];
      angular.forEach(self.documentos, function (e) {
        if (e.OBRIGATORIO == true) {
          self.documentosObrigatorios.push(e);
          self.documentosObrigatoriosSlug.push(e.NOME);
        }
      });
    };

    self.filesObrigatoriosSelected = function () {
      var c = 0;
      angular.forEach(Object.keys(self.file), function (e) {
        if (self.documentosObrigatoriosSlug.indexOf(e) > -1 && self.file.hasOwnProperty(e) && self.file[e]) {
          c++;
        }
      });
      return c;
    };


    self.$formIsValid = function () {
      if (self.documentosObrigatorios.length > 0) {
        return self.filesObrigatoriosSelected() == self.documentosObrigatorios.length;
      }

      return true;
    };

    self.upload = function () {
      self.uploading = true;
      self.progressPercentage = 0;
      self.lead.status = 'L';

      angular.forEach(self.documentos, function (e) {
        if (self.file.hasOwnProperty(e.NOME)) {
          self.lead[e.NOME] = self.file[e.NOME];
        }
      });

      $API
        .upload('/candidato/add/upload/', { lead: self.lead })
        .then(function (result) {
          if (result.data.CodigoResposta == 1) {
            self.uploading = false;
            self.close({ $value: result });
          }
        }, function () {
          self.uploading = false;
          DialogService.error({
            title: 'Erro!',
            message: 'Ocorreu um erro.'
          });
        }, function (e) {
          self.progressPercentage = parseInt(100.0 * e.loaded / e.total);
        });
    };

    self.$submit = function () {
      if ($scope.formFiles.$valid) {
        self.upload();
      } else {
        DialogService.error({
          title: 'Atenção!',
          message: 'Não foi possível concluir a inscrição pois o formulário contém erros. Por favor envie apenas arquivos PDF, JPG ou PNG.'
        });
      }
    };
  }

})();

(function () {
  'use strict';

  var component = {
    templateUrl: 'app/components/modals/modal-upload/modal-upload.html',
    controller: 'ModalUploadController',
    bindings: {
      resolve: '<',
      close: '&',
      dismiss: '&',
      modalInstance: '&'
    }
  };

  angular
    .module('creduc.components')
    .component('creducModalUpload', component);

})();

(function () {
  'use strict';

  angular
    .module('creduc.controllers')
    .controller('ModalProgressBarController', ModalProgressBarController);

  /** @ngInject */
  function ModalProgressBarController($state, $scope, $rootScope) {
    var self = this;

    self.name = 'modal-progress-bar';

    self.$onInit = function () {
      self.title = self.resolve.message.title;
      self.modalComponentProgressPercentage = $rootScope.modalComponentProgressPercentage;
    };

    $scope.$watch(function () {
      return $rootScope.modalComponentProgressPercentage;
    }, function (v) {
      self.modalComponentProgressPercentage = v;
    });
  }

})();

(function () {
  'use strict';

  var component = {
    templateUrl: 'app/components/modals/modal-progress-bar/modal-progress-bar.html',
    controller: 'ModalProgressBarController',
    bindings: {
      resolve: '<',
      close: '&',
      dismiss: '&',
      modalInstance: '&'
    }
  };

  angular
    .module('creduc.components')
    .component('creducModalProgressBar', component);

})();

(function () {
  'use strict';

  angular
    .module('creduc.controllers')
    .controller('ModalSouCadastradoController', ModalSouCadastradoController);

  /** @ngInject */
  function ModalSouCadastradoController($q, $API, $location, Instituicao, PathService, $state) {
    var self = this;
    self.localCpf = '';
    self.listDados = [];
    self.cpfNaoEncontradoMsg = '';

    self.$onInit = function () {
      self.title = self.resolve.message.title;
      self.localCpf = self.resolve.message.localCpf ? self.resolve.message.localCpf : '';
      self.listDados = self.resolve.message.listDados ? self.resolve.message.listDados : [];


      if (self.localCpf) {
        self.retunDirectiveCpf();
      }

    };

    self.ok = function () {
      self.close({$value: true});
    };

    self.cancel = function () {
      // //console.log(self.localCpf);
      self.close({$value: true});
    };


    self.site = function () {
      return PathService.$instituicao();
    };



    self.retunDirectiveCpf = function _checkCpf() {
      var modelValue = self.localCpf;
      if (!modelValue || modelValue.length < 11) {
        self.listDados = [];
        self.cpfNaoEncontradoMsg = '';
        return;
      }

      var params = $location.search();
      var def = $q.defer();
      if (params.cc == null || params.cc == undefined) {
        var url = '/instituicao/{idCampus}/candidato/{cpf}/pendencias';
        url = url.replace('{idCampus}', Instituicao.data().ID_CAMPUS);
        url = url.replace('{cpf}', modelValue);

        $API.get(url).then(function (result) {
          if (result.data.Dados.length == 0) {
            self.cpfNaoEncontradoMsg = '*CPF não encontrado';
            def.resolve();
          } else {

              self.listDados = result.data.Dados;

           // result.data.Dados.map(p => self.listDados.push(p));
            // //console.log(self.listDados);
          }
        });
      }
      return;
    };



    self.continueLead = function (index) {

        // //console.log(self.listDados[index]);

        $API.post('/candidato/lead/' + self.localCpf, {
          email: '',
          ID_CAMPUS_CURSO: self.listDados[index].Candidato.ID_CAMPUS_CURSO,
          ID_CAMPUS: self.listDados[index].IdCampus,
          ID_CANDIDATO: self.listDados[index].Candidato.ID_CANDIDATO
        }).then(function (r) {
          if (r.data.Dados) {
            var data = r.data.Dados;
            var campusCurso = data.CAMPUS_CURSO;

            var candidato = {};
            var selected = {};
            var estados = [];
            var cidades = [];
            var cursos = [];
            var instituicoes = [];

            candidato.cpf = data.CPF;
            candidato.nome = data.NOME;
            candidato.email = data.EMAIL;
            candidato.celular = data.CELULAR;
            candidato.telefone = data.TELEFONE;
            candidato.ID_CAMPUS = campusCurso.CAMPUS.ID_CAMPUS;

            selected.estado = data.ESTADO || {};
            selected.cidade = data.CIDADE || {};
            selected.curso = data.CAMPUS_CURSO.CURSO || {};
            selected.instituicao = data.CAMPUS_CURSO.CAMPUS || {};


            var lead = {
              ID_CANDIDATO: data.ID_CANDIDATO,
              ID_CAMPUS: data.ID_CAMPUS,
              CPF: data.CPF,
              NOME: data.NOME,
              CELULAR: data.CELULAR,
              EMAIL: data.EMAIL,
              ID_ESTADO: data.ID_ESTADO,
              ID_CIDADE: data.ID_CIDADE,
              CAMPUS_EXTENSO: data.CAMPUS_EXTENSO,
              CURSO_EXTENSO: data.CAMPUS_CURSO.CURSO.NOME,
              ID_CAMPUS_CURSO: data.ID_CAMPUS_CURSO,
              ORIGEM_CANDIDATO: 'H',
              instituicaoSelecionado: data.CAMPUS_CURSO.CAMPUS,
              RENDA: data.RENDA,
              RENDA_FAMILIAR: data.RENDA_FAMILIAR,
              TELEFONE: data.TELEFONE,
              NOTA_ENEM: data.NOTA_ENEM,
              MATRICULA: data.MATRICULA,
              DT_NASCIMENTO: data.STR_DT_NASCIMENTO,
              CEP: data.CEP,
              estadoCivil: data.FL_ESTADO_CIVIL,
              FL_VETERANO: data.FL_VETERANO,
              CONJUGE_CPF: data.CONJUGE_CPF,
              CONJUGE_NOME: data.CONJUGE_NOME,
              RESPONSAVEL_CPF: data.RESPONSAVEL_CPF,
              RESPONSAVEL_NOME: data.RESPONSAVEL_NOME,
              corresponsaveisFinanceiros: data.RESPONSAVEL_SERASA,
              alunoVeterano: data.FL_VETERANO == 'S',
              membrosFamilia: data.MEMBROS_FAMILIA,
              PASSOS: data.PASSOS,
              documentosAluno: data.documentosAluno,
              documentosConjuge: data.documentosConjuge,
              documentosResponsavel: data.documentosResponsavel,
              responsaveisFinanceiros: data.corresponsaveisFinanceiros,
              documentosFamilia: data.documentosFamilia,
              documentosFiador: data.documentosFiador,
              status: data.STATUS.FLAG,
              listaArquivos: [],
              LOGRADOURO: data.LOGRADOURO,
              BAIRRO: data.BAIRRO,
              CIDADE: data.CIDADE,
              ESTADO: data.ESTADO,
              UF: data.UF,
              NUMERO: data.NUMERO,
              COMPLEMENTO: data.COMPLEMENTO
            };
            console.log(lead);
            

            angular.forEach(lead.documentosAluno, function (e) {
              if (lead.status == "LEA") {
                lead.listaArquivos.push(e.ID_CHECK_LIST_DOC_CAMPUS);
              } else if (e.Status == "VAL") {
                lead.listaArquivos.push(e.ID_CHECK_LIST_DOC_CAMPUS);
              }
            });

            angular.forEach(lead.documentosConjuge, function (e) {
              if (lead.status == "LEA") {
                lead.listaArquivos.push(e.ID_CHECK_LIST_DOC_CAMPUS)
              } else if (e.Status == "VAL") {
                lead.listaArquivos.push(e.ID_CHECK_LIST_DOC_CAMPUS);
              }
            });

            angular.forEach(lead.documentosResponsavel, function (e) {
              if (lead.status == "LEA") {
                lead.listaArquivos.push(e.ID_CHECK_LIST_DOC_CAMPUS)
              } else if (e.Status == "VAL") {
                lead.listaArquivos.push(e.ID_CHECK_LIST_DOC_CAMPUS);
              }
            });

            angular.forEach(lead.documentosFamilia, function (e) {
              if (lead.status == "LEA") {
                lead.listaArquivos.push(e.ID_CHECK_LIST_DOC_CAMPUS)
              } else if (e.Status == "VAL") {
                lead.listaArquivos.push(e.ID_CHECK_LIST_DOC_CAMPUS);
              }
            });

            angular.forEach(lead.documentosFiador, function (e) {
              if (lead.status == "LEA") {
                lead.listaArquivos.push(e.ID_CHECK_LIST_DOC_CAMPUS)
              } else if (e.Status == "VAL") {
                lead.listaArquivos.push(e.ID_CHECK_LIST_DOC_CAMPUS);
              }
            });


            // self.continue();
            self.cancel();

            $state.go('instituicao-inscricao-dados-academicos', {
              instituicao: self.site(),
              candidato: lead,
              selected: selected,
              estados: estados || [],
              cidades: cidades || [],
              instituicoes: instituicoes || [],
              cursos: cursos || []
            });

          }
        }, function () {
          // DialogService.error({
          //   message: 'Erro ao carregar inscrição'
          // });
        });
    };



  }
})();

(function () {
  'use strict';

  var component = {
    templateUrl: 'app/components/modals/modal-sou-cadastrado/modal-sou-cadastrado.html',
    controller: 'ModalSouCadastradoController',
    bindings: {
      resolve: '<',
      close: '&',
      dismiss: '&',
      modalInstance: '&'
    }
  };

  angular
    .module('creduc.components')
    .component('creducModalSouCadastrado', component);

})();

(function () {
  'use strict';

  angular
    .module('creduc.controllers')
    .controller('ModalPendenciaAlertController', ModalPendenciaAlertController);

  /** @ngInject */
  function ModalPendenciaAlertController(Instituicao, DialogService) {
    var self = this;

    self.name = 'modal-pendencia-alert';
    self.instituicao = {};
    self.lead = {};

    self.$onInit = function () {
      self.title = self.resolve.message.title;
      self.instituicao = Instituicao.data();
      self.lead = self.resolve.lead;
    };

    self.ok = function () {
      self.close({ $value: '' });
    };

    self.cancel = function () {
      self.dismiss({ $value: 'cancel' });
    };

    self.openModalPendencia = function () {
      var dialogPendencia = DialogService.dialog({
        component: 'creducModalPendencia',
        backdrop: 'static',
        resolve: {
          instituicao: self.instituicao,
          lead: self.lead
        }
      });

      dialogPendencia.result.then(function(result) {
        if (result.action == 'UPLOAD_SUCCESS') {
          self.close({ $value: result })
        }
      });

      return dialogPendencia;
    };

    self.continue = function () {
      self.close({ $value: { action: 'CONTINUE' } });
    };
  }

})();

(function () {
  'use strict';

  var component = {
    templateUrl: 'app/components/modals/modal-pendencia-alert/modal-pendencia-alert.html',
    controller: 'ModalPendenciaAlertController',
    bindings: {
      resolve: '<',
      close: '&',
      dismiss: '&',
      modalInstance: '&'
    }
  };

  angular
    .module('creduc.components')
    .component('creducModalPendenciaAlert', component);

})();

(function () {
  'use strict';

  angular
    .module('creduc.controllers')
    .controller('ModalDialogController', ModalDialogController);

  /** @ngInject */
  function ModalDialogController() {
    var self = this;

    self.$onInit = function () {
      self.title = self.resolve.message.title;
      self.message = self.resolve.message.message;
      self.status = self.resolve.message.status;
      self.secondButton  = self.resolve.message.secondButton;
    };

    self.ok = function () {
      if (self.status) {
        self.close({ $value: true });
      } else {
        self.cancel();
      }
    };

    self.cancel = function () {
      self.dismiss({ $value: 'cancel' });
    };

    self.resultButton = function (resp) {
      self.close({ $value: resp });
    };
  }

})();

(function () {
  'use strict';

  var component = {
    templateUrl: 'app/components/modals/modal-dialog/modal-dialog.html',
    controller: 'ModalDialogController',
    bindings: {
      resolve: '<',
      close: '&',
      dismiss: '&'
    }
  };

  angular
    .module('creduc.components')
    .component('creducModalDialog', component);

})();

(function () {
  'use strict';

  angular
    .module('creduc.controllers')
    .controller('ModalDialogDefaultController', ModalDialogDefaultController);

  /** @ngInject */
  function ModalDialogDefaultController() {
    var self = this;

    self.$onInit = function () {
      self.title = self.resolve.message.title;
      self.message = self.resolve.message.message;
      self.html = self.resolve.message.HTMLTemplateElement;
    };

    self.ok = function () {
      self.close({ $value: '' });
    };

    self.cancel = function () {
      self.dismiss({ $value: 'cancel' });
    };
  }

})();

(function () {
  'use strict';

  var component = {
    templateUrl: 'app/components/modals/modal-dialog/modal-dialog-default.html',
    controller: 'ModalDialogDefaultController',
    bindings: {
      resolve: '<',
      close: '&',
      dismiss: '&'
    }
  };

  angular
    .module('creduc.components')
    .component('creducModalDialogDefault', component);

})();

(function () {
  'use strict';

  angular
    .module('creduc.controllers')
    .controller('ModalPendenciaController', ModalPendenciaController);

  /** @ngInject */
  function ModalPendenciaController($scope, $API, DialogService, $state) {
    var self = this;

    self.name = 'modal-pendencia';
    self.pending = true;
    self.uploading = false;
    self.showMessage = false;
    self.noSelected = true;
    self.instituicoes = [];
    self.documentos = [];
    self.documentosObrigatorios = [];
    self.documentosObrigatoriosSlug = [];
    self.files = {};
    self.candidato = {};

    self.$onInit = function () {
      self.title = 'Pendências';
      self.instituicao = self.resolve.instituicao;
      self.lead = self.resolve.lead;
      self.situacao = self.resolve.situacao;
       

      self.loadInstituicoes();

      if (self.instituicoes.length == 1) {
        self.noSelected = false;

        self.campus = self.instituicoes[0];

        if ('REJEITADO' in self.campus && self.campus.REJEITADO) {
          self.pending = true;
          self.rejeitado = true;
        }
        else if ('LEAD' in self.campus && self.campus.LEAD) {
          self.pending = true;
          self.leadStatus = true;
        }
        else if ('SEM_MATRICULA' in self.campus && self.campus.SEM_MATRICULA) {
          self.pending = true;
          self.semMatricula = true;
        }
        else {
          self.showMessage = true;
        }
      }
    };

    self.loadInstituicoes = function () {
      angular.forEach(self.situacao, function (e) {
        self.instituicoes.push({
          ID_CAMPUS: e.IdCampus,
          ID_CAMPUS_CURSO: e.Candidato.ID_CAMPUS_CURSO,
          NOME_FANTASIA: e.NomeCampus,
          PENDENTE: e.Pendente,
          REJEITADO: e.Rejeitado,
          SEM_MATRICULA: e.SemMatricula,
          LEAD: e.Lead
        })
      });
    };

    self.ok = function () {
      self.close({ $value: '' });
    };

    self.cancel = function () {
      self.dismiss({ $value: 'cancel' });
    };

    self.continue = function () {
      self.close({ $value: { action: 'CONTINUE' } });
    };

    self.getPendencias = function (campus) {
      if (!campus || !campus.ID_CAMPUS) {
        self.pending = true;
        self.noSelected = true;
        self.showMessage = false;
        self.rejeitado = false;
        self.leadStatus = false;
        self.pendenciaDocumento = false;
        return false;
      }

      self.pending = true;
      self.showMessage = false;
      self.noSelected = false;
      self.rejeitado = false;
      self.leadStatus = false;
      self.pendenciaDocumento = false;

      angular.forEach(self.documentos, function (e) {
        self.files[e.NOME] = null;
      });

      var url = '/campus/{idCampus}/candidato/{cpf}/pendencias';
      url = url.replace('{idCampus}', campus.ID_CAMPUS);
      url = url.replace('{cpf}', self.lead.cpf);

      $API.get(url).then(function (result) {
        if (result.data.Dados) {
          var data = result.data.Dados;

          self.campus = {
            ID_CAMPUS: data.IdCampus,
            ID_CAMPUS_CURSO: data.Candidato.ID_CAMPUS_CURSO,
            LEAD: data.Lead,
            NOME_FANTASIA: data.NomeCampus,
            PENDENTE: data.Pendente,
            REJEITADO: data.Rejeitado,
            SEM_MATRICULA: data.SemMatricula
          };

          if ('REJEITADO' in self.campus && self.campus.REJEITADO) {
            self.pending = true;
            self.rejeitado = true;
          }
          else if ('LEAD' in self.campus && self.campus.LEAD) {
            self.pending = true;
            self.leadStatus = true;
          }
          else if ('SEM_MATRICULA' in self.campus && self.campus.SEM_MATRICULA) {
            self.pending = true;
            self.semMatricula = true;
          }
          else {
            self.showMessage = true;
          }

        }
      }, function () {
        self.showMessage = true;
      });
    };

    self.upload = function () {
      self.uploading = true;
      self.progressPercentage = 0;

      self.lead.ID_CAMPUS = self.campus.ID_CAMPUS;

      angular.forEach(self.documentos, function (e) {
        if (self.files.hasOwnProperty(e.NOME)) {
          self.lead[e.NOME] = self.files[e.NOME];
        }
      });

      $API
        .upload('/candidato/pendencias/upload/', { lead: self.lead })
        .then(function (result) {
          if (result.data.CodigoResposta == 1) {
            self.uploading = false;
            var response = {
              action: 'UPLOAD_SUCCESS',
              message: {
                success: self.semMatricula ? 'Informação salva com sucesso!' : 'Documentos enviados com sucesso!'
              }
            };
            self.close({ $value: response });
          }
        }, function () {
          self.uploading = false;
          DialogService.error({
            title: 'Erro!',
            message: 'Ocorreu um erro.'
          });
        }, function (e) {
          self.progressPercentage = parseInt(100.0 * e.loaded / e.total);
        });
    };

    self.filesLength = function () {
      var c = 0;
      angular.forEach(Object.keys(self.files), function (e) {
        if (self.files.hasOwnProperty(e) && self.files[e])
          c++;
      });
      return c;
    };

    self.filesObrigatoriosSelected = function () {
      var c = 0;
      angular.forEach(Object.keys(self.files), function (e) {
        if (self.documentosObrigatoriosSlug.indexOf(e) > -1 && self.files.hasOwnProperty(e) && self.files[e]) {
          c++;
        }
      });
      return c;
    };

    self.getDocumentosObrigatorios = function () {
      self.documentosObrigatorios = [];
      angular.forEach(self.documentos, function (e) {
        if (e.OBRIGATORIO == true) {
          self.documentosObrigatorios.push(e);
          self.documentosObrigatoriosSlug.push(e.NOME);
        }
      });
    };

    self.$formIsValid = function () {
      if (self.documentosObrigatorios.length > 0) {
        return self.filesObrigatoriosSelected() == self.documentosObrigatorios.length;
      }
      return true;
    };

    self.continueLead = function () {

      if (self.email) {
        $API.post('/candidato/lead/' + self.lead.cpf, {
          email: self.email,
          ID_CAMPUS_CURSO: self.campus.ID_CAMPUS_CURSO,
          ID_CAMPUS: self.campus.ID_CAMPUS,
          ID_CANDIDATO: self.situacao[0].Candidato.ID_CANDIDATO
        }).then(function (r) {
          if (r.data.Dados) {
            var data = r.data.Dados;
            var campusCurso = data.CAMPUS_CURSO;

            var candidato = {}
            var selected = {};
            var estados = [];
            var cidades = [];
            var cursos = [];
            var instituicoes = [];

            candidato.cpf = data.CPF;
            candidato.nome = data.NOME;
            candidato.email = data.EMAIL;
            candidato.celular = data.CELULAR;
            candidato.telefone = data.TELEFONE;
            candidato.ID_CAMPUS = campusCurso.CAMPUS.ID_CAMPUS;

            //data.ESTADO.UF = data.ESTADO.COD_ESTADO;
           // data.CAMPUS_CURSO.CAMPUS.CAMPUS = data.CAMPUS_CURSO.CAMPUS.NOME_FANTASIA;
            //data.CAMPUS_CURSO.CURSO.DESCRICAO = '<u>' + campusCurso.CURSO.NOME + '</u> <span class="flags"><i>' + campusCurso.MODALIDADE.DESCRICAO + '</i> <i>' + campusCurso.GRAU.DESCRICAO + '</i> <i>' + campusCurso.TIPO_CURSO.DESCRICAO + '</i> <i>' + campusCurso.TURNO.NOME + '</i></span>';

            //estados.push(data.ESTADO);
            //cidades.push(data.CIDADE);
            //cursos.push(data.CAMPUS_CURSO.CURSO);
            //instituicoes.push(data.CAMPUS_CURSO.CAMPUS);

            selected.estado = data.ESTADO || {};
            selected.cidade = data.CIDADE || {};
            selected.curso = data.CAMPUS_CURSO.CURSO || {};
            selected.instituicao = data.CAMPUS_CURSO.CAMPUS || {};


            var lead = {
              ID_CANDIDATO: data.ID_CANDIDATO,
              ID_CAMPUS: data.ID_CAMPUS,
              CPF: data.CPF,
              NOME: data.NOME,
              CELULAR: data.CELULAR,
              EMAIL: data.EMAIL,
              ID_ESTADO: data.ID_ESTADO,
              ID_CIDADE: data.ID_CIDADE,
              CAMPUS_EXTENSO: data.CAMPUS_EXTENSO,
              CURSO_EXTENSO: data.CAMPUS_CURSO.CURSO.NOME,
              ID_CAMPUS_CURSO: data.ID_CAMPUS_CURSO,
              ORIGEM_CANDIDATO: 'H',
              instituicaoSelecionado: data.CAMPUS_CURSO.CAMPUS,
              RENDA: data.RENDA,
              RENDA_FAMILIAR: data.RENDA_FAMILIAR,
              TELEFONE: data.TELEFONE,
              NOTA_ENEM: data.NOTA_ENEM,
              MATRICULA: data.MATRICULA,
              DT_NASCIMENTO: data.STR_DT_NASCIMENTO,
              CEP: data.CEP,
              estadoCivil: data.FL_ESTADO_CIVIL,
              FL_VETERANO: data.FL_VETERANO,
              CONJUGE_CPF: data.CONJUGE_CPF,
              CONJUGE_NOME: data.CONJUGE_NOME,
              RESPONSAVEL_CPF: data.RESPONSAVEL_CPF,
              RESPONSAVEL_NOME: data.RESPONSAVEL_NOME,
              corresponsaveisFinanceiros: data.RESPONSAVEL_SERASA,
              alunoVeterano: data.FL_VETERANO == 'S',
              membrosFamilia: data.MEMBROS_FAMILIA,
              PASSOS: data.PASSOS,
              documentosAluno: data.documentosAluno,
              documentosConjuge: data.documentosConjuge,
              documentosResponsavel: data.documentosResponsavel,
              responsaveisFinanceiros: data.corresponsaveisFinanceiros,
              documentosFamilia: data.documentosFamilia,
              documentosFiador: data.documentosFiador,
              status: data.STATUS.FLAG,
              listaArquivos: []
            };

            angular.forEach(lead.documentosAluno, function (e) {
              if (lead.status == "LEA") {
                lead.listaArquivos.push(e.ID_CHECK_LIST_DOC_CAMPUS);
              } else if (e.Status == "VAL") {
                lead.listaArquivos.push(e.ID_CHECK_LIST_DOC_CAMPUS);
              }
            });

            angular.forEach(lead.documentosConjuge, function (e) {
              if (lead.status == "LEA") {
                lead.listaArquivos.push(e.ID_CHECK_LIST_DOC_CAMPUS)
              } else if (e.Status == "VAL") {
                lead.listaArquivos.push(e.ID_CHECK_LIST_DOC_CAMPUS);
              }
            });

            angular.forEach(lead.documentosResponsavel, function (e) {
              if (lead.status == "LEA") {
                lead.listaArquivos.push(e.ID_CHECK_LIST_DOC_CAMPUS)
              } else if (e.Status == "VAL") {
                lead.listaArquivos.push(e.ID_CHECK_LIST_DOC_CAMPUS);
              }
            });

            angular.forEach(lead.documentosFamilia, function (e) {
              if (lead.status == "LEA") {
                lead.listaArquivos.push(e.ID_CHECK_LIST_DOC_CAMPUS)
              } else if (e.Status == "VAL") {
                lead.listaArquivos.push(e.ID_CHECK_LIST_DOC_CAMPUS);
              }
            });

            angular.forEach(lead.documentosFiador, function (e) {
              if (lead.status == "LEA") {
                lead.listaArquivos.push(e.ID_CHECK_LIST_DOC_CAMPUS)
              } else if (e.Status == "VAL") {
                lead.listaArquivos.push(e.ID_CHECK_LIST_DOC_CAMPUS);
              }
            });


            self.continue();

            $state.go('instituicao-inscricao-dados-academicos', {
              instituicao: self.instituicao.SITE,
              candidato: lead,
              selected: selected,
              estados: estados || [],
              cidades: cidades || [],
              instituicoes: instituicoes || [],
              cursos: cursos || []
            });

          }
        }, function () {
          DialogService.error({
            message: 'Erro ao verificar E-mail.'
          });
        });
      }
    };

    self.continuePendencia = function () {
      if (self.email) {
        self.continueLead();
      }
    };

    self.$submit = function () {
      if (self.$formIsValid()) {
        self.upload();
      } else {
        var message = null;

        if (self.filesLength() == 0) {
          message = 'Nenhum arquivo foi selecionado. <br> Por favor envie apenas arquivos PDF, JPG ou PNG.';
        }

        DialogService.error({
          title: 'Atenção!',
          message: message || 'Não foi possível concluir a inscrição pois o formulário contém erros. <br> Por favor envie apenas arquivos PDF, JPG ou PNG.'
        });
      }
    };
  }

})();

(function () {
  'use strict';

  var component = {
    templateUrl: 'app/components/modals/modal-pendencia/modal-pendencia.html',
    controller: 'ModalPendenciaController',
    bindings: {
      resolve: '<',
      close: '&',
      dismiss: '&',
      modalInstance: '&'
    }
  };

  angular
    .module('creduc.components')
    .component('creducModalPendencia', component);

})();

(function () {
  'use strict';

  angular
    .module('creduc.controllers')
    .controller('ModalInscricaoController', ModalInscricaoController);

  /** @ngInject */
  function ModalInscricaoController() {
    var self = this;

    self.$onInit = function () {
      self.title = self.resolve.message.title;
      self.message = self.resolve.message.message;
    };

    self.ok = function () {
      self.close({ $value: '' });
    };

    self.cancel = function () {
      self.dismiss({ $value: 'cancel' });
    };
  }

})();

(function () {
  'use strict';

  var component = {
    templateUrl: 'app/components/modals/modal-inscricao/modal-inscricao.html',
    controller: 'ModalInscricaoController',
    bindings: {
      resolve: '<',
      close: '&',
      dismiss: '&',
      modalInstance: '&'
    }
  };

  angular
    .module('creduc.components')
    .component('creducModalInscricao', component);

})();

(function () {
  'use strict';

  angular
    .module('creduc.controllers')
    .controller('SlidesController', SlidesController);

  /** @ngInject */
  function SlidesController() {
    var self = this;
    var slides = self.slides = [];

    self.addSlide = function (slide) {
      slides.push(slide);
    };
  }

})();

(function () {
  'use strict';

  var component = {
    transclude: true,
    templateUrl: 'app/components/slides/slides.html',
    controller: 'SlidesController',
    bindings: {}
  };

  angular
    .module('creduc.components')
    .component('creducSlides', component);

})();

(function () {
  'use strict';

  angular
    .module('creduc.controllers')
    .controller('SlideController', SlideController);

  /** @ngInject */
  function SlideController() {
    var self = this;

    self.$onInit = function () {
      self.slidesCtrl.addSlide(self);
    };
  }

})();

(function () {
  'use strict';

  var component = {
    transclude: true,
    templateUrl: 'app/components/slide/slide.html',
    controller: 'SlideController',
    require: {
      slidesCtrl: '^creducSlides'
    },
    bindings: {
      title: '=',
      srcSm: '=',
      srcMd: '=',
      srcLg: '='
    }
  };

  angular
    .module('creduc.components')
    .component('creducSlide', component);

})();

(function () {
  'use strict';

  angular
    .module('creduc.controllers')
    .controller('PaymentBoletoController', PaymentBoletoController);

  /** @ngInject */
  function PaymentBoletoController($API, downloadService, DialogService, API_SETTINGS, ENV) {
    var self = this;

    self.name = 'payment-boleto';
    self.showLoader = false;


    self.getBoleto = function () {
      self.showLoader = true;
      var ret = JSON.parse(localStorage.getItem("recebivel"));
  

      var url = API_SETTINGS[ENV].CREDUC_API + '/api/Aluno/GetBoleto?idRecebivel=' + ret.IdRecebivel;



      $API.get(url)
        .then(function (res) {


          if (res.data.ReturnData) {
            var obj = {
              data: res.data.ReturnData.Result,
              filename: 'boleto',
              format: 'pdf'
            };
            downloadService.download(obj);
          }

        }, function () {
          // $API.ProcessarErro(ex, 'Não foi possível gerar o boleto!');
        });




    }
  }
})();

(function () {
  'use strict';

  var component = {
    templateUrl: 'app/components/payment-boleto/payment-boleto.html',
    controller: 'PaymentBoletoController',
    controllerAs: 'paymentb',
    bindings: {
      contrato: '<'
    }
  };

  angular
    .module('creduc.components')
    .component('creducPaymentBoleto', component);

})();

(function () {
    'use strict';

    angular
        .module('creduc.controllers')
        .controller('PaymentCreditcardController', PaymentCreditcardController);

    /** @ngInject */
    function PaymentCreditcardController($filter, $API, DialogService, API_SETTINGS, ENV) {
        var self = this;


        self.name = 'payment-creditcard';
        self.parcelas = [];

        self.dadosCartao = {
            numero: null,
            bandeira: null,
            validadeMes: null,
            validadeAno: null,
            nome: null,
            qtdCaracters: null,
            qtdCartao: null,
            txt: false,
            parcelaSelecionada: null,
            ccv: null


        };

        self.showLoader = false;

        self.$onChanges = function (c) {
            if (c.contrato.currentValue) getParcelas();
        };
        var qtdeParcelas = 6;

        function getParcelas() {

            var ret = JSON.parse(localStorage.getItem("recebivel"));

            if (ret.qtdCampus != null && ret.qtdCampus > 0) {

                qtdeParcelas = ret.qtdCampus;
            }


            if (qtdeParcelas == 0)
                qtdeParcelas = 6;

            for (var i = 1; i <= qtdeParcelas; i++) {
                self.parcelas.push({
                    qtdParcelas: i,
                    descricao:
                        i + 'x de ' + $filter('currency')(ret.Valor / i)
                });
            }
            self.dadosCartao.parcelaSelecionada = self.parcelas[0];
        }

        // Código copiado do portal do aluno antigo.
        self.setBandeira = function () {

            var numeroCartao = self.dadosCartao.numero;

            var marca = {
                VISA: {
                    valido: function (numeroCartao) {
                        return /^4\d{15}$/.test(numeroCartao);
                    }
                },
                MASTERCARD: {
                    valido: function (numeroCartao) {
                        return /^(5[1-5]|222[1-9]|22[3-9]|2[3-6]|27[01]|2720)[0-9]{0,}$/.test(
                            numeroCartao
                        );
                    }
                },
                DISCOVER: {
                    valido: function (numeroCartao) {
                        return /^(6011|65|64[4-9]|622)/.test(numeroCartao);
                    }
                },
                DINERS: {
                    valido: function (numeroCartao) {
                        return /^3[0,6,8]\d{12}$/.test(numeroCartao);
                    }
                },

                ELO: {
                    valido: function (numeroCartao) {
                        return /^4011|438935|45(1416|76)|50(4175|6699|67|90[4-7])|63(6297|6368)/.test(numeroCartao);
                    }
                },
                HIPERCARD: {
                    valido: function (numeroCartao) {
                        return /^(606282\d{10}(\d{3})?)|(3841\d{15})/.test(numeroCartao);
                    }
              },
                AMEX: {
                  valido: function (numeroCartao) {
                    return /^3[47][0-9]{13}$/.test(numeroCartao);
                  }
              },

            };

            self.dadosCartao.bandeira = null;

            if (marca.ELO.valido(numeroCartao)) {
                self.dadosCartao.bandeira = 'elo';
                self.dadosCartao.qtdCaracters = 16;
            }
            if (marca.VISA.valido(numeroCartao)) {
                self.dadosCartao.qtdCaracters = 16;
                self.dadosCartao.bandeira = 'visa';
            }
            if (marca.MASTERCARD.valido(numeroCartao)) {
                self.dadosCartao.qtdCaracters = 16;
                self.dadosCartao.bandeira = 'mastercard';
            }
            if (marca.DINERS.valido(numeroCartao)) {
                self.dadosCartao.bandeira = 'diners';
                self.dadosCartao.qtdCaracters = 14;
            }
            if (marca.DISCOVER.valido(numeroCartao)) {
                self.dadosCartao.bandeira = 'discover';
                self.dadosCartao.qtdCaracters = 16;
            }
            if (marca.HIPERCARD.valido(numeroCartao)) {
                self.dadosCartao.bandeira = 'hipercard';
                self.dadosCartao.qtdCaracters = 16;
            }
            if (marca.AMEX.valido(numeroCartao)) {
              self.dadosCartao.qtdCaracters = 15;
              self.dadosCartao.bandeira = 'amex';
            }

        };

        self.pagar = function () {
            var year = new Date;
            year = year.getFullYear();


            if (isNaN(self.dadosCartao.numero)) {
                DialogService.error({
                    title: 'Verifique o número do cartão',
                    message: 'Ano inválido'
                });
                return;
            }
            if (isNaN(self.dadosCartao.validadeMes) || (self.dadosCartao.validadeMes < 1 || self.dadosCartao.validadeMes > 12)) {
                DialogService.error({
                    title: 'Verifique o mês do cartão',
                    message: 'Mês inválido'
                });
                return;
            }
            if (isNaN(self.dadosCartao.validadeAno) || (self.dadosCartao.validadeAno < year)) {
                DialogService.error({
                    title: 'Verifique o Ano do cartão',
                    message: 'Ano inválido'
                });
                return;
            }
            if (self.dadosCartao.nome.split(' ').length < 2) {
                DialogService.error({
                    title: 'Verifique o nome impresso no cartão',
                    message: 'Nome inválido'
                });
                return;
            }
            self.showLoader = true;
            var ret = JSON.parse(localStorage.getItem("recebivel"));


            var params = {
                tipoRecebivel: 6,
                idRecebivel: ret.IdRecebivel,
                nomePortador: self.dadosCartao.nome,
                bandeira: self.dadosCartao.bandeira,
                numeroCartao: self.dadosCartao.numero,
                validadeCartao: self.dadosCartao.validadeAno + self.dadosCartao.validadeMes,
                qtdParcelas: self.dadosCartao.parcelaSelecionada.qtdParcelas
            };

            if (params.bandeira == null || params.bandeira == '') {
                DialogService.error({
                    title: 'Escolha a bandeira do cartão',
                    message: 'Não foi possivel reconhecer a bandeira do seu cartão'
                });
                self.showLoader = false;
                return;
            }


            $API.post(API_SETTINGS[ENV].CREDUC_API + '/api/Aluno/PagamentoCartaoCredito', params).then(function (res) {


                var dialog = {};
                if (res.data.ReturnData.Sucesso) {
                    dialog = DialogService.success({
                        title: res.data.StrCode,
                        message: res.data.MessageAlert
                    });
                    dialog.result.then(function () {
                        self.selected = {};
                        self.lead = {};
                        window.location.reload();
                    });
                } else {
                    DialogService.error({
                        title: 'Erro ao processar seu pagamento',
                        message: res.data.ReturnData.MensagemCustom
                    });
                }




                self.showLoader = false;
            },
                function (err) {
                    if (err && err.status === 500) {
                        DialogService.error({
                            title: 'Erro ao realizar o pagamento',
                            message:
                                'Ocorreu um problema interno no servidor. </br> Tente novamente. Se o problema persistir entre em contato com a instituição. </br>'
                        });
                    }
                    self.showLoader = false;
                }
            );

        };
    }
})();

(function () {
  'use strict';

  var component = {
    templateUrl: 'app/components/payment-creditcard/payment-creditcard.html',
    controller: 'PaymentCreditcardController',
    controllerAs: 'paymentcc',
    bindings: {
      contrato: '<',
      onPagamentoRealizado: '&'
    }
  };

  angular
    .module('creduc.components')
    .component('creducPaymentCreditcard', component);

})();

(function () {
  'use strict';

  angular
    .module('creduc.controllers')
    .controller('NavbarController', NavbarController)

  /** @ngInject */
  function NavbarController($stateParams, PathService, $filter) {
    var self = this;
    self.Escolha = false;
    self.urlInstituicao = $stateParams.instituicao;
    self.ListParametrosGrupo = [];
    if (localStorage.getItem("Escolha") == null) {
      self.Escolha = true;
    }

    self.update = function (value) {
      // self.navbarIsOpened = value;
      self.onChange({ value: value });
    };

    self.isHotsite = function () {
      return PathService.$isHotsite();
    };

    self.site = function () {
        return PathService.$instituicao();
    }

    self.bloqueiaSimulacao = function () {
      self.ListParametrosGrupo = JSON.parse(localStorage.getItem("parametros"));
      return exibeCampo("BLOQUEAR_SIMULACAO");
    };

    function exibeCampo(parametro) {
      var exibe = false;
      if (self.ListParametrosGrupo) {
        self.parametros = self.ListParametrosGrupo;
        if (self.parametros != undefined) {

          var it = $filter('filter')(self.parametros, { 'SLUG': parametro });

          if (it.length > 0) {
            var existe = it[0];

            if (self.parametros && existe.VALOR == "S") {
              exibe = true;
              return exibe;
            }
          }

        }
      }
      return exibe;
    }
  }

})();

(function () {
  'use strict';

  var component = {
    restrict: 'E',
    templateUrl: 'app/components/navbar/navbar.html',
    controller: 'NavbarController',
    bindings: {
      onChange: '&'
    }
  };

  angular
    .module('creduc.components')
    .component('creducNavbar', component);

})();

(function () {
  'use strict';

  angular
    .module('creduc.controllers')
    .controller('NavbarBtnController', NavbarBtnController)

  /** @ngInject */
  function NavbarBtnController() {
    var self = this;

    self.toggle = function () {
      self.onChange({ value: !self.navbarStatus });
    };
  }
})();

(function () {
  'use strict';

  var component = {
    restrict: 'E',
    templateUrl: 'app/components/navbar/navbar-btn.html',
    controller: 'NavbarBtnController',
    bindings: {
      navbarStatus: '=',
      onChange: '&'
    }
  };

  angular
    .module('creduc.components')
    .component('creducNavbarBtn', component);

})();

(function () {
  'use strict';

  angular
    .module('creduc.controllers')
    .controller('LoadingController', LoadingController);

  /** @ngInject */
  function LoadingController($scope, $http) {
    var self = this;

    self.name = 'loading';
    self.isLoading = false;

    $scope.$watch(function () {
      return $http.pendingRequests.length;
    }, function (v) {
      if (document.location.pathname != '/')
       
        //if (document.location.pathname != '/creduc/inscricao/documentos-candidato')
        self.isLoading = v > 0;
    });

  }

})();

(function () {
  'use strict';

  var component = {
    templateUrl: 'app/components/loading/loading.html',
    controller: 'LoadingController',
    bindings: {}
  };

  angular
    .module('creduc.components')
    .component('creducLoading', component);

})();

(function () {
  'use strict';

  angular
    .module('creduc.controllers')
    .controller('LinkController', LinkController);

  /** @ngInject */
  function LinkController(PathService, $state, $stateParams) {
    var self = this;

    self.$instituicao = $stateParams.instituicao || $state.params.instituicao || '';

    self.$onInit = function () {
      self.url = self.parseUrl(self.href);
      self.target = self.newWindow ? '_blank' : '_self';
    };

    self.closeNavbar = function () {
      self.onChange({ value: false });
    };

    self.getInstituicao = function () {
      return self.$instituicao = $stateParams.instituicao || $state.params.instituicao || '';
    };

    self.parseUrl = function (endpoint) {
      if (endpoint.startWith('http') || !self.changeHotsite) {
        return endpoint;
      }

      var url = PathService.ABSOLUTE_URL();

      if (self.getInstituicao()) {
        url += '/' + self.getInstituicao();
      }

      if (!endpoint.startWith('#')) {
        url += '/'
      }

      url += endpoint.replace('/', '');

      return url;
    };

  }

})();

(function () {
  'use strict';

  var component = {
    templateUrl: 'app/components/link/link.html',
    controller: 'LinkController',
    bindings: {
      title: '@',
      href: '@',
      changeHotsite: '@',
      newWindow: '@',
      class: '@',
      onChange: '&'
    }
  };

  angular
    .module('creduc.components')
    .component('creducLink', component);

})();

(function () {
  'use strict';

  var component = {
    templateUrl: 'app/components/inscricao/inscricao.html',
    controller: 'InscricaoComponentController',
    bindings: {
      instituicao: '='
    }
  };

  angular
    .module('creduc.components')
    .component('creducInscricao', component);

})();

(function () {
  'use strict';

  angular
    .module('creduc.controllers')
    .controller('InscricaoComponentController', InscricaoComponentController);

  /** @ngInject */
  function InscricaoComponentController(Estado, Instituicao, Lead, HelperService, DialogService, PathService, $uibModal, $scope, $API, $state, $location, $filter) {

    var self = this;

    self.estados = [];
    self.cidades = [];
    self.cidade = {};
    self.instituicoes = [];
    $scope.campi = [];
    $scope.statesWithFlags = [{ 'name': 'Alabama', 'flag': '5/5c/Flag_of_Alabama.svg/45px-Flag_of_Alabama.svg.png' },
    { 'name': 'Alaska', 'flag': 'e/e6/Flag_of_Alaska.svg/43px-Flag_of_Alaska.svg.png' },
    { 'name': 'Arizona', 'flag': '9/9d/Flag_of_Arizona.svg/45px-Flag_of_Arizona.svg.png' }, { 'name': 'Arkansas', 'flag': '9/9d/Flag_of_Arkansas.svg/45px-Flag_of_Arkansas.svg.png' }, { 'name': 'California', 'flag': '0/01/Flag_of_California.svg/45px-Flag_of_California.svg.png' }, { 'name': 'Colorado', 'flag': '4/46/Flag_of_Colorado.svg/45px-Flag_of_Colorado.svg.png' }, { 'name': 'Connecticut', 'flag': '9/96/Flag_of_Connecticut.svg/39px-Flag_of_Connecticut.svg.png' }, { 'name': 'Delaware', 'flag': 'c/c6/Flag_of_Delaware.svg/45px-Flag_of_Delaware.svg.png' }, { 'name': 'Florida', 'flag': 'f/f7/Flag_of_Florida.svg/45px-Flag_of_Florida.svg.png' }, { 'name': 'Georgia', 'flag': '5/54/Flag_of_Georgia_%28U.S._state%29.svg/46px-Flag_of_Georgia_%28U.S._state%29.svg.png' }, { 'name': 'Hawaii', 'flag': 'e/ef/Flag_of_Hawaii.svg/46px-Flag_of_Hawaii.svg.png' }, { 'name': 'Idaho', 'flag': 'a/a4/Flag_of_Idaho.svg/38px-Flag_of_Idaho.svg.png' }, { 'name': 'Illinois', 'flag': '0/01/Flag_of_Illinois.svg/46px-Flag_of_Illinois.svg.png' }, { 'name': 'Indiana', 'flag': 'a/ac/Flag_of_Indiana.svg/45px-Flag_of_Indiana.svg.png' }, { 'name': 'Iowa', 'flag': 'a/aa/Flag_of_Iowa.svg/44px-Flag_of_Iowa.svg.png' }, { 'name': 'Kansas', 'flag': 'd/da/Flag_of_Kansas.svg/46px-Flag_of_Kansas.svg.png' }, { 'name': 'Kentucky', 'flag': '8/8d/Flag_of_Kentucky.svg/46px-Flag_of_Kentucky.svg.png' }, { 'name': 'Louisiana', 'flag': 'e/e0/Flag_of_Louisiana.svg/46px-Flag_of_Louisiana.svg.png' }, { 'name': 'Maine', 'flag': '3/35/Flag_of_Maine.svg/45px-Flag_of_Maine.svg.png' }, { 'name': 'Maryland', 'flag': 'a/a0/Flag_of_Maryland.svg/45px-Flag_of_Maryland.svg.png' }, { 'name': 'Massachusetts', 'flag': 'f/f2/Flag_of_Massachusetts.svg/46px-Flag_of_Massachusetts.svg.png' }, { 'name': 'Michigan', 'flag': 'b/b5/Flag_of_Michigan.svg/45px-Flag_of_Michigan.svg.png' }, { 'name': 'Minnesota', 'flag': 'b/b9/Flag_of_Minnesota.svg/46px-Flag_of_Minnesota.svg.png' }, { 'name': 'Mississippi', 'flag': '4/42/Flag_of_Mississippi.svg/45px-Flag_of_Mississippi.svg.png' }, { 'name': 'Missouri', 'flag': '5/5a/Flag_of_Missouri.svg/46px-Flag_of_Missouri.svg.png' }, { 'name': 'Montana', 'flag': 'c/cb/Flag_of_Montana.svg/45px-Flag_of_Montana.svg.png' }, { 'name': 'Nebraska', 'flag': '4/4d/Flag_of_Nebraska.svg/46px-Flag_of_Nebraska.svg.png' }, { 'name': 'Nevada', 'flag': 'f/f1/Flag_of_Nevada.svg/45px-Flag_of_Nevada.svg.png' }, { 'name': 'New Hampshire', 'flag': '2/28/Flag_of_New_Hampshire.svg/45px-Flag_of_New_Hampshire.svg.png' }, { 'name': 'New Jersey', 'flag': '9/92/Flag_of_New_Jersey.svg/45px-Flag_of_New_Jersey.svg.png' }, { 'name': 'New Mexico', 'flag': 'c/c3/Flag_of_New_Mexico.svg/45px-Flag_of_New_Mexico.svg.png' }, { 'name': 'New York', 'flag': '1/1a/Flag_of_New_York.svg/46px-Flag_of_New_York.svg.png' }, { 'name': 'North Carolina', 'flag': 'b/bb/Flag_of_North_Carolina.svg/45px-Flag_of_North_Carolina.svg.png' }, { 'name': 'North Dakota', 'flag': 'e/ee/Flag_of_North_Dakota.svg/38px-Flag_of_North_Dakota.svg.png' }, { 'name': 'Ohio', 'flag': '4/4c/Flag_of_Ohio.svg/46px-Flag_of_Ohio.svg.png' }, { 'name': 'Oklahoma', 'flag': '6/6e/Flag_of_Oklahoma.svg/45px-Flag_of_Oklahoma.svg.png' }, { 'name': 'Oregon', 'flag': 'b/b9/Flag_of_Oregon.svg/46px-Flag_of_Oregon.svg.png' }, { 'name': 'Pennsylvania', 'flag': 'f/f7/Flag_of_Pennsylvania.svg/45px-Flag_of_Pennsylvania.svg.png' }, { 'name': 'Rhode Island', 'flag': 'f/f3/Flag_of_Rhode_Island.svg/32px-Flag_of_Rhode_Island.svg.png' }, { 'name': 'South Carolina', 'flag': '6/69/Flag_of_South_Carolina.svg/45px-Flag_of_South_Carolina.svg.png' }, { 'name': 'South Dakota', 'flag': '1/1a/Flag_of_South_Dakota.svg/46px-Flag_of_South_Dakota.svg.png' }, { 'name': 'Tennessee', 'flag': '9/9e/Flag_of_Tennessee.svg/46px-Flag_of_Tennessee.svg.png' }, { 'name': 'Texas', 'flag': 'f/f7/Flag_of_Texas.svg/45px-Flag_of_Texas.svg.png' }, { 'name': 'Utah', 'flag': 'f/f6/Flag_of_Utah.svg/45px-Flag_of_Utah.svg.png' }, { 'name': 'Vermont', 'flag': '4/49/Flag_of_Vermont.svg/46px-Flag_of_Vermont.svg.png' },
    { 'name': 'Virginia', 'flag': '4/47/Flag_of_Virginia.svg/44px-Flag_of_Virginia.svg.png' }, { 'name': 'Washington', 'flag': '5/54/Flag_of_Washington.svg/46px-Flag_of_Washington.svg.png' }, { 'name': 'West Virginia', 'flag': '2/22/Flag_of_West_Virginia.svg/46px-Flag_of_West_Virginia.svg.png' }, { 'name': 'Wisconsin', 'flag': '2/22/Flag_of_Wisconsin.svg/45px-Flag_of_Wisconsin.svg.png' }, { 'name': 'Wyoming', 'flag': 'b/bc/Flag_of_Wyoming.svg/43px-Flag_of_Wyoming.svg.png' }]
    self.instituicao = {};
    self.rendaFamiliar = false;
    self.pessoasFamilia = false;
    self.dataNascimento = false;
    self.notaEnem = false;
    self.chamadaInicial = true;
    self.cursos = [];
    self.listaCursos = [];
    self.selected = {};
    self.selected1 = {};
    self.disabled = true;
    self.$isHotsite = PathService.$isHotsite;
    self.emailvalido = false;
    self.creducHome = false;
    self.listaTipoGraduacao = ['Graduação'];
    self.selecionadoTipoGraduacao = '';
    // self.modalidade = "G";
    $scope.NomeCidade1 = '';
    $scope.$watch($scope.NomeCidade1, function () {

    }, true);

    $scope.openModalPendencia = function () {
      var modalUpload = $uibModal.open({
        component: 'creducModalPendencia',
        backdrop: 'static',
        resolve: {
          instituicao: self.instituicao,
          lead: self.lead
        }
      });

      return modalUpload;
    };
    $scope.customSelected = null;
    $scope.gravaIncricaoEstadoLocal = function () {

      //if (localStorage.getItem("inscricao") != null && localStorage.getItem("inscricao") != undefined && localStorage.getItem("inscricao") != 'undefined') {
      //  self.lead = JSON.parse(localStorage.getItem("inscricao"));
      //}
      //if (self.lead != null) {
      //  self.lead.estadoSelecionado = estado;
      //} else {
      //  self.lead = {};
      //  self.lead.estadoSelecionado = estado;

      //}
      //if (!inicio) {
      //  self.lead.cidadeSelecionado = null;
      //  self.lead.cursoSelecionado = null;
      //  self.lead.instituicaoSelecionado = null;
      //}

      //localStorage. o", JSON.stringify(self.lead))

    };
    $scope.gravaIncricaoCidadeLocal = function (cidade) {
      if (self.lead != null) {
        self.lead.cidadeSelecionado = cidade;
      } else {
        self.lead = {};
        self.lead.cidadeSelecionado = cidade;

      }



    };

    $scope.buscarCampus = function (cidade) {
      localStorage.setItem("ciu", JSON.stringify(cidade));
      $API.post('api/campus/BuscarPorLocalidade_a', cidade).then(function (r) {
        $scope.campi = r.data.ReturnData;
      }, function () {
      });

    };
    $scope.gravaIncricaoInstituicaoLocal = function (instituicao) {

      if (self.lead != null) {
        self.lead.instituicaoSelecionado = instituicao;
      } else {
        self.lead = {};
        self.lead.instituicaoSelecionado = instituicao;
      }
    };

    $scope.gravaSelectedCurso = function (curso) {



      if (self.lead != null) {
        self.lead.cursoSelecionado = curso;
      } else {
        self.lead = {};
        self.lead.cursoSelecionado = curso;
      }

    };
    $scope.pegaIncricaoLocalEstado = function () {

    };

    $scope.pegaIncricaoLocalInstituicao = function () {

    };
    $scope.pegaIncricaoLocalCidade = function () {

    };
    $scope.pegaIncricaoLocalCurso = function () {

    };
    $scope.changeEstado = function () {

    };
    self.$onInit = function () {
      //localStorage.removeItem("_inscricao");
      //localStorage.removeItem("inscricaoFK");
      sessionStorage.clear();


      if (localStorage.getItem("ciu") != null && localStorage.getItem("ciu") != "undefined") {
        self.NomeCidade = JSON.parse(localStorage.getItem("ciu"));
        $scope.buscarCampus(self.NomeCidade);
      }
      if (PathService.$isHotsite()) {

        Instituicao.dataAsync().then(function (data) {
          self.instituicao = data;
          self.rendaFamiliar = self.instituicao.SOLICITAR_RENDA;
          self.pessoasFamilia = self.instituicao.EXIBIR_CAMPO_PESSOAS_FAMILIA;
          self.dataNascimento = self.instituicao.EXIBIR_CAMPO_DT_NASCIMENTO;
          self.notaEnem = self.instituicao.EXIBIR_CAMPO_NOTA_ENEM;
          Estado.campus.all(self.instituicao.ID_CAMPUS).then(promiseEstadoSuccess);
          self.completaInscricao();
        });


        // //Pegar arquivo local Json, nao chama valores do Back, precisa existir a pasta local
        // var slug = $state.params.instituicao;
        // $http.get('app/dados/'+slug+'/data.json').then(function(data) {
        //   self.instituicao = data.data.Dados;
        //   self.rendaFamiliar = self.instituicao.SOLICITAR_RENDA;
        //   self.pessoasFamilia = self.instituicao.EXIBIR_CAMPO_PESSOAS_FAMILIA;
        //   self.dataNascimento = self.instituicao.EXIBIR_CAMPO_DT_NASCIMENTO;
        //   self.notaEnem = self.instituicao.EXIBIR_CAMPO_NOTA_ENEM;
        //   Estado.campus.all(self.instituicao.ID_CAMPUS).then(promiseEstadoSuccess);
        //   self.completaInscricao();
        //   //console.log('CARREGANDO ARQUIVOS JSON DA PASTA LOCAL');
        //   //console.log(data);
        //
        // }, function() {
        //   //console.log('Não achou folder local');
        //   Instituicao.dataAsync().then(function (data) {
        //     self.instituicao = data;
        //     self.rendaFamiliar = self.instituicao.SOLICITAR_RENDA;
        //     self.pessoasFamilia = self.instituicao.EXIBIR_CAMPO_PESSOAS_FAMILIA;
        //     self.dataNascimento = self.instituicao.EXIBIR_CAMPO_DT_NASCIMENTO;
        //     self.notaEnem = self.instituicao.EXIBIR_CAMPO_NOTA_ENEM;
        //     Estado.campus.all(self.instituicao.ID_CAMPUS).then(promiseEstadoSuccess);
        //     self.completaInscricao();
        //   });
        // });

      } else {
        //Estado.all().then(promiseEstadoSuccess);
      }
    };

    self.completaInscricao = function () {

      var params = $location.search();
      if (params.cc == null || params.cc == undefined) {
        return;
      }


      $API.post('/candidato/lead/' + params.candidato, {
        email: params.mail,
        ID_CAMPUS_CURSO: params.cc,
        ID_CAMPUS: params.c,
        ID_CANDIDATO: params.ca
      }).then(function (r) {
        if (r.data.Dados) {
          var data = r.data.Dados;
          
          var campusCurso = data.CAMPUS_CURSO;

          var candidato = {};
          var selected = {};
          var estados = [];
          var cidades = [];
          var cursos = [];
          var instituicoes = [];


          candidato.cpf = data.CPF;
          candidato.nome = data.NOME;
          candidato.email = data.EMAIL;
          candidato.celular = data.CELULAR;
          candidato.telefone = data.TELEFONE;
          candidato.ID_CAMPUS = campusCurso.CAMPUS.ID_CAMPUS;
          candidato.ForcarSolicitarDocumentos = data.ForcarSolicitarDocumentos;
          candidato.ForcarSolicitarFiador = data.ForcarSolicitarFiador;


          //data.ESTADO.UF = data.ESTADO.COD_ESTADO;
          data.CAMPUS_CURSO.CAMPUS.CAMPUS = data.CAMPUS_CURSO.CAMPUS.NOME_FANTASIA;
          data.CAMPUS_CURSO.CURSO.DESCRICAO = '<u>' + campusCurso.CURSO.NOME + '</u> <span class="flags"><i>' + campusCurso.MODALIDADE.DESCRICAO + '</i> <i>' + campusCurso.GRAU.DESCRICAO + '</i> <i>' + campusCurso.TIPO_CURSO.DESCRICAO + '</i> <i>' + campusCurso.TURNO.NOME + '</i></span>';

          estados.push(data.ESTADO);
          cidades.push(data.CIDADE);
          cursos.push(data.CAMPUS_CURSO.CURSO);
          instituicoes.push(data.CAMPUS_CURSO.CAMPUS);

          selected.estado = data.ESTADO || {};
          selected.cidade = data.CIDADE || {};
          selected.curso = data.CAMPUS_CURSO.CURSO || {};
          selected.instituicao = data.CAMPUS_CURSO.CAMPUS || {};


          self.lead = {
            ID_CANDIDATO: data.ID_CANDIDATO,
            ID_CAMPUS: data.ID_CAMPUS,
            CPF: data.CPF,
            NOME: data.NOME,
            CELULAR: data.CELULAR,
            EMAIL: data.EMAIL,
            ID_ESTADO: data.ID_ESTADO,
            ID_CIDADE: data.ID_CIDADE,
            CAMPUS_EXTENSO: data.CAMPUS_EXTENSO,
            CURSO_EXTENSO: data.CAMPUS_CURSO.CURSO.NOME,
            ID_CAMPUS_CURSO: data.ID_CAMPUS_CURSO,
            ORIGEM_CANDIDATO: 'H',
            instituicaoSelecionado: data.CAMPUS_CURSO.CAMPUS,
            RENDA: data.RENDA,
            RENDA_FAMILIAR: data.RENDA_FAMILIAR,
            TELEFONE: data.TELEFONE,
            NOTA_ENEM: data.NOTA_ENEM,
            MATRICULA: data.MATRICULA,
            DT_NASCIMENTO: data.STR_DT_NASCIMENTO,
            CEP: data.CEP,
            estadoCivil: data.FL_ESTADO_CIVIL,
            FL_VETERANO: data.FL_VETERANO,
            CONJUGE_CPF: data.CONJUGE_CPF,
            CONJUGE_NOME: data.CONJUGE_NOME,
            RESPONSAVEL_CPF: data.RESPONSAVEL_CPF,
            RESPONSAVEL_NOME: data.RESPONSAVEL_NOME,
            corresponsaveisFinanceiros: data.RESPONSAVEL_SERASA,
            alunoVeterano: data.FL_VETERANO,
            membrosFamilia: data.MEMBROS_FAMILIA,
            PASSOS: data.PASSOS,
            documentosAluno: data.documentosAluno,
            documentosConjuge: data.documentosConjuge,
            documentosResponsavel: data.documentosResponsavel,
            responsaveisFinanceiros: data.corresponsaveisFinanceiros,
            documentosFamilia: data.documentosFamilia,
            documentosFiador: data.documentosFiador,
            status: data.STATUS.FLAG,
            listaArquivos: [],
            ForcarSolicitarDocumentos: data.ForcarSolicitarDocumentos,
            ForcarSolicitarFiador: data.ForcarSolicitarFiador
          };


          angular.forEach(self.documentosAluno, function (e) {
            self.lead.listaArquivos.push(e.ID_CHECK_LIST_DOC_CAMPUS)
          });

          angular.forEach(self.documentosConjuge, function (e) {
            self.lead.listaArquivos.push(e.ID_CHECK_LIST_DOC_CAMPUS)
          });

          angular.forEach(self.documentosResponsavel, function (e) {
            self.lead.listaArquivos.push(e.ID_CHECK_LIST_DOC_CAMPUS)
          });

          angular.forEach(self.documentosFamilia, function (e) {
            self.lead.listaArquivos.push(e.ID_CHECK_LIST_DOC_CAMPUS)
          });


          angular.forEach(self.documentosFiador, function (e) {
            self.lead.listaArquivos.push(e.ID_CHECK_LIST_DOC_CAMPUS)
          });

          localStorage.removeItem("_inscricao");
          //localStorage.setItem("_inscricao", JSON.stringify(self.lead));
          var ies = localStorage.getItem("lastInstituicao")

          $state.go('instituicao-inscricao-dados-academicos', {
            instituicao: ies,
            candidato: self.lead,
            selected: selected,
            estados: estados || [],
            cidades: cidades || [],
            instituicoes: instituicoes || [],
            cursos: cursos || []
          });


        }
      }, function () {
        DialogService.error({
          message: 'Erro ao verificar E-mail.'
        });
      });
    }
    self.getCidades = function (estado) {
      if (!estado) {
        return false;
      }

      // $scope.gravaIncricaoEstadoLocal(estado, inicio);

      HelperService.deleteSelected(self.selected, 'cidade');
      HelperService.deleteSelected(self.selected, 'instituicao');
      HelperService.deleteSelected(self.selected, 'curso');
      HelperService.deleteSelected(self, 'cidades');
      HelperService.deleteSelected(self, 'instituicoes');
      HelperService.deleteSelected(self, 'listaCursos');

      self.listaTipoGraduacao = ['Graduação'];
      self.selecionadoTipoGraduacao = '';

      if (PathService.$isHotsite()) {
        Estado.campus.cidades(self.instituicao.ID_CAMPUS, estado.ID_ESTADO).then(promiseCidadeSuccess);
      } else {
        Estado.cidades(estado.ID_ESTADO).then(promiseCidadeSuccess);
      }
    };

    self.getInstituicoesCreduc = function ($item) {
      if (!$item) {
        return false;
      }
      $scope.gravaIncricaoCidadeLocal($item);
      HelperService.deleteSelected(self.selected, 'instituicao');

      if ($item && $item.ID_CIDADE) {
        Instituicao.filter.cidade(null, $item.ID_CIDADE, null).then(promiseInstituicoesSuccess);
      }
    };

    self.getInstituicoes = function ($item, $item2) {
      //HelperService.deleteSelected(self.selected, 'instituicao');
      //HelperService.deleteSelected(self.selected, 'curso');
      //HelperService.deleteSelected(self, 'instituicoes');
      //HelperService.deleteSelected(self, 'listaCursos');
      // var CPF = null;

      // if (self.lead && self.lead.CPF) {
      //     CPF = self.lead.CPF.replace(".", "").replace(".", "").replace("-", "");
      // }

      if (!$item) {
        return false;
      }

      //var json = '{ "ID_CIDADE":"' + $item.ID_CIDADE + '" , "Nome":"' + $item.NOME_CIDADE + '" , "Uf":"' + $item2.UF + '" }';
      //$API.post('api/Campus/BuscarPorUfCidadeCampus/?idCampus=' + self.instituicao.ID_CAMPUS, json).then(function (r) {
      //    self.instituicoes = r.data.ReturnData;
      //}, function () {
      //});


      $API.post('/campus/{idCampus}/ufCpf/?idCampus=' + self.instituicao.ID_CAMPUS + '&uf=' + $item2.UF, $item).then(function (r) {
        self.instituicoes = r.data.Dados.Result;
        self.listaTipoGraduacao = ['Graduação'];
        self.selecionadoTipoGraduacao = '';
        self.resultadoEmReais = null;
      }, function () {
      });
      //console.log($scope.campi);
      $scope.gravaIncricaoCidadeLocal($item);
      //Instituicao.filter.cidade(self.instituicao.ID_CAMPUS, $item.ID_CIDADE, CPF).then(promiseInstituicoesSuccess);
      //console.log(self.instituicoes);

    };

    self.getCursos = function ($item) {
      HelperService.deleteSelected(self.selected, 'curso');

      if (!$item || !$item.hasOwnProperty('ID_CAMPUS')) {
        return false;
      }
      $scope.gravaIncricaoInstituicaoLocal($item);

      if (!PathService.$isHotsite() && $item.hasOwnProperty('SLUG') && $item.SLUG) {
        DialogService.alert({
          message: 'Você está sendo redirecionado para o hotsite da instituição: <br><b>' + $item.CAMPUS + '</b>'
        });

        $state.go('instituicao', {
          instituicao: $item.SLUG
        });
      }

      if ($item && $item.hasOwnProperty('ID_CAMPUS') && $item.ID_CAMPUS) {
        Instituicao.cursos($item.ID_CAMPUS).then(promiseCursosSuccess);
      }
    };


    $scope.getCursos1 = function ($item) {

      DialogService.alert({
        message: 'Você está sendo redirecionado para o hotsite da instituição: <br><b>' + $item.HotSite + '</b>'
      });

      $state.go('instituicao', {
        instituicao: $item.HotSite
      });

    };

    self.getTituloRenda = function () {
      return self.instituicao.TEXTO_CAMPO_RENDA;
    };

    self.getDicaRenda = function () {
      return self.instituicao.TEXTO_INFORMATIVO_RENDA;
    };
    self.VAlidaInscricao = function (lead) {

      if (lead.CPF == null) {
        DialogService.error({
          message: 'Por favor preencha o CPF'
        });
        return false;
      }

      if (lead.NOME == null) {
        DialogService.error({
          message: 'Por favor preencha o NOME'
        });
        return false;
      }
      if (lead.CELULAR == null) {
        DialogService.error({
          message: 'Por favor preencha o CELULAR'
        });
        return false;
      }
      if (lead.EMAIL == null) {
        DialogService.error({
          message: 'Por favor preencha o E-MAIL'
        });
        return false;
      }

      return true;

    }
    self.submit = function () {
      var lead = {};

      if (localStorage.getItem("inscricaoFK") != null) {
        var fkitem = JSON.parse(localStorage.getItem("inscricaoFK"));

        if (self.lead.CPF == null) {

          self.lead.CPF = fkitem.CPF;

        }
        if (self.lead.NOME == null) {
          self.lead.NOME = fkitem.NOME;
        }
        if (self.lead.CELULAR == null) {
          self.lead.CELULAR = fkitem.CELULAR;
        }
        if (self.lead.EMAIL == null) {
          self.lead.EMAIL = fkitem.EMAIL;
        }
      }
      if (HelperService.getSelectedValue(self.selected, 'estado', 'ID_ESTADO', null) == null && PathService.$isHotsite()) {
        DialogService.error({
          message: 'Escolha um Estado'
        });
        return false;
      }
      if (HelperService.getSelectedValue(self.selected, 'cidade', 'ID_CIDADE', null) == null && PathService.$isHotsite()) {
        DialogService.error({
          message: 'Escolha uma Cidade'
        });
        return false;
      }
      if (HelperService.getSelectedValue(self.selected, 'instituicao', 'CAMPUS') == null && PathService.$isHotsite()) {
        DialogService.error({
          message: 'Escolha uma Instituição de Interesse'
        });
        return false;
      }
      if (HelperService.getSelectedValue(self.selected, 'curso', 'NOME') == null && PathService.$isHotsite()) {
        DialogService.error({
          message: 'Escolha um curso'
        });
        return false;
      }
      if (self.exibeRegulamento() && !self.regulamentoAceito) {
        DialogService.error({
          message: 'Marque a opção <b>Confirmo que li e estou de acordo com o regulamento</b>'
        });
        return false;

      }

      var IdUsuarioTeste = 0;

      var UserTeste = localStorage.getItem('userTeste');

      if (UserTeste != null) {
        IdUsuarioTeste = JSON.parse(UserTeste).IdUser;
      }
      lead = {
        CPF: self.lead.CPF != null ? self.lead.CPF : null,
        NOME: self.lead.NOME != null ? self.lead.NOME.toUpperCase() : null,
        CELULAR: self.lead.CELULAR,
        EMAIL: self.lead.EMAIL != null ? self.lead.EMAIL.toUpperCase() : null,
        ID_ESTADO: HelperService.getSelectedValue(self.selected, 'estado', 'ID_ESTADO', null),
        ID_CIDADE: HelperService.getSelectedValue(self.selected, 'cidade', 'ID_CIDADE', null),
        CAMPUS_EXTENSO: HelperService.getSelectedValue(self.selected, 'instituicao', 'CAMPUS') != null ? HelperService.getSelectedValue(self.selected, 'instituicao', 'CAMPUS').toUpperCase() : null,
        CURSO_EXTENSO: HelperService.getSelectedValue(self.selected, 'curso', 'NOME') != null ? HelperService.getSelectedValue(self.selected, 'curso', 'NOME').toUpperCase() : null,
        ID_CAMPUS_CURSO: HelperService.getSelectedValue(self.selected, 'curso', 'ID_CAMPUS_CURSO', null),
        ORIGEM_CANDIDATO: PathService.$isHotsite() ? 'H' : 'S',
        UserTeste: IdUsuarioTeste
      };

      if (!self.VAlidaInscricao(lead)) {
        return false;
      }

      if (PathService.$isHotsite()) {

        lead.FL_STATUS = "LEAD";

        $API.post('/candidato/add', lead).then(function (r) {
          self.lead.ID_CAMPUS = self.selected.curso.ID_CAMPUS;
          self.lead.ID_CANDIDATO = r.data.Dados.ID_CANDIDATO;
          self.lead.IdLogin = r.data.Dados.IdLogin;
          localStorage.removeItem("inscricaoFK");

          if (r.data.Dados.IsCandidatoCampusPeriodo) {

            $uibModal.open({
              component: 'creducModalSouCadastrado',
              modalInstance: null,
              backdrop: 'static',
              windowClass: 'my-modal',
              resolve: {
                message: {
                  title: r.data.Dados.Alerta,
                  localCpf: self.lead.CPF
                }
              }
            });

          } else {
            $state.go('instituicao-inscricao-dados-academicos', {
              instituicao: self.instituicao.SITE,
              candidato: self.lead,
              selected: self.selected,
              estados: self.estados || [],
              cidades: self.cidades || [],
              instituicoes: self.instituicoes || [],
              cursos: self.cursos || []
            });
          }

        }, function (e) {


          if (e.data.ExceptionMessage) {
            DialogService.error({
              message: e.data.ExceptionMessage
            });
          }
          else {
            DialogService.error({
              message: 'Não foi possível salvar os dados de inscrição. Tente novamente!'
            });
          }
        });

      }
      else {
        Lead
          .inscricao(lead)
          .then(promiseInscricaoSuccess, promiseInscricaoFallback);
      }
    };

    self.exibeRegulamento = function () {
      return exibeCampo("EXIGIR_ACEITE_REGULAMENTO");
    };

    function exibeCampo(parametro) {
      var exibe = false;
      if (localStorage.getItem("parametros") != undefined) {
        var parametros = JSON.parse(localStorage.getItem("parametros"))
        if (parametros != undefined) {

          var existe = $filter('filter')(parametros, { 'SLUG': parametro });
          if (parametros && existe.length > 0 && existe[0].VALOR == "S") {

            return true;
          }
        }
      }

      return exibe;
    }

    self.validarEmail = function () {


      self.submit();

    };

    // BUSCAR INSTITUIÇÕES
    self.BuscarInstituicoes = function (instituicao) {
      self.isLoading = false;
      self.disabled = false;

      if (instituicao.length == '') {
        self.isLoading = false;
        self.instiuicoes = [];
      }

      if (instituicao.length > 2) {
        self.isLoading = false;
        $API.get('api/cidade/GetFiltro?nome=' + instituicao).then(function (r) {
          self.instituicoes = r.data.ReturnData;
        }, function () {
        });
      }
    }


    // BUSCAR CIDADES
    self.BuscarCidade = function (nome) {
      self.isLoading = false;

      if (nome.length == '') {
        self.disabled = true;
        self.isLoading = false;
        self.cidades = [];
        self.instituicoes = [];
      }

      if (nome.length > 2) {
        self.disabled = false;
        self.isLoading = true;
        $API.get('api/cidade/GetFiltro?nome=' + nome).then(function (r) {
          self.isLoading = false;
          self.cidades = r.data.ReturnData;
        }, function () {
        });
      }
    };
    $scope.$watch($scope.customSelected, function () {


    }, true);
    function promiseEstadoSuccess(result) {
      self.estados = result.data.Dados;
      $scope.pegaIncricaoLocalEstado();
    }

    function promiseCidadeSuccess(result) {
      self.cidades = result.data.Dados;
      $scope.pegaIncricaoLocalCidade();
    }

    function promiseInstituicoesSuccess(result) {
      self.instituicoes = result.data.Dados;
      $scope.pegaIncricaoLocalInstituicao();
    }


    function distincArray(vet) {
      if (vet && vet.length) {
        var result = [];
        var aux;
        for (var i = 0; i < vet.length; i++) {
          aux = result.filter(function (p) {
            return p === vet[i];
          })[0];

          if (!aux) {
            result.push(vet[i]);
          }

        }

        return result;
      }
      return [];
    }

    function promiseCursosSuccess(result) {
      self.cursos = result.data.Dados;
      self.listaCursos = [];

      var auxList = self.cursos.map(function (p) {
        return p.MODALIDADE;
      });
      self.listaTipoGraduacao = distincArray(auxList);

      if (!self.selecionadoTipoGraduacao) {
        var auxFindGraduacao = self.listaTipoGraduacao.filter(function (p) {
          return p === 'Graduação'
        });
        auxFindGraduacao.length > 0 ? self.selecionadoTipoGraduacao = auxFindGraduacao[0] : self.selecionadoTipoGraduacao = self.listaTipoGraduacao[0];
      }

      if (self.listaTipoGraduacao.length > 1) {
        angular.forEach(self.cursos, function (e) {
          if (e && e.hasOwnProperty('ID_CAMPUS_CURSO') && e.ID_CAMPUS_CURSO && e.MODALIDADE === self.selecionadoTipoGraduacao) {
            self.listaCursos.push({
              ID_CAMPUS_CURSO: e.ID_CAMPUS_CURSO,
              ID_CAMPUS: e.ID_CAMPUS,
              DESCRICAO: '<u title=" ' + e.NOME + '">' + e.NOME + '</u> <span class="flags"><i>' + e.GRAU + '</i> <i>' + e.TIPO + '</i> <i>' + e.TURNO + '</i></span>',
              VALOR: e.VALOR,
              NOME: e.NOME
            });
          }
        });
      }
      else {
        angular.forEach(self.cursos, function (e) {
          if (e && e.hasOwnProperty('ID_CAMPUS_CURSO') && e.ID_CAMPUS_CURSO && e.MODALIDADE === self.selecionadoTipoGraduacao) {
            self.listaCursos.push({
              ID_CAMPUS_CURSO: e.ID_CAMPUS_CURSO,
              ID_CAMPUS: e.ID_CAMPUS,
              DESCRICAO: '<u>' + e.NOME + '</u> <span class="flags"><i>' + e.MODALIDADE + '</i> <i>' + e.GRAU + '</i> <i>' + e.TIPO + '</i> <i>' + e.TURNO + '</i></span>',
              VALOR: e.VALOR,
              NOME: e.NOME
            });
          }
        });
      }

      $scope.pegaIncricaoLocalCurso();
    }

    function promiseInscricaoSuccess(result) {
      if (result.data.CodigoResposta == 1) {
        var dialog = DialogService.success({
          title: 'Parabéns!',
          message: 'Sua inscrição foi realizada com sucesso!'
        });

        dialog.result.then(function () {
          self.selected = {};
          self.lead = {};
        });
      } else {
        DialogService.error({
          message: 'Não foi possível efetuar a inscrição. Tente novamente!'
        });
      }
    }

    function promiseInscricaoFallback() {
      DialogService.error({
        message: 'Não foi possível efetuar a inscrição. Tente novamente!'
      });
    }
    self.selecionarModalidade = function () {
      // //console.log(self.modalidade);
    }

    self.souCadastrado = function () {
      var modalInstance = $uibModal.open({
        component: 'creducModalSouCadastrado',
        modalInstance: null,
        backdrop: 'static',
        windowClass: 'my-modal',
        resolve: {
          message: {
            title: "Já sou cadastrado",
          }
        }
      });

      modalInstance.result.then(function (response) {
        // //console.log('saiu sou cadastrado, resultado = ' + response);
        if (response == true) {
          self.limparCursoInstituicao();
        }
      });
    };


    self.limparCursoInstituicao = function () {
      // self.selected.instituicao = '';
      // self.selected.curso = '';
    };


  }

})();

(function () {
  'use strict';

  angular
    .module('creduc.controllers')
    .controller('HeaderController', HeaderController);

  /** @ngInject */
  function HeaderController($state, $stateParams, PathService, Instituicao) {
    var self = this;
    self.showScript = false;
    var slug = window.location.pathname.split('/')[1];

    self.navbarIsOpened = false;

    self.isHotsite = function () {
      return !PathService.$isHotsite();
    }; 
    if (slug == "arnaldo") {
      self.showScript = true;
    }

    self.goHome = function () {
      
      
      if (PathService.$isHotsite()) {
        $state.go('instituicao', {
          instituicao: Instituicao.data().SITE
        });
      } else {
        $state.go('home');
      }
    };

    self.update = function (value) {
      self.navbarIsOpened = value;
      self.onUpdate({ value: self.navbarIsOpened });
    };
  }

})();

(function () {
  'use strict';

  var component = {
    templateUrl: 'app/components/header/header.html',
    controller: 'HeaderController',
    bindings: {
      onUpdate: '&'
    }
  };

  angular
    .module('creduc.components')
    .component('creducHeader', component);

})();

(function () {
  'use strict';

  angular
    .module('creduc.controllers')
    .controller('FooterController', FooterController);

  /** @ngInject */
  function FooterController (PathService,$scope) {
    var self = this;

    self.date = new Date();
    $scope.Escolha = false;
    if (localStorage.getItem("Escolha") == null) {
      $scope.Escolha = true;
    }

    self.showBrand = function () {
      return !PathService.$isHotsite();
    };
  }

})();

(function () {
  'use strict';

  var component = {
    templateUrl: 'app/components/footer/footer.html',
    controller: 'FooterController'
  };

  angular
    .module('creduc.components')
    .component('creducFooter', component);

})();

(function () {
  'use strict';

  angular
    .module('creduc.controllers')
    .service('PathService', PathService);

  /** @ngInject */
  function PathService(PATH_SETTINGS, $location, ENV) {
    var self = this;

    self.$stateParams = null;
    self.$absoluteUrl = $location.$$protocol + '://' + $location.$$host;

    if ($location.$$port && $location.$$port != 80) {
      self.$absoluteUrl += ':' + $location.$$port;
    }

    var PathService = {
      init: _init,
      $instituicao: _instituicao,
      $isHotsite: _isHotsite,
      STATIC_URL: _getStaticPath,
      ABSOLUTE_URL: _getAbsoluteUrl,
      ASSETS_URL: _getAssetsPath
    };

    return PathService;

    function _init($stateParams) {
      self.$stateParams = $stateParams;
      return PathService;
    }

    function _instituicao() {
      return self.$stateParams && 'instituicao' in self.$stateParams ? self.$stateParams.instituicao : null
    }

    function _isHotsite() {
      return 'instituicao' in self.$stateParams && Boolean(self.$stateParams.instituicao);
    }

    function _getStaticPath() {
      return PATH_SETTINGS[ENV].STATIC_URL;
    }

    function _getAbsoluteUrl() {
      return self.$absoluteUrl;
    }

    function _getAssetsPath() {
      return PATH_SETTINGS[ENV].ASSETS_URL;
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('creduc.services')
    .factory('Lead', LeadService);

  /** @ngInject */
  function LeadService($API) {
    var LeadService = {
      inscricao: _inscricao
    };

    return LeadService;

    function _inscricao(lead) {
      var params = lead;
      return $API.post('/candidato/add', params);
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('creduc.services')
    .factory('Instituicao', InstituicaoService);

  /** @ngInject */
  function InstituicaoService($API, PathService, $q) {
    var self = this
    var deferred = $q.defer();

    self.data = {};

    var InstituicaoService = {
      cidade: _cidade,
      cursos: _cursos,
      filter: {
        cidade: _filterCidade
      },
      get: _get,
      data: _getData,
      dataAsync: _getDataAsync,
      parametrosCampusAsync: _getParametrosCampusAsync
    };

    return InstituicaoService;

    function _cidade(id) {
      return $API.get('/campus/cidade/{id}'.replace('{id}', id));
    }

    function _cursos(id) {
      return $API.get('/campus/{id}/curso/'.replace('{id}', id));
    }

    function _filterCidade(idCampus, idCidade, cpf) {
      var url = '/campus/{idCampus}/cidade/{idCidade}/candidato/{cpf}';

      if (cpf == undefined) {
        cpf = "00000000000";
      }

      url = url.replace('{idCampus}', idCampus);
      url = url.replace('{cpf}', cpf);


      url = url.replace('{idCidade}', idCidade);

      return $API.get(url);
    }

    function _get(slug) {
      return $API
        .get('/campus/hotsite/{slug}'.replace('{slug}', slug))
        .then(function (result) {

          self.data = result.data.Dados;
          sessionStorage.instituicao = angular.toJson(self.data);

          return result;
        });
    }

    function _getParametrosCampusAsync(idCampus) {
      return $API
        .get('/campus/{idCampus}/parametros'.replace('{idCampus}', idCampus))
        .then(function (result) {
          return result.data.Dados;
        });
    }

    function _getData() {
      var data = angular.fromJson(sessionStorage.instituicao);
      return data;
    }

    function _getDataAsync() {
      var data = angular.fromJson(sessionStorage.instituicao);
      if (!data) {
        _get(PathService.$instituicao()).then(function (result) {
          data = result.data.Dados;
          deferred.resolve(data)
        });
      } else {
        deferred.resolve(data);
      }
      return deferred.promise;
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('creduc.services')
    .factory('Hotsite', HotsiteService);

  /** @ngInject */
  function HotsiteService($API) {
    var HotsiteService = {
      parceiros: _parceiros
    };

    return HotsiteService;

    function _parceiros() {
      return $API.get('/hotsite/parceiros');
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('creduc.services')
    .factory('HelperService', HelperService);

  /** @ngInject */
  function HelperService () {
    var HelperService = {
      deleteSelected: _deleteSelected,
      getSelectedValue: _getSelectedValue
    };

    return HelperService;

    function _deleteSelected(obj, key) {
      if (obj.hasOwnProperty(key) && obj[key] && Object.keys(obj[key]).length) {
        delete obj[key];
      }
    }

    function _getSelectedValue (obj, key, property, defaultValue) {
      if (typeof defaultValue === "undefined") {
        defaultValue = true;
      }

      if (obj.hasOwnProperty(key)) {
        if (defaultValue) {
          return typeof obj[key] == "string" ? obj[key] : obj[key][property];
        }
        return obj[key][property] || null;
      }

      return null;
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('creduc.services')
    .factory('Estado', EstadoService);

  /** @ngInject */
  function EstadoService($API) {
    var EstadoService = {
      all: _all,
      cidades: _cities,
      campus: {
        all: _campusEstados,
        cidades: _campusCidades
      }
    };

    return EstadoService;

    function _all() {
      return $API.get('/estado');
    }

    function _cities(id) {
      return $API.get('/cidades/{id}'.replace('{id}', id));
    }

    function _campusEstados(id) {
      return $API.get('/campus/{id}/estados'.replace('{id}', id));
    }

    function _campusCidades(idCampus, idEstado) {
      var url = '/campus/{idCampus}/estado/{idEstado}/cidades';
      url = url.replace('{idCampus}', idCampus);
      url = url.replace('{idEstado}', idEstado);
      return $API.get(url);
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('creduc.services')
    .factory('downloadService', DownloadService);

  /** @ngInject */
  function DownloadService () {
    var DownloadService = {
        download: downloadFile
    };

    return DownloadService;

    /**
     *  @params {object}: response
     *  @params {response.data}: dados do arquivo
     *  @params {response.filename}: nome do arquivo
     *  @params {response.format}: formato do arquivo
     *  @return {void}
     */
    function downloadFile(response) {
        var filename = response.filename;

        response.contentType = contentType(response.format);

        var byteCharacters = atob(response.data);
        var byteNumbers = new Array(byteCharacters.length);

        for (var i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        var byteArray = new Uint8Array(byteNumbers);
        var blob = new Blob([byteArray], { type: response.contentType });

        if (typeof window.navigator.msSaveBlob !== 'undefined') {
            window.navigator.msSaveBlob(blob, filename);
        } else {
            var URL = window.URL || window.webkitURL;
            var downloadUrl = URL.createObjectURL(blob);

            if (filename) {
                var a = document.createElement("a");
                if (typeof a.download === 'undefined') {
                    window.location = downloadUrl;
                } else {
                    a.href = downloadUrl;
                    a.download = filename;
                    document.body.appendChild(a);
                    a.click();
                }
            } else {
                window.location = downloadUrl;
            }

            setTimeout(function () { URL.revokeObjectURL(downloadUrl); }, 100);
        }
    }

    function contentType(format) {
        if (format == 'pdf') {
            return 'application/pdf';
        }

        if (format == 'xls') {
            return 'application/vnd.ms-excel';
        }

        if (format == 'docx') {
            return 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
        }
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('creduc.services')
    .factory('DialogService', DialogService);

  /** @ngInject */
  function DialogService($uibModal) {
    var defaultOptions = {
      modalInstance: null,
      component: 'creducModalDialogDefault',
      resolve: {
        message: {
          title: "Aviso!",
          message: ""
        }
      }
    };

    var DialogService = {
      dialog: _dialog,
      success: _success,
      error: _error,
      alert: _alert,
      progress: _progress
    };

    return DialogService;

    function _dialog(options) {
      options = options || {};

      var dialogInstance = $uibModal.open(angular.extend({}, defaultOptions, options));

      dialogInstance.result.then(function () {
        if (typeof defaultOptions.modalInstance === "object" && defaultOptions.modalInstance && typeof defaultOptions.modalInstance.close === "function") {
          defaultOptions.modalInstance.close();
        }
      });

      return dialogInstance;
    }

    function _progress(value, options) {
      var defaultOptions = {
        title: 'Enviando'
      };

      var message = angular.extend({}, defaultOptions, options);

      return _dialog({
        component: 'creducModalProgressBar',
        size: 'sm',
        backdrop: 'static',
        resolve: { message: message, percent: function () { return value; } }
      }, true);
    }

    function _alert(options) {
      var defaultOptions = {
        title: 'Aviso!',
        message: 'Operação concluída com sucesso!',
        status: true
      };

      var message = angular.extend({}, defaultOptions, options);

      return _dialog({
        size: 'sm',
        backdrop: 'static',
        resolve: { message: message }
      }, true);
    }

    function _success(options) {
      var defaultOptions = {
        title: 'Sucesso!',
        message: 'Operação concluída com sucesso!',
        status: true
      };

      var message = angular.extend({}, defaultOptions, options);

      return _dialog({
        component: 'creducModalDialog',
        size: 'sm',
        backdrop: 'static',
        resolve: { message: message }
      }, true);
    }

    function _error(options) {
      var defaultOptions = {
        title: 'Ops!',
        message: 'Ocorreu um erro ao tentar realizar a operação.',
        status: false
      };

      var message = angular.extend({}, defaultOptions, options);

      return _dialog({
        component: 'creducModalDialog',
        size: 'sm',
        backdrop: 'static',
        resolve: { message: message }
      }, true);
    }



  }

})();

(function () {
  'use strict';

  angular
    .module('creduc.services')
    .factory('CpfService', CpfService);

  /** @ngInject */
  function CpfService() {
    var CpfService = {
      validate: _validate
    };
    
    return CpfService;

    function calcCheck(digits) {
      var sum = null;
      
      if (digits.length == 9) {
        for (var j = 0; j < 9; ++j) {
          sum += digits.toString().charAt(j) * (10 - j);
        }

        var lastSumChecker1 = sum % 11;
        
        return lastSumChecker1 < 2 ? 0 : 11 - lastSumChecker1;
      } else if (digits.length == 10) {
        for (var k = 0; k < 10; ++k) {
          sum += digits.toString().charAt(k) * (11 - k);
        }

        var lastSumChecker2 = sum % 11;

        return lastSumChecker2 < 2 ? 0 : 11 - lastSumChecker2;
      } else {
        throw '[CPF] Error!';
      }
    }

    function _validate(cpf) {
      if (typeof cpf !== "string" && cpf.length !== 11) {
        return false;
      }
     
      var cleanCPF = cpf.replace(".", "").replace(".", "").replace("-", "");
      var digits = cleanCPF.substring(0, 9);
      var checker = cleanCPF.substring(9, 11);

      //console.log(cleanCPF);
      //console.log(digits);
      //console.log(checker);


      if (cleanCPF.length !== 11) {
        return false;
      }

      for (var i = 0; i < 10; i++) {
        if ('' + digits + checker === Array(12).join(i)) {
          return false;
        }
      }

      var checker1 = calcCheck(digits);
      var checker2 = calcCheck(digits + '' + checker1);
     // //console.log(checker.toString() === checker1.toString() + checker2.toString());
      return checker.toString() === checker1.toString() + checker2.toString();
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('creduc.services')
    .factory('ContatoService', ContatoService);

  /** @ngInject */
  function ContatoService ($API) {
    var ContatoService = {
      faleConosco: _faleConosco,
      getContactInfos: _getContactInfos,
      queroSerParceiro: _queroSerParceiro
    };

    return ContatoService;

    function _faleConosco (dados) {
      var params = dados;
      return $API.post('/contato/fale-conosco', params);
    }

    function _queroSerParceiro (dados) {
      var params = dados;
      return $API.post('/contato/quero-ser-parceiro', params);
    }
    function _getContactInfos (slug) {
      return $API.get('/site/'+slug+'/contato/fale-conosco/' , "");
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('creduc.services')
    .factory('$API', ApiService);

  /** @ngInject */
  function ApiService($http, API_SETTINGS, ENV, Upload) {
    var ApiService = {
      get: _get,
      post: _post,
      upload: _upload,
      postUpload: _postUpload,
      parseUrl: _parseUrl
    };

    return ApiService;

    function _get(url, data, headers) {
      var config = getHeaders(headers);
      if (data) {
        config.data = data;
      }
     // //console.log('fdfd')
       
      return $http.get(getAbsoluteUrl(url), config);
    }

    function _post(url, data, headers) {
      return $http.post(getAbsoluteUrl(url), data, getHeaders(headers));
    }

    function _upload(url, data, absoluteUrl) {
      absoluteUrl = typeof absoluteUrl === "undefined" ? true : absoluteUrl;
      url = absoluteUrl ? getAbsoluteUrl(url) : url;

      return Upload.upload({
        url: url,
        data: data || null
      });
    }

    function _postUpload(url, data, absoluteUrl) {
      absoluteUrl = typeof absoluteUrl === "undefined" ? true : absoluteUrl;
      url = absoluteUrl ? getAbsoluteUrl(url) : url;

      return Upload.upload({
        url: url,
        data: {
          file: data,
          data: Upload.json(data)
        }
      });
    }

    function _parseUrl(url) {
      // TODO
      return url;
    }

    function getAbsoluteUrl(url) {
     
      if (url.substring(0, 3) == "api") {
        return API_SETTINGS[ENV].BASE_API_CREDUC + url;
      } else if (url.substring(0, 4) == "http")  {
        return  url;
      } else {
        return API_SETTINGS[ENV].BASE_URL + url;
      }
    }

    function getHeaders(headers) {
      return headers || {
        headers: { 'Content-Type': 'application/json' },
        cache: false
      };
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('creduc.directives')
    .directive('validatePhone', ValidatePhoneDirective);

  /** @ngInject */
  function ValidatePhoneDirective($filter) {
    var ValidatePhoneDirective = {
      restrict: "A",
      require: 'ngModel',
      link: function ($scope, $elem, $attrs, $ctrl) {

        $elem.on('keyup', function () {
          var value = ($elem[0].value || "").toString().replace(/[^\d]/g, '');
          $elem.val($filter('phone')(value));
        });

        $elem.on('blur', function () {
          var value = $elem[0].value.toString().replace(/[^\d]/g, '');
          $elem.val($filter('phone')(value));
        });

        $ctrl.$validators.phone = function _validatePhone(modelValue, viewValue) {
          var modelLength = viewValue && viewValue.toString().replace(/[^\d]/g, '').length;

          if (modelLength < 10 || modelLength > 11) {
            return false;
          }

          return true;
        };

        $ctrl.$formatters.unshift(function () {
          return $filter('phone')($ctrl.$modelValue);
        });

        $ctrl.$parsers.unshift(function (viewValue) {
          var plainValue = viewValue && viewValue.replace(/[^\d]/g, '').slice(0, 11);
          return plainValue;
        });
      }
    };

    return ValidatePhoneDirective;
  }

})();

(function () {
  'use strict';

  angular
    .module('creduc.directives')
    .directive('validateDdd', ValidateDDDDirective);

  /** @ngInject */
  function ValidateDDDDirective() {
    var ValidateDDDDirective = {
      require: 'ngModel',
      link: function (scope, e, attrs, ctrl){
        ctrl.$validators.ddd = _validateDDD;

        function _validateDDD (modelValue) {
          modelValue = modelValue || "";

          if (modelValue.length < 10) {
            return false;
          }

          return true;
        }
      }
    };

    return ValidateDDDDirective;
  }

})();

(function () {
  'use strict';

  angular
    .module('creduc.directives')
    .directive('validateCpf', ValidateCpfDirective);

  /** @ngInject */
  function ValidateCpfDirective(CpfService, $filter) {
    var ValidateCpfDirective = {
      restrict: "A",
      require: 'ngModel',
      link: function ($scope, $elem, $attrs, $ctrl) {
       
        
        

        $elem.on('keyup', function () {
          var value = ($elem[0].value || "").toString().replace(".", "").replace(".", "").replace("-", "");
          $elem.val($filter('cpf')(value));
        });

        $elem.on('blur', function () {
           
          var value = $elem[0].value.toString().replace(".", "").replace(".", "").replace("-", "");
          $elem.val($filter('cpf')(value));
        });

        $ctrl.$validators.cpf = function _validateCpf(modelValue, viewValue) {
         
          var modelLength = viewValue && viewValue.toString().replace(".", "").replace(".", "").replace("-", "").length;
          
          if (modelLength != 11) {
            return false;
          }
       
          return CpfService.validate(modelValue);
        };

        $ctrl.$formatters.unshift(function () {
          
          return $filter('cpf')($ctrl.$modelValue);
        });

        $ctrl.$parsers.unshift(function (viewValue) {
          var plainValue = viewValue && viewValue.replace(".", "").replace(".", "").replace("-", "").slice(0, 11);
          return plainValue;
        });

        $scope.$watch($attrs['ngModel'], function (newValue, oldValue) {
          newValue = newValue || "";

          var value = newValue && newValue.toString().replace(".", "").replace(".", "").replace("-", "");
          if (value.length >= 11) {
            newValue = oldValue;
          }
          return newValue;
        });
      }
    };

    return ValidateCpfDirective;
  }

})();

(function () {
  'use strict';

  angular
    .module('creduc.directives')
    .directive('validateBirth', ValidateBirthDirective);

  /** @ngInject */
  function ValidateBirthDirective(DialogService) {
    var ValidateBirthDirective = {
      require: 'ngModel',
      link: function (scope, e, attrs, ctrl) {
        ctrl.$validators.validateBirth = _validateBirth;

        function _validateBirth(modelValue, viewValue) {
          if (viewValue && viewValue.toString().length != 10) {
            return false;
          }

          if (modelValue && attrs.hasOwnProperty('ageMin') && getIdade(modelValue) < attrs.ageMin) {
            DialogService.alert({
              message: 'A idade do candidato não pode ser menor que ' + attrs.ageMin + ' anos de idade.'
            });
            return false;
          }

          if (modelValue && attrs.hasOwnProperty('ageMax') && getIdade(modelValue) > attrs.ageMax) {
            DialogService.alert({
              message: 'A idade do candidato não pode ser maior que ' + attrs.ageMax + ' anos de idade.'
            });
            return false;
          }

          return true;
        }
      }
    };

    return ValidateBirthDirective;
  }

  function getIdade(dtNascimento) {
    var birth = new Date(dtNascimento) || null;

    if (!birth) {
      return 0
    }

    var d = new Date(),
      currentMonth = d.getMonth() + 1,
      currentDay = d.getDate(),

      birthMonth = birth.getMonth() + 1,
      birthDay = birth.getDate(),

      age = d.getFullYear() - birth.getFullYear();

    if (currentMonth < birthMonth || (currentMonth == birthMonth && currentDay < birthDay)) {
      age--;
    }

    return age < 0 ? 0 : age;
  }

})();

//(function () {

//  'use strict';

//  angular
//    .module('creduc.directives')
//    .directive('numberOnly', function () {
//      return {
//        restrict: 'A',
//        require: 'ngModel',
//        link: function (scope, element, attrs, ngModel) {
//          var negativo = '/\-/'.test(attrs.numberOnly);
//          var decimal = /\.|\,/.test(attrs.numberOnly) ? /\.|\,/.exec(attrs.numberOnly)[0] : null;

//          var regExp = '^';
//          regExp += negativo ? '[\\-]{0,1}' : '';
//          regExp += '[\\d]+';
//          if (decimal != null) {
//            regExp += '[\\' + decimal + '][\\d]+|';
//            if (negativo) {
//              regExp += '[\\-]{0,1}'
//            }
//            regExp += '[\\d]+'
//          }
//          regExp += '';
//          regExp = new RegExp(regExp);

//          ngModel.$parsers.unshift(function (input) {
//            if (input === undefined) return null;
//            if (input === null) return;

//            input = input.toString().replace(/\./, decimal);
//            if (input == '-') return input;
//            if (decimal !== null && input.charAt(input.length - 1) == decimal) return input;

//            input = regExp.test(input) ? regExp.exec(input)[0] : null;

//            var viewVal = null;

//            if (input !== null) {
//              input = decimal != null ? parseFloat(input.replace(/\,/, '.')) : parseInt(input);
//            }

//            viewVal = isNaN(input) || input === null ? '' : input;

//            ngModel.$setViewValue(decimal != null ? viewVal.toString().replace(/\./, decimal) : viewVal.toString());
//            ngModel.$render();

//            return isNaN(input) ? null : input;
//          });

//          ngModel.$formatters.unshift(function (value) {
//            if (value !== undefined && value !== null) {
//              return decimal != null ? value.toString().replace(/\./, decimal) : value.toString();
//            }
//          });
//        }
//      }
//    });

//})();

(function () {

  'use strict';

  angular
    .module('creduc.directives')
    .directive('checkCpf', checkCpf);


  /** @ngInject */
  function checkCpf($q, $API, $location, Instituicao, DialogService, $uibModal) {
    var dialogoSouCadastrado = null;
    return {
      require: 'ngModel',
      link: function (scope, e, attrs, ctrl) {
        ctrl.$asyncValidators.checkCpf = _checkCpf;

        function _checkCpf(modelValue) {
          if (modelValue.length != 11) {
            return $q.reject();
          }
          var params = $location.search();
          var def = $q.defer();
          if (params.cc == null || params.cc == undefined) {

            var url = '/instituicao/{idCampus}/candidato/{cpf}/pendencias';
            url = url.replace('{idCampus}', Instituicao.data().ID_CAMPUS);
            url = url.replace('{cpf}', modelValue);

            $API.get(url).then(function (result) {
              if (result.data.Dados.length == 0) {
                def.resolve();
              } else {
                if (!dialogoSouCadastrado) {
                  dialogoSouCadastrado = $uibModal.open({
                    component: 'creducModalSouCadastrado',
                    backdrop: 'static',
                    windowClass: 'my-modal',
                    resolve: {
                      message: {
                        localCpf: modelValue,
                        listDados: result.data.Dados,
                        title: "Já sou cadastrado",
                      }
                    }
                  });
                }
                dialogoSouCadastrado.result.then(function(response){
                  dialogoSouCadastrado = null;
                  if(response == true ){
                    def.resolve();
                  }
                });
              }
            });
          }
          return def.promise;
        }
      }
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('creduc.filters')
    .filter('static_url', UrlFilter);

  /** @ngInject */
  function UrlFilter(PathService) {
    function Url(endpoint) {
      var url = PathService.STATIC_URL();

      url += '/' + endpoint;

      return url;
    }

    return Url;
  }

})();

(function () {
  'use strict';

  angular
    .module('creduc.filters')
    .filter('assets_url', UrlFilter);

  /** @ngInject */
  function UrlFilter(PathService) {
    function Url(endpoint) {
      var url = PathService.ASSETS_URL();

      url += '/' + endpoint;

      return url;
    }

    return Url;
  }

})();

(function () {
  'use strict';

  String.prototype.startWith = function (str) {
    return this.indexOf(str) == 0;
  };

  angular
    .module('creduc.filters')
    .filter('absolute_url', UrlFilter);

  /** @ngInject */
  function UrlFilter(PathService) {
    function Url(endpoint) {
      var url = PathService.ABSOLUTE_URL();

      if (PathService.$isHotsite()) {
        url += '/' + PathService.$instituicao();
      }

      if (!endpoint.startWith('#')) {
        url += '/'
      }

      url += endpoint;

      return url;
    }


    return Url;
  }

})();

(function () {
  'use strict';

  angular
    .module('creduc.filters')
    .filter('phone', PhoneFilter);

  /** @ngInject */
  function PhoneFilter() {
    function Phone(value) {
      if (!value) {
        return "";
      }

      var n = (value || "").toString().replace(/[^\d]/g, '').slice(0,11);
      var nLength = n && n.toString().length;

      if (nLength < 2) {
        n = n.replace(/^(\d{1,2})$/, '$1');
      } else if (nLength == 2) {
        n = n.replace(/^(\d{1,2})$/, '($1)');
      } else if (nLength > 2 && nLength <= 6) {
        n = n.replace(/^(\d{2})(\d{1,4})$/, '($1) $2');
      } else if (nLength > 6 && nLength <= 10) {
          n = n.replace(/^(\d{2})(\d{4})(\d{1,4})$/, '($1) $2-$3');
      } else {
        n = n.replace(/^(\d{2})(\d{5})(\d{1,4})$/, '($1) $2-$3');
      }

      return n;
    }

    return Phone;
  }

})();

(function () {
  'use strict';

  angular
    .module('creduc.filters')
    .filter('olength', OlengthFilter);

  /** @ngInject */
  function OlengthFilter() {
    function Olength(value) {
      if (typeof value === "object") {
        return Object.keys(value).length;
      }

      return 0;
    }

    return Olength;
  }

})();

(function () {
  'use strict';

  angular
    .module('creduc.filters')
    .filter('cpf', CpfFilter);

  /** @ngInject */
  function CpfFilter() {
    function Cpf(value) {
      if (!value) {
        return '';
      }

      var cpf = (value || "").toString().replace(/[^\d]/g, '').slice(0,11);
      var cpfLength = cpf && cpf.toString().length;

      if (cpf && cpfLength > 3 && cpfLength <= 6) {
        cpf = cpf.replace(/^(\d{3})(\d{1,3})$/, "$1.$2");
      } else if (cpf && cpfLength > 6 && cpfLength <= 9) {
        cpf = cpf.replace(/^(\d{3})(\d{3})(\d{1,3})$/, "$1.$2.$3");
      } else if (cpf && cpfLength > 9 && cpfLength <= 11) {
        cpf = cpf.replace(/^(\d{3})(\d{3})(\d{3})(\d{1,2})$/, "$1.$2.$3-$4");
      } else {
        cpf = cpf.replace(/^(\d{3})(\d{3})(\d{3})(\d{1,2})$/, "$1.$2.$3-$4");
      }

      return cpf;
    }

    return Cpf;
  }

})();

(function () {
  'use strict';

  angular
    .module('creduc.controllers')
    .controller('SimuladorController', SimuladorController);

  /** @ngInject */
  function SimuladorController($stateParams, $state, $filter, $API, Instituicao, HelperService, DialogService, $scope, PathService, Estado) {
    var self = this;
    self.dataParcelas = null;
    self.$onInit = function () {

      self.modalidade = "G";
      self.mostrarMensagemErro = false;
      self.rangeMin = 0;
      self.valorMensalidadeDesejada = null;
      self.valorMensalidadeDepois = null;
      self.porcentagemParcela = null;
      self.valorMensalidade = null;
      self.qtdeSemestresParcelamento = 8;
      self.semestreInicio = "1";
      self.qtdeMesesPosGraduacao = 24;
      self.listaTipoModalidade = [];
      self.percMaximo = null;
      self.travarSimulador = 'N';
      self.valorMinimoPorcentagem = null;
      self.arrayParcelasDurante = [];
      self.arrayParcelasDepois = [];
      self.listaSemestres = [];

      self.IdCampusSelecionado = null;
      self.instituicao = {};
      self.instituicoes = [];
      self.estados = [];
      self.cidades = [];
      self.selected = {};
      self.selected1 = {};
      self.cursos = [];
      self.listaCursos = [];
      self.listaTipoGraduacao = ['Graduação'];
      self.selecionadoTipoGraduacao = '';
      self.$isHotsite = PathService.$isHotsite;
      self.selecionadoTipoGraduacao = '';

      self.listValorPagar = [];
      self.isSolicitaCurso = 'N';
      self.resultadoEmReais = null;
      self.teste = null;


      Instituicao.dataAsync().then(function (data) {
        self.instituicao = data;
        Estado.campus.all(self.instituicao.ID_CAMPUS).then(promiseEstadoSuccess);
      });

      //Estado.campus.all(self.instituicao.ID_CAMPUS).then(promiseEstadoSuccess);


      //Carrega os tipos de modalidade da instituicao (Graduação e Pos-Graduação)
      var hotsite = $stateParams.instituicao;
      // //console.log(self.instituicao.ID_CAMPUS)
      $API.get('api/campus/BuscarModalidade?hotsite=' + hotsite).then(function (r) {
        self.listaTipoModalidade = r.data.ReturnData;
        var auxModalidade = self.listaTipoModalidade.find(function (p) { return p.FlModalidade == 'G' });
        self.modalidade = auxModalidade ? 'G' : 'P';
        self.selecionarModalidade();
        // //console.log(r.data.ReturnData);
      }, function () {
      });
    }


    self.getInstituicoesCreduc = function ($item) {
      if (!$item) {
        return false;
      }
      $scope.gravaIncricaoCidadeLocal($item);
      HelperService.deleteSelected(self.selected, 'instituicao');

      if ($item && $item.ID_CIDADE) {
        Instituicao.filter.cidade(null, $item.ID_CIDADE, null).then(promiseInstituicoesSuccess);
      }
    };


    $scope.gravaSelectedCurso = function (curso) {
      self.valorMensalidade = curso.VALOR;
      self.porcentagemParcela = null;
      self.valorMensalidadeDesejada = null;
      self.resultadoEmReais = null;
      // //console.log('selecionou curso');
    }

    self.getInstituicoes = function ($item, $item2) {
      console.log('here 2');
      //HelperService.deleteSelected(self.selected, 'instituicao');
      //HelperService.deleteSelected(self.selected, 'curso');
      //HelperService.deleteSelected(self, 'instituicoes');
      //HelperService.deleteSelected(self, 'listaCursos');
      // var CPF = null;

      // if (self.lead && self.lead.CPF) {
      //     CPF = self.lead.CPF.replace(".", "").replace(".", "").replace("-", "");
      // }

      if (!$item) {
        return false;
      }

      //var json = '{ "ID_CIDADE":"' + $item.ID_CIDADE + '" , "Nome":"' + $item.NOME_CIDADE + '" , "Uf":"' + $item2.UF + '" }';
      //$API.post('api/Campus/BuscarPorUfCidadeCampus/?idCampus=' + self.instituicao.ID_CAMPUS, json).then(function (r) {
      //    self.instituicoes = r.data.ReturnData;
      //}, function () {
      //});


      $API.post('/campus/{idCampus}/ufCpf/?idCampus=' + self.instituicao.ID_CAMPUS + '&uf=' + $item2.UF, $item).then(function (r) {
        self.instituicoes = r.data.Dados.Result;
        self.listaTipoGraduacao = ['Graduação'];
        self.selecionadoTipoGraduacao = '';
      }, function () {
      });
      //console.log($scope.campi);
      //$scope.gravaIncricaoCidadeLocal($item);
      //Instituicao.filter.cidade(self.instituicao.ID_CAMPUS, $item.ID_CIDADE, CPF).then(promiseInstituicoesSuccess);
      //console.log(self.instituicoes);

    };

    self.getCursos = function ($item) {
      HelperService.deleteSelected(self.selected, 'curso');

      self.selecionarModalidade();

      if (!$item || !$item.hasOwnProperty('ID_CAMPUS')) {
        return false;
      }
      //$scope.gravaIncricaoInstituicaoLocal($item);

      if (!PathService.$isHotsite() && $item.hasOwnProperty('SLUG') && $item.SLUG) {
        DialogService.alert({
          message: 'Você está sendo redirecionado para o hotsite da instituição: <br><b>' + $item.CAMPUS + '</b>'
        });

        $state.go('instituicao', {
          instituicao: $item.SLUG
        });
      }

      if ($item && $item.hasOwnProperty('ID_CAMPUS') && $item.ID_CAMPUS) {
        Instituicao.cursos($item.ID_CAMPUS).then(promiseCursosSuccess);
      }
      self.IdCampusSelecionado = $item.ID_CAMPUS;
    };

    function promiseEstadoSuccess(result) {
      self.estados = result.data.Dados;
      //$scope.pegaIncricaoLocalEstado();
    }
    function promiseCidadeSuccess(result) {
      self.cidades = result.data.Dados;
      //$scope.pegaIncricaoLocalCidade();
    }
    function promiseInstituicoesSuccess(result) {
      self.instituicoes = result.data.Dados;
      $scope.pegaIncricaoLocalInstituicao();
    }
    function promiseCursosSuccess(result) {
      self.cursos = result.data.Dados;
      self.listaCursos = [];

      var auxList = self.cursos.map(function (p) {
        return p.MODALIDADE;
      });
      self.listaTipoGraduacao = distincArray(auxList);

      if (!self.selecionadoTipoGraduacao) {
        var auxFindGraduacao = self.listaTipoGraduacao.filter(function (p) {
          return p === 'Graduação'
        });
        auxFindGraduacao.length > 0 ? self.selecionadoTipoGraduacao = auxFindGraduacao[0] : self.selecionadoTipoGraduacao = self.listaTipoGraduacao[0];
      }

      if (self.listaTipoGraduacao.length > 1) {
        angular.forEach(self.cursos, function (e) {
          if (e && e.hasOwnProperty('ID_CAMPUS_CURSO') && e.ID_CAMPUS_CURSO && e.MODALIDADE === self.selecionadoTipoGraduacao) {
            self.listaCursos.push({
              ID_CAMPUS_CURSO: e.ID_CAMPUS_CURSO,
              ID_CAMPUS: e.ID_CAMPUS,
              DESCRICAO: '<u title=" ' + e.NOME + '">' + e.NOME + '</u> <span class="flags"><i>' + e.GRAU + '</i> <i>' + e.TIPO + '</i> <i>' + e.TURNO + '</i></span>',
              VALOR: e.VALOR,
              NOME: e.NOME
            });
          }
        });
      }
      else {
        angular.forEach(self.cursos, function (e) {
          if (e && e.hasOwnProperty('ID_CAMPUS_CURSO') && e.ID_CAMPUS_CURSO && e.MODALIDADE === self.selecionadoTipoGraduacao) {
            self.listaCursos.push({
              ID_CAMPUS_CURSO: e.ID_CAMPUS_CURSO,
              ID_CAMPUS: e.ID_CAMPUS,
              DESCRICAO: '<u>' + e.NOME + '</u> <span class="flags"><i>' + e.MODALIDADE + '</i> <i>' + e.GRAU + '</i> <i>' + e.TIPO + '</i> <i>' + e.TURNO + '</i></span>',
              VALOR: e.VALOR,
              NOME: e.NOME
            });
          }
        });
      }

      //$scope.pegaIncricaoLocalCurso();


      var hotsite = $stateParams.instituicao;
      $API.get('api/campus/BuscarModalidade?hotsite=' + hotsite + '&idCampus=' + self.IdCampusSelecionado).then(function (r) {
        self.listaTipoModalidade = r.data.ReturnData;
        var auxModalidade = self.listaTipoModalidade.find(function (p) { return p.FlModalidade == 'G' });
        self.modalidade = auxModalidade ? 'G' : 'P';
        self.selecionarModalidade();
        // //console.log(r.data.ReturnData);
      }, function () {
      });
    }



    function distincArray(vet) {
      if (vet && vet.length) {
        var result = [];
        var aux;
        for (var i = 0; i < vet.length; i++) {
          aux = result.find(function (p) {
            return p === vet[i];
          });
          if (!aux) {
            result.push(vet[i]);
          }
        }
        return result;
      }
      return [];
    }

    self.getCidades = function (estado) {
      if (!estado) {
        return false;
      }

      // $scope.gravaIncricaoEstadoLocal(estado, inicio);

      HelperService.deleteSelected(self.selected, 'cidade');
      HelperService.deleteSelected(self.selected, 'instituicao');
      HelperService.deleteSelected(self.selected, 'curso');
      HelperService.deleteSelected(self, 'cidades');
      HelperService.deleteSelected(self, 'instituicoes');
      HelperService.deleteSelected(self, 'listaCursos');

      self.listaTipoGraduacao = ['Graduação'];
      self.selecionadoTipoGraduacao = '';

      if (PathService.$isHotsite()) {
        Estado.campus.cidades(self.instituicao.ID_CAMPUS, estado.ID_ESTADO).then(promiseCidadeSuccess);
      } else {
        Estado.cidades(estado.ID_ESTADO).then(promiseCidadeSuccess);
      }

    };

    self.containsGraducaoPos = function (str) {
      if (self.listaTipoModalidade) {
        var result = self.listaTipoModalidade.find(function (p) { return p.FlModalidade == str }) ? true : false;
        return result;
      }
    }

    self.selecionarModalidade = function () {

      self.valorMensalidadeDesejada = null;
      self.valorMensalidade = null;
      self.porcentagemParcela = null;
      self.valorMinimoPorcentagem = null;
      self.resultadoEmReais = null;

      //Essa parte verifica qual modo esta sendo selecionado do back!!
      if (self.listaTipoModalidade && self.listaTipoModalidade.length > 0) {
        self.isSolicitaCurso = self.listaTipoModalidade.find(function (p) { return p.SolicitarCurso === 'S' }) ? 'S' : 'N';
      }

      if (self.selecionadoTipoGraduacao && self.isSolicitaCurso == 'S') {
        // //console.log(self.selecionadoTipoGraduacao);
        // //console.log(self.modalidade);
        self.modalidade = self.selecionadoTipoGraduacao === 'Pós-Graduação' ? 'P' : 'G';
      }

      if (self.modalidade == 'G') {
        var auxModalidade = self.listaTipoModalidade.find(function (p) { return p.FlModalidade == 'G' });
        self.listValorPagar = auxModalidade.ListPecentual ? auxModalidade.ListPecentual : [];
        // //console.log(self.listValorPagar);
        if (auxModalidade && auxModalidade.TravarSimulador && auxModalidade.PercMaximo && auxModalidade.TravarSimulador == 'S') {
          self.travarSimulador = auxModalidade.TravarSimulador;
          self.percMaximo = auxModalidade.PercMaximo;
        }
        else {
          self.travarSimulador = 'N';
          self.percMaximo = null;
        }
      }

      if (self.modalidade == 'P') {
        var auxModalidade2 = self.listaTipoModalidade.find(function (p) { return p.FlModalidade == 'P' });
        self.listValorPagar = auxModalidade2.ListPecentual ? auxModalidade2.ListPecentual : [];
        // //console.log(self.listValorPagar);
        if (auxModalidade2 && auxModalidade2.TravarSimulador && auxModalidade2.PercMaximo && auxModalidade2.TravarSimulador == 'S') {
          self.travarSimulador = auxModalidade2.TravarSimulador;
          self.percMaximo = auxModalidade2.PercMaximo;
        }
        else {
          self.travarSimulador = 'N';
          self.percMaximo = null;
        }
      }

    }

    // CALCULAR A PORCENTAGEM DO PARCELAMENTO
    self.calcularPorcentagem = function () {
      self.valorMensalidadeDepois = self.valorMensalidade - self.valorMensalidadeDesejada;

      self.mostrarMensagemErro = false;

      var porcentagemParcelaAux = ((self.valorMensalidadeDesejada * 100) / self.valorMensalidade).toFixed(2);
      self.porcentagemParcela = (100 - porcentagemParcelaAux).toFixed(2);

      self.mostrarMensagemErro = false;

      if (self.porcentagemParcela < 0) {
        self.porcentagemParcela = 0;
        self.mostrarMensagemErro = true;
      }


      //Verifica se tem restricao e tem valor especificado de restricao e valor desejado não bater,
      if (self.percMaximo && self.valorMensalidadeDesejada && self.porcentagemParcela > self.percMaximo) {
        self.valorMinimoPorcentagem = self.valorMensalidade * (100 - self.percMaximo) / 100;
      }
      else {
        self.valorMinimoPorcentagem = null;

        if (self.valorMensalidade == '' || self.valorMensalidadeDesejada == '' || self.valorMensalidadeDesejada == null) {
          self.porcentagemParcela = 0;
        }

        if (self.porcentagemParcela != 0 && self.modalidade == "G") {
          self.replicarSemestres();
        }

        if (self.porcentagemParcela != 0 && self.modalidade == "P") {
          self.replicarMeses();
        }
      }

    }


    self.atualizaResultadoPagamentoMes = function () {
      if (!self.porcentagemParcela) {
        self.valorMensalidadeDesejada = null;
        self.resultadoEmReais = null;
        self.porcentagemParcela = 0;
        return;
      }
      self.valorMensalidadeDesejada = (100 - self.porcentagemParcela) / 100 * self.valorMensalidade;
      self.atualizaValorDesejadoEmRelacaoPorcentagem();
    }

    self.atualizaValorDesejadoEmRelacaoPorcentagem = function () {
      self.resultadoEmReais = self.porcentagemParcela / 100 * self.valorMensalidade;
      if (self.porcentagemParcela != 0 && self.modalidade == "G") {
        self.replicarSemestres();
      }

      if (self.porcentagemParcela != 0 && self.modalidade == "P") {
        self.replicarMeses();
      }

      self.valorMensalidadeDepois = self.valorMensalidade - self.valorMensalidadeDesejada;
      // self.calcularPorcentagem();
    }



    // REPLICAR MESES PÓS GRADUAÇÃO
    self.replicarMeses = function () {

      self.modalidade = 'P';

      var qtdeMeses = self.qtdeMesesPosGraduacao * 2;

      $API.get('/hotsite/GetDatas/?semestreInicio=' + self.semestreInicio + '&parcelas=' + qtdeMeses + '&valorMensalidade=' + self.valorMensalidade + '&valorPago=' + self.valorMensalidadeDesejada).then(function (r) {
        self.dataParcelas = r.data;

        self.modalidade = 'P';

        self.valorTotalDurante = self.valorMensalidadeDesejada * self.dataParcelas.Durante.length;
        self.valorTotalDepois = (self.valorMensalidade - self.valorMensalidadeDesejada) * self.dataParcelas.Durante.length

        self.valorTotal = self.valorTotalDurante + self.valorTotalDepois;


      });
    }

    // REPLICAR SEMESTRES GRADUAÇÃO
    self.replicarSemestres = function () {



      self.modalidade = "G"

      var qtdeMeses = (self.qtdeSemestresParcelamento * 6) * 2;

      self.listaSemestres = [];
      $API.get('/hotsite/GetDatas/?semestreInicio=' + self.semestreInicio + '&parcelas=' + qtdeMeses + '&valorMensalidade=' + self.valorMensalidade + '&valorPago=' + self.valorMensalidadeDesejada).then(function (r) {
        if (r.data) {
          self.listaSemestres = [];
          self.dataParcelas = r.data;

          self.valorTotalDurante = self.valorMensalidadeDesejada * self.dataParcelas.Durante.length;
          self.valorTotalDepois = (self.valorMensalidade - self.valorMensalidadeDesejada) * self.dataParcelas.Durante.length

          self.valorTotal = self.valorTotalDurante + self.valorTotalDepois;


          var posicao = 0;


          for (var i = 0; i < self.qtdeSemestresParcelamento; i++) {
            self.arrayParcelasDurante = [];
            self.arrayParcelasDepois = [];


            var semestre = i + 1;

            for (var j = 0; j < 6; j++) {


              self.parcelasDurante = self.dataParcelas.Durante[posicao]
              self.parcelasDepois = self.dataParcelas.Depois[posicao]

              self.arrayParcelasDurante.push(self.parcelasDurante)
              self.arrayParcelasDepois.push(self.parcelasDepois)

              posicao++

            }

            self.dadosSemestre = {
              semestre: semestre,
              parcelasDurante: angular.copy(self.arrayParcelasDurante),
              parcelasDepois: angular.copy(self.arrayParcelasDepois)
            }



            self.listaSemestres.push(self.dadosSemestre)

            self.dadosSemestre = null
          }




        }

        //console.log(self.listaSemestres)

      });



      //self.qtdeMesesSemestre = self.qtdeSemestresParcelamento * 6;
      //self.qtdeMesesParcelamento = self.qtdeSemestresParcelamento * 12;


    }

    self.imprimirSimulacao = function () {

      //var pdf = new jsPDF();
      //pdf.fromHTML(document.getElementById("simulacao"), 5, 0, { 'width': 1900 });


      ////pdf.addImage(img, 'JPEG', 15, 10, 180, 0);
      //pdf.autoPrint();
      //window.open(pdf.output('bloburl'), '_blank');

      //document.getElementById('ocultarAoImprimir').style.display = 'none';
      //document.getElementById('ocultarAoImprimir1').style.display = 'none';
      //document.getElementById('ocultarAoImprimir2').style.display = 'none';
      //document.getElementById('ocultarAoImprimir3').style.display = 'none';
      //document.getElementById('ocultarAoImprimir4').style.display = 'none';
      //document.getElementById('ocultarAoImprimir5').style.display = 'none';
      //document.getElementById('ocultarAoImprimir6').style.display = 'none';
      //$('.panel-info').css("max-height", "100%");

      //html2canvas(document.getElementById("simulacao"), {
      //  onrendered: function (canvas) {

      //    //var img = canvas.toDataURL("image/png");
      //    var pdf = new jsPDF();
      //    //pdf.addImage(img, 'JPEG', 15, 10, 180, 0);
      //    pdf.autoPrint();
      //    window.open(pdf.output('bloburl'), '_blank');

      //    //document.getElementById('ocultarAoImprimir').style.display = '';
      //    //document.getElementById('ocultarAoImprimir1').style.display = '';
      //    //document.getElementById('ocultarAoImprimir2').style.display = '';
      //    //document.getElementById('ocultarAoImprimir3').style.display = '';
      //    //document.getElementById('ocultarAoImprimir4').style.display = '';
      //    //document.getElementById('ocultarAoImprimir5').style.display = '';
      //    //document.getElementById('ocultarAoImprimir6').style.display = '';
      //    //$('.panel-info').css("max-height", "275px");
      //  }
      //});
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('creduc.controllers')
    .controller('QueroSerParceiroController', QueroSerParceiroController);

  /** @ngInject */
  function QueroSerParceiroController(Estado, $scope, HelperService, DialogService, ContatoService, CREDUC) {
    var self = this;

    self.estados = [];
    self.cidades = [];
    self.selected = {};

    self.$onInit = function () {
      Estado.all().then(resultEstado);
    }

    self.getCidades = function (estado) {
      HelperService.deleteSelected(self.selected, 'cidade');
      Estado
        .cidades(estado.ID_ESTADO)
        .then(function (result) {
          self.cidades = result.data.Dados;
        });
    };

    self.submit = function () {
      var contato = angular.copy($scope.contato);

      contato.ID_CAMPUS = CREDUC.ID;

      ContatoService
        .queroSerParceiro(contato)
        .then(function (result) {
          if (result.data.CodigoResposta == 1) {
            var dialog = DialogService.success({
              message: 'Sua mensagem foi enviada com sucesso!'
            });
            dialog.result.then(function () {
              $scope.contato = {};
            });
          } else {
            DialogService.error();
          }
        }, function () {
          DialogService.error();
        });
    };

    self.$onInit();

    function resultEstado(result) {
      self.estados = result.data.Dados || [];
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('creduc.controllers')
    .controller('PendenciaController', PendenciaController);

  /** @ngInject */
  function PendenciaController(Instituicao, $state, $stateParams, $scope, $filter, Estado, DialogService, $API, $log, $rootScope, $q) {
    var self = this;

    self.instituicao = {};

    // functions
    self.exibeDadosConjuge = exibeDadosConjuge;
    self.exibeDadosResponsavel = exibeDadosResponsavel;
    self.exibeMembrosDaFamilia = exibeMembrosDaFamilia;
    self.exibeResponsaveisFinanceiros = exibeResponsaveisFinanceiros;

    self.getParentescoDescricao = getParentescoDescricao;
    self.submit = submit;
    self.removeFile = removeFile;
    self.fileExists = fileExists;

    self.$onInit = function () {
      self.lead = $stateParams.candidato || $state.params.candidato || null;
      self.situacao = $stateParams.situacao || $state.params.situacao || null;

      var $apiInstituicao = Instituicao.dataAsync().then(function (data) {
        self.instituicao = data;
        self.rendaFamiliar = self.instituicao.SOLICITAR_RENDA;
        self.pessoasFamilia = self.instituicao.EXIBIR_CAMPO_PESSOAS_FAMILIA;
      });

      if (!$stateParams.cpf || !$stateParams.email || !$stateParams.ies) {
        $state.go('instituicao', { instituicao: self.instituicao.SITE });
        return;
      }

      var $apiGetCandidato = getCandidato().then(function (data) {
        self.lead = data;
      }, function (err) {
        $log.error(err);
        DialogService.error({
          message: 'Nenhum candidato foi encontrado.'
        });
      });

      $q.all([$apiInstituicao, $apiGetCandidato]).then(function () {
        if (!self.lead) {
          $state.go('instituicao', { instituicao: self.instituicao.SITE });
          return;
        }

        var url = '/campus/{idCampus}/candidato/{cpf}/pendencias';

        url = url.replace('{idCampus}', self.lead.idCampus);
        url = url.replace('{cpf}', self.lead.cpf);

        $API.get(url).then(function (result) {
          if (result.data.Dados) {
            self.situacao = result.data.Dados;

            self.lead = {};
            self.lead.idCandidato = self.situacao.Candidato.ID_CANDIDATO;
            self.lead.idCampus = self.situacao.IdCampus;
            self.lead.cpf = self.situacao.Candidato.CPF;
            self.lead.nome = self.situacao.Candidato.NOME;
            self.lead.dtNascimento = self.situacao.Candidato.DT_NASCIMENTO;

            self.pendenciaAluno = self.situacao.Pendencias || [];
            self.pendenciaConjuge = self.situacao.Pendencias.PendenciaConjuge || [];
            self.pendenciaResponsavel = self.situacao.Pendencias.PendenciaResponsavel || [];
            self.pendenciaMembroFamilia = self.situacao.Pendencias.PendenciaMembrosFamilia || [];
            self.pendenciaFiador = self.situacao.Pendencias.PendenciaFiadorModel || [];
          }
        });
      });
    };

    function getCandidato() {
      var deferred = $q.defer();
      $API.post('/candidato/verifica/' + $stateParams.cpf, {
        email: $stateParams.email,
        ID_CAMPUS_CURSO: $stateParams.ies
      }).then(function (r) {
        if (r.data.Dados) {
          var data = r.data.Dados;

          var candidato = {};
          candidato.cpf = data.CPF;
          candidato.nome = data.NOME;
          candidato.idCampus = data.ID_CAMPUS;

          deferred.resolve(candidato);
        } else {
          deferred.reject();
        }
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    }

    function fileExists(obj, index) {
      if (typeof obj === "object" && obj.hasOwnProperty(index)) {
        return true;
      }
      return false;
    }

    function removeFile(obj, index) {
      if (fileExists(obj, index)) {
        delete obj[index];
      }
    }

    function getParentescoDescricao(FL_PARENTESCO) {
      switch (FL_PARENTESCO) {
        case 'P': return 'Pai/Mãe';
        case 'I': return 'Irmão/Irmã';
        case 'F': return 'Filho/Filha';
        case 'R': return 'Primo/Prima';
        case 'A': return 'Avô/Avó';
        case 'T': return 'Tio/Tia';
        case 'O': return 'Outros';
        default: return '';
      }
    }

    function exibeDadosResponsavel() {
      return self.pendenciaResponsavel && self.pendenciaResponsavel.length > 0;
    }

    function exibeDadosConjuge() {
      return self.pendenciaConjuge && self.pendenciaConjuge.length > 0;
    }

    function exibeMembrosDaFamilia() {
      return self.pendenciaMembroFamilia && self.pendenciaMembroFamilia.length > 0;
    }

    function exibeResponsaveisFinanceiros() {
      return self.pendenciaFiador && self.pendenciaFiador.length > 0;
    }

    function filesObrigatoriosSelected(listaObrigatoria, listaArquivos) {
      var c = 0;
      angular.forEach(Object.keys(listaArquivos), function (e) {
        if (listaObrigatoria.indexOf(e) > -1 && listaArquivos.hasOwnProperty(e) && listaArquivos[e]) {
          c++;
        }
      });
      return c;
    }

    // function validarDocumentosObrigatorios(listDocumentos, objDocumento) {
    //   var isValid = true;
    //   angular.forEach(listDocumentos, function (e) {
    //     if (e.OBRIGATORIO && (!objDocumento.hasOwnProperty(e.ID_CHECK_LIST_DOC_CAMPUS) || !objDocumento[e.ID_CHECK_LIST_DOC_CAMPUS])) {
    //       isValid = false;
    //     }
    //   });
    //   return isValid;
    // }


    function deleteEmptyFile(files) {
      angular.forEach(Object.keys(files || []), function (k) {
        if (files.hasOwnProperty(k) && typeof files[k] === "object" && !files[k]) {
          delete files[k];
        }
      });
    }

    function clearEmptyFiles() {
      if (self.hasOwnProperty('pendenciaAluno') && self.pendenciaAluno) {
        deleteEmptyFile(self.pendenciaAluno.files);
      }

      angular.forEach(self.pendenciaConjuge || [], function (e) {
        deleteEmptyFile(e.files);
      });

      angular.forEach(self.pendenciaResponsavel || [], function (e) {
        deleteEmptyFile(e.files);
      });

      angular.forEach(self.pendenciaMembroFamilia || [], function (e) {
        deleteEmptyFile(e.files);
      });

      angular.forEach(self.pendenciaFiador || [], function (e) {
        deleteEmptyFile(e.files);
      });
    }

    function submit() {
      // verifica se formulário contem erros
      if ($scope.formInscricao.$invalid) {
        DialogService.error({
          message: "É necessário preencher todos os campos corretamente!"
        })
        return;
      }

      clearEmptyFiles();

      var isValid = true;

      // mapeia
      var candidato = {
        ID: self.lead.idCandidato,
        ID_CAMPUS: self.lead.idCampus,
        CPF: self.lead.cpf
      };

      // verifica documentos aluno
      var docObrigatorioAluno = [];
      angular.forEach(self.pendenciaAluno.DocumentosNecessarios || [], function (e) {
        if (e.OBRIGATORIO) {
          docObrigatorioAluno.push(e.FAKE_ID.toString());
        }
      });

      if (docObrigatorioAluno.length > 0 && filesObrigatoriosSelected(docObrigatorioAluno, self.pendenciaAluno.files || []) < docObrigatorioAluno.length) {
        DialogService.error({
          message: "É necessário anexar todos os documentos obrigatórios do aluno!"
        });
        return;
      }

      candidato.FILES = self.pendenciaAluno.files || [];
      candidato.FAKE_ID = [];

      for (var p in self.pendenciaAluno.files)
        candidato.FAKE_ID.push(p);


      if (exibeDadosConjuge()) {
        isValid = true;

        angular.forEach(self.pendenciaConjuge, function (c) {
          var docObrigatorioConjuge = [];

          angular.forEach(c.DocumentosNecessarios || [], function (e) {
            if (e.OBRIGATORIO) {
              docObrigatorioConjuge.push(e.FAKE_ID.toString());
            }
          });

          if (docObrigatorioConjuge.length > 0 && filesObrigatoriosSelected(docObrigatorioConjuge, c.files || []) < docObrigatorioConjuge.length) {
            isValid = false;
            return;
          }

          var candidatoConjuge = {
            ID: c.ID,
            FAKE_ID: [],
            FILES: c.files || []
          };

          for (var p in c.files)
            candidatoConjuge.FAKE_ID.push(p);

          candidato.CANDIDATO_CONJUGE = [candidatoConjuge];
        });

        if (!isValid) {
          DialogService.error({
            message: "É necessário anexar todos os documentos obrigatórios do cônjuge!"
          });
          return;
        }
      } else if (exibeDadosResponsavel()) {
        isValid = true;
        angular.forEach(self.pendenciaResponsavel, function (c) {
          var docObrigatorioResponsavel = [];

          angular.forEach(c.DocumentosNecessarios || [], function (e) {
            if (e.OBRIGATORIO) {
              docObrigatorioResponsavel.push(e.FAKE_ID.toString());
            }
          });

          if (docObrigatorioResponsavel.length > 0 && filesObrigatoriosSelected(docObrigatorioResponsavel, c.files || []) < docObrigatorioResponsavel.length) {
            isValid = false;
            return;
          }

          var candidatoResponsavel = {
            ID: c.ID,
            FAKE_ID: [],
            FILES: c.files || []
          };

          for (var p in c.files)
            candidatoResponsavel.FAKE_ID.push(p);

          candidato.CANDIDATO_RESPONSAVEL = [candidatoResponsavel];
        });

        if (!isValid) {
          DialogService.error({
            message: "É necessário anexar todos os documentos obrigatórios do responsável do menor!"
          })
          return;
        }
      }

      if (exibeMembrosDaFamilia()) {
        var listaMembros = [];

        isValid = true;

        angular.forEach(self.pendenciaMembroFamilia, function (c) {
          var docObrigatorioMembroFamilia = [];

          angular.forEach(c.DocumentosNecessarios || [], function (e) {
            if (e.OBRIGATORIO) {
              docObrigatorioMembroFamilia.push(e.FAKE_ID.toString());
            }
          });

          if (docObrigatorioMembroFamilia.length > 0 && filesObrigatoriosSelected(docObrigatorioMembroFamilia, c.files || []) < docObrigatorioMembroFamilia.length) {
            isValid = false;
            return;
          }

          var membro = {
            ID: c.ID,
            FAKE_ID: [],
            FILES: c.files || []
          };

          for (var p in c.files)
            membro.FAKE_ID.push(p);

          listaMembros.push(membro);
        });

        if (!isValid) {
          DialogService.error({
            message: "É necessário anexar todos os documentos obrigatórios do membro da família!"
          });
          return;
        }

        candidato.MEMBROS_FAMILIA = listaMembros;
      }

      if (exibeResponsaveisFinanceiros()) {
        var listaFiador = [];

        isValid = true;

        angular.forEach(self.pendenciaFiador, function (c) {
          var docObrigatorioFiador = [];

          angular.forEach(c.DocumentosNecessarios || [], function (e) {
            if (e.OBRIGATORIO) {
              docObrigatorioFiador.push(e.FAKE_ID.toString());
            }
          });

          if (docObrigatorioFiador.length > 0 && filesObrigatoriosSelected(docObrigatorioFiador, c.files || []) < docObrigatorioFiador.length) {
            isValid = false;
            return;
          }

          var fiador = {
            ID: c.ID,
            FAKE_ID: [],
            FILES: c.files || []
          };

          for (var p in c.files)
            fiador.FAKE_ID.push(p);

          listaFiador.push(fiador);
        });

        if (!isValid) {
          DialogService.error({
            message: "É necessário anexar todos os documentos obrigatórios dos corrresponsáveis financeiros!"
          });
          return;
        }

        candidato.RESPONSAVEL_SERASA = listaFiador;
      }

      $log.log(candidato);

      $rootScope.modalComponentProgressPercentage = 0;

      var $dialogProgress = DialogService.progress($rootScope.modalComponentProgressPercentage, {
        title: 'Enviando inscrição!'
      });

      // se tudo OK, chama a api com endpoint novo
      $API.postUpload('/candidato/pendencia/concluir', candidato).then(function (r) {
        if (r.data.Dados) {
          $dialogProgress.close();
          var $dialogSuccess = DialogService.success({
            message: 'Sua inscrição foi concluída com sucesso!'
          });

          $dialogSuccess.result.then(function () {
            $state.go('instituicao', {
              instituicao: self.instituicao.SITE
            });
          });
        }
      }, function (err) {
        $log.error(err);
        $dialogProgress.close();
        DialogService.error({
          message: 'Ocorreu um erro ao concluir a inscrição. Tente novamente!'
        });
      }, function (e) {
        $rootScope.modalComponentProgressPercentage = parseInt(100.0 * e.loaded / e.total);
      });
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('creduc.controllers')
    .controller('InstituicaoController', InstituicaoController);

  /** @ngInject */
  function InstituicaoController(Instituicao, $state, $stateParams, $scope, $filter, $rootScope, $location, $anchorScroll) {
    var self = this;

    self.slides = [];

    self.instituicao = {};
    self.showBannerOqE = false;
    self.mostrarMsgAvaliacao = false;
    self.showIESvxFIesBanner = false;
    self.showIESvxFIesBannerDoctum = false;
    self.mostrarMensagemInscricao = false;
    self.parametros = null;
    self.urlTextoComercialSM = '';
    self.urlTextoComercialMD = '';
    self.urlComparacaoFiesSM = '';
    self.urlComparacaoFiesMD = '';
    self.urlInstituicao = '';
    self.CreducVsFies = [
    ];

    self.$onInit = function () {
      var slug = $stateParams.instituicao || $state.params.instituicao;
      //return;
      console.log(localStorage.getItem("parametros"));
      localStorage.removeItem("_inscricao");
      localStorage.removeItem("parametros");
      localStorage.removeItem("instituicao");
      localStorage.removeItem("docs");
      localStorage.removeItem("estados");
      localStorage.removeItem("Escolha");
      localStorage.removeItem("userTeste");
      localStorage.setItem("lastInstituicao", slug);
      console.log(localStorage.getItem("parametros"));



      if ($location.search().Id != null) {
        var userTeste = { IdUser: $location.search().Id };
        var json = JSON.stringify(userTeste);

        localStorage.setItem('userTeste', json);
      }



      if (slug == "iesb") {
        self.showBannerOqE = true;
        self.showIESvxFIesBanner = true;
      } else if (slug == "doctum") {
        //self.showBannerOqE = true;
        self.showIESvxFIesBannerDoctum = true;
      }

      self.urlInstituicao = slug;
      //console.log('here');
      //if (localStorage.getItem("instituicao") != null) {
      //  //console.log(localStorage.getItem("instituicao"));
      //  promiseGetInstituicaoSuccess(null);
      //  // console.log(self.instituicao);

      //} else {
      Instituicao
        .get(slug)
        .then(promiseGetInstituicaoSuccess, promiseGetInstituicaoError);
      //}
      //Instituicao
      //  .get(slug)
      //  .then(promiseGetInstituicaoSuccess, promiseGetInstituicaoError);


      //Pegar arquivo local Json, nao chama valores do Back, precisa existir a pasta local
      // $http.get('app/dados/'+slug+'/data.json').then(function(data) {
      //   self.instituicao = data.data.Dados;
      //   localStorage.setItem("parametros", JSON.stringify(self.instituicao.ListParametrosGrupo));
      //   self.slides.push({
      //     title: 'Slide 1',
      //     src: {
      //       sm: self.getBanner('sm'),
      //       md: self.getBanner('md'),
      //       lg: self.getBanner('lg')
      //     }
      //   });
      //
      //   let aux = self.instituicao.BANNER_HOTSITE.find(p => p.TIPO === "TextoComercial");
      //   self.urlTextoComercial = aux && aux.ARQUIVO ? aux.ARQUIVO.STATIC_PATH : '';
      //
      //   aux = self.instituicao.BANNER_HOTSITE.find(p => p.TIPO === "ComparacaoFies");
      //   self.urlComparacaoFies = aux && aux.ARQUIVO ? aux.ARQUIVO.STATIC_PATH : '';
      //
      //   self.CreducVsFies = self.instituicao.COMPARACAO_FIES;
      //   $rootScope.title = self.instituicao.SEO_TITLE;
      //   $rootScope.$seo_keywords = self.instituicao.SEO_KEYWORDS;
      //   $rootScope.$seo_description = self.instituicao.SEO_DESCRIPTION;
      //   $rootScope.$favicon = self.instituicao.FAVICON.STATIC_PATH;
      //   //console.log('CARREGANDO ARQUIVOS JSON DA PASTA LOCAL');
      //   //console.log(data);
      //
      // }, function() {
      //   //console.log('Não achou folder local');
      //   Instituicao
      //     .get(slug)
      //     .then(promiseGetInstituicaoSuccess, promiseGetInstituicaoError);
      // });

    };


    self.bloqueiaInscricao = function () {
      //console.log(exibeCampo("BLOQUEAR_INSCRICAO"))
      return exibeCampo("BLOQUEAR_INSCRICAO");


    };

    self.bloqueiaSimulacao = function () {
      //console.log(exibeCampo("BLOQUEAR_INSCRICAO"))
      return exibeCampo("BLOQUEAR_SIMULACAO");


    };

    function exibeCampo(parametro) {
      var exibe = false;
      if (self.instituicao.ListParametrosGrupo) {
        self.parametros = self.instituicao.ListParametrosGrupo;
        if (self.parametros != undefined) {

          var it = $filter('filter')(self.parametros, { 'SLUG': parametro });

          if (it.length > 0) {
            var existe = it[0];

            if (self.parametros && existe.VALOR == "S") {
              exibe = true;
              return exibe;
            }
          }

        }
      }
      return exibe;
    }

    self.getTituloImplantacao = function () {
      return self.instituicao.TITULO_IMPLANTACAO;
    };

    self.getNomeParcelamento = function () {
      return self.instituicao.PROGRAMA_CREDITO;
    };

    self.getTexto = function (ordem) {
      var texto = $filter('filter')(self.instituicao.TEXTO_IMPLANTACAO, function (e) {
        return e.ORDEM == ordem;
      });

      if (angular.isArray(texto) && texto.length > 0) {
        return texto[0].TEXTO;
      }

      return null;
    };

    // ANCORA SCROLL LINKS
    self.linkIrPara = function (id) {

      self.mostrarMensagemInscricao = true;

      setTimeout(function () {
        $location.hash(id);
        $anchorScroll();
      }, 100);



    };

    self.mostarMensagemAvaliacao = function () {
      self.mostrarMsgAvaliacao = !self.mostrarMsgAvaliacao;
      self.mostrarMsgAdesao = false;
      self.mostrarMsgAprovacao = false;
    }

    self.mostarMensagemAdesao = function () {
      self.mostrarMsgAdesao = !self.mostrarMsgAdesao;
      self.mostrarMsgAvaliacao = false;
      self.mostrarMsgAprovacao = false;
    }

    self.mostarMensagemAprovacao = function () {
      self.mostrarMsgAprovacao = !self.mostrarMsgAprovacao;
      self.mostrarMsgAdesao = false;
      self.mostrarMsgAvaliacao = false;
    }


    self.getBanner = function (tamanho) {
      var banner = $filter('filter')(self.instituicao.BANNER_HOTSITE, function (e) {
        return (e.TAMANHO.toUpperCase() == tamanho.toUpperCase() && !!e.ARQUIVO && !!e.ARQUIVO.NOME_ARQUIVO && (!e.TIPO || e.TIPO === 'Banner'));
      });

      if (angular.isArray(banner) && banner.length > 0) {
        return banner[0].ARQUIVO.STATIC_PATH;
      }

      return null;
    };

    function promiseGetInstituicaoError() {
      document.location = '/';
    }

    function promiseGetInstituicaoSuccess(result) {
      //if (localStorage.getItem("instituicao") != null) {
      //  self.instituicao = JSON.parse(localStorage.getItem("instituicao"));

      //} else {
      self.instituicao = result.data.Dados;
      //localStorage.setItem("instituicao", JSON.stringify(self.instituicao));
      //}

      localStorage.setItem("parametros", JSON.stringify(self.instituicao.ListParametrosGrupo));

      //var teste = {
      //  title: 'Slide 1',
      //  src: {
      //    sm: self.getBanner('sm'),
      //    md: self.getBanner('lg') ? self.getBanner('lg') : self.getBanner('md')
      //  }
      //}
      //console.log(teste);
      self.slides.push({
        title: 'Slide 1',
        src: {
          sm: self.getBanner('sm'),
          md: self.getBanner('lg') ? self.getBanner('lg') : self.getBanner('md')
        }
      });


      var temp1 = $filter("filter")(self.instituicao.BANNER_HOTSITE, { TIPO: "TextoComercial", TAMANHO: 'SM' });
      var aux = temp1.length > 0 ? temp1[0] : null;
      self.urlTextoComercialSM = aux && aux.ARQUIVO ? aux.ARQUIVO.STATIC_PATH : '';

      temp1 = $filter("filter")(self.instituicao.BANNER_HOTSITE, { TIPO: "TextoComercial", TAMANHO: 'MD' });
      aux = temp1.length > 0 ? temp1[0] : null;
      self.urlTextoComercialMD = aux && aux.ARQUIVO ? aux.ARQUIVO.STATIC_PATH : '';

      temp1 = $filter("filter")(self.instituicao.BANNER_HOTSITE, { TIPO: "ComparacaoFies", TAMANHO: 'SM' });
      aux = temp1.length > 0 ? temp1[0] : null;
      self.urlComparacaoFiesSM = aux && aux.ARQUIVO ? aux.ARQUIVO.STATIC_PATH : '';

      temp1 = $filter("filter")(self.instituicao.BANNER_HOTSITE, { TIPO: "ComparacaoFies", TAMANHO: 'MD' });
      aux = temp1.length > 0 ? temp1[0] : null;
      self.urlComparacaoFiesMD = aux && aux.ARQUIVO ? aux.ARQUIVO.STATIC_PATH : '';

      self.CreducVsFies = self.instituicao.COMPARACAO_FIES;

      $rootScope.title = self.instituicao.SEO_TITLE;
      $rootScope.$seo_keywords = self.instituicao.SEO_KEYWORDS;
      $rootScope.$seo_description = self.instituicao.SEO_DESCRIPTION;
      $rootScope.$favicon = self.instituicao.FAVICON.STATIC_PATH;
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('creduc.controllers')
    .controller('ParceirosController', ParceirosController);

  /** @ngInject */
  function ParceirosController(Hotsite ,$state) {
    var self = this;
    self.parceiros = {};
    self.url = '';

    self.$onInit = function () {
      document.location.href = 'https://parceiro.creduc.com.br'; 
      //Hotsite
      //  .parceiros()
      //  .then(promiseGetParceirosSuccess, promiseGetParceirosError);
    };

    self.$onInit();
    self.goHotsite =  function(url){
      self.url = url
      $state.go(self.url, {
        teste: 'teste'
      });
    }
    //function promiseGetParceirosSuccess(result) {
    //  self.parceiros = result.data.Result;
    //  //console.log(self.parceiros);
    //}
    //function promiseGetParceirosError() {
    //  //console.log("Error");
    //  // $state.go('home');
    //}
  }

})();

(function () {
  'use strict';

  angular
    .module('creduc.controllers')
    .controller('InscricaoController', InscricaoController)

  /** @ngInject */
  function InscricaoController(Instituicao, $state, $stateParams, $scope, $filter, Estado, DialogService, $API, $log, $interval, $rootScope, $q, $location, API_SETTINGS, ENV, $sce) {
    var self = this;
    self.contrato = {};
    self.listaBannerConclusao = [];
    self.textoConclusao;
    self.exibeImgTextoConclusao;

    self.UrlRetornoFacebook = API_SETTINGS[ENV].AUTENTICAR;
    self.vagasDisponiveis = localStorage.getItem("vagasDisponiveis");
    self.enderecoAluno = { $id: '', CEP: '', LOGRADOURO: '', BAIRRO: '', CIDADE: '', ESTADO: '', UF: '', COMPLEMENTO: '', NUMERO: '' };
    var pId = $location.path().split("/")[3] || "Unknown";
    if (pId == "Unknown" && $location.path().split("/")[2] == "inscricao") {
      pId = "dados-academicos";
    }

    self.InfoPasso = {};
    switch (pId) {
      case 'dados-academicos':
        self.InfoPasso.BTNSalvar = "PROSSEGUIR";
        break;
      case 'dados-pessoais':
        self.InfoPasso.BTNSalvar = "PROSSEGUIR";
        break;
      case 'dados-familia':
        self.InfoPasso.BTNSalvar = "PROSSEGUIR";
        break;
      case 'termo-candidato':
       // self.InfoPasso.BTNSalvar = self.botaoTermoAceite;
       

        /* eslint-disable no-console */
       // console.log(self.InfoPasso.BTNSalvar);
       /* eslint-enable no-console */

        break;
      case 'dados-financeiros':
        self.InfoPasso.BTNSalvar = "PROSSEGUIR";
        break;
      case 'pagar-taxa':
        self.InfoPasso.BTNSalvar = "PROSSEGUIR";
        self.InfoPasso.BTNPular = "PAGAR DEPOIS";
        break;
      case 'documentos-candidato':
        self.InfoPasso.BTNSalvar = "CONCLUIR INSCRIÇÃO";
        self.InfoPasso.BTNPular = "PULAR ENVIO DE DOCUMENTOS";
        break;
    }

    self._passo = pId;
    self.mostrar_tudo = false;
    self.showGmaps = false;
    self.parametros = null;
    self.instituicao = {};
    self.membroFamilia = {};
    self.instituicaoNome = null;
    self.membrosFamilia = [];
    self.corresponsaveisFinanceiros = [];
    self.selected = { estadoCivil: null };
    self.habilitaLoading = '';

    self.documentos = [];
    self.documentosAluno = [];
    self.documentosFamilia = [];
    self.documentosFiador = [];
    self.documentosConjuge = [];

    self.documentosResponsavel = [];
    self.passoDadosAcademicos = false;
    self.passoDadosPessoais = false;
    self.passoDadosMembrosFamilia = false;
    self.passoDadosFinanceiros = false;
    self.passoDadosDocumentos = false;
    self.passoDadosTermoCompromiso = false;
    self.passoConclusao = false;
    // functions
    self.exibeDadosConjuge = exibeDadosConjuge;
    self.exibeDadosResponsavel = exibeDadosResponsavel;
    self.candidatoMenorIdade = candidatoMenorIdade;
    self.getParentescoDescricao = getParentescoDescricao;
    self.showPagamento = false;
    self.exibeDocumentos = exibeDocumentos;

    self.adicionarMembroResponsavel = adicionarMembroResponsavel;
    self.removerMembroResponsavel = removerMembroResponsavel;

    self.removeFile = removeFile;
    self.fileExists = fileExists;
    self.alunoVeterano = '';
    self.membroResponsavel = {};

    self.SENHA_CADASTRO = null;
    self.listaConsultor = [];
    self.idConsultor = 0;

    self.ListaDocumentosAnexadosAluno = [];
    self.ListaDocumentosAnexadosFamilia = [];
    self.ListaDocumentosAnexadosFiador = [];
    self.ListaDocumentosAnexadosConjuge = [];
    self.ListaDocumentosAnexadosResponsavel = [];

    self.pagaVeterano = 'S';
    self.habilitaAceiteContratoOnline = '';
    self.paramTermoCompromisso = 'N';
    self.userIp = '';
    self.temAceiteTermo = false;
    self.botaoTermoAceite = "ACEITAR";

    self.$onInit = function () {
      self.buscarIP();
      if (self._passo == "termo-candidato") {
        self.verificarPendenciaAluno();
      }

      self.ListaParametros = JSON.parse(localStorage.getItem("parametros"));

      self.parametros = self.ListaParametros;

      var ita = $filter('filter')(self.ListaParametros, { 'SLUG': 'HABIITAR_ACEITE_ONLINE_CONTRATO' });
      self.habilitaAceiteContratoOnline = ita != undefined && ita.length > 0 ? ita[0].VALOR == 'S' : false;

      var itp = $filter('filter')(self.ListaParametros, { 'SLUG': 'HABILITAR_PAGAMENTO_HOTSITE' });
      self.showPagamento = itp != undefined && itp.length > 0 ? itp[0].VALOR == 'S' : false;


      var itf = $filter('filter')(self.ListaParametros, { 'SLUG': 'SOLICITAR_RENDA' });
      self.rendaFamiliar = itf != undefined && itf.length > 0 ? itf[0].VALOR : "N";

      var itf2 = $filter('filter')(self.ListaParametros, { 'SLUG': 'EXIBIR_CAMPO_PESSOAS_FAMILIA' });
      self.pessoasFamilia = itf2 != undefined && itf2.length > 0 ? itf2[0].VALOR : "N";

      var itf3 = $filter('filter')(self.ListaParametros, { 'SLUG': 'EXIBIR_CAMPO_NOTA_ENEM' });
      self.notaEnem = itf3 != undefined && itf3.length > 0 ? itf3[0].VALOR : "N";
      var passoIr = 'dados-academicos';


      var itf4 = $filter('filter')(self.ListaParametros, { 'SLUG': 'ATIVAR_TP_FINANCIAMENTO_VETERANO' });
      self.paramTermoCompromisso = $filter('filter')(self.ListaParametros, { 'SLUG': 'EXIBIR_TERMO_COMPROMISSO' })[0].VALOR;
      var showPagamentoVeterano = itf4 != undefined && itf4.length > 0 ? itf4[0].VALOR == 'S' : false;
      if (self.showPagamento && showPagamentoVeterano == false) {
        self.showPagamento = false;
      }

      if (($stateParams.candidato == undefined || $state.params.candidato == undefined) && localStorage.getItem("_inscricao") == undefined) {
        return;
      }
      else {

        self.instituicao = $stateParams.instituicao || $state.params.instituicao;

        self.lead = $stateParams.candidato || $state.params.candidato || null;

        self.selected = $stateParams.selected || $state.params.selected || null;
        self.estados = $stateParams.estados || $state.params.estados || [];
        self.cidades = $stateParams.cidades || $state.params.cidades || [];
        self.instituicoes = $stateParams.instituicoes || $state.params.instituicoes || [];
        self.cursos = $stateParams.cursos || $state.params.cursos || [];

        if (self.instituicao == "iesb") {
          self.showGmaps = true;
        }

        var _inscricao = {};

        if (localStorage.getItem("_inscricao") == undefined && (self.lead || self.lead.CPF || self.lead.ID_CAMPUS)) {

          /* eslint-disable no-console */
          console.log("lead_familia", self.lead.membrosFamilia);
          /* eslint-enable no-console */

          

          _inscricao = {
            instituicao: self.instituicao,
            lead: self.lead,
            selected: self.selected,
            estados: self.estados,
            cidades: self.cidades,
            instituicoes: self.instituicoes,
            cursos: self.cursos,
            membrosFamilia: self.lead.membrosFamilia,
            corresponsaveisFinanceiros: self.lead.corresponsaveisFinanceiros,
          }

          self.membrosFamilia = self.lead.membrosFamilia != null ? self.lead.membrosFamilia : [];
          self.corresponsaveisFinanceiros = self.lead.corresponsaveisFinanceiros != null ? self.lead.corresponsaveisFinanceiros : [];

          self.alunoVeterano = _inscricao.lead.alunoVeterano ? 'S' : 'N';

          if (_inscricao.lead.documentosAluno == undefined) {
            _inscricao.lead.documentosAluno = [];
          }

          if (_inscricao.lead.documentosFamilia == undefined) {
            _inscricao.lead.documentosFamilia = [];
          }

          if (_inscricao.lead.documentosFiador == undefined) {
            _inscricao.lead.documentosFiador = [];
          }

          if (_inscricao.lead.documentosConjuge == undefined) {
            _inscricao.lead.documentosConjuge = [];
          }

          if (_inscricao.lead.documentosResponsavel == undefined) {
            _inscricao.lead.documentosResponsavel = [];
          }

          localStorage.setItem("_inscricao", JSON.stringify(_inscricao));

          self.mudarRota(passoIr);
        }
        else {
          
          /* eslint-disable no-console */
          console.log("inscricao", _inscricao.membrosFamilia);
          /* eslint-enable no-console */
          _inscricao = JSON.parse(localStorage.getItem("_inscricao"));
          self.instituicao = JSON.parse(localStorage.getItem("instituicao"));
          self.instituicaoNome = _inscricao.instituicao;
          self.membrosFamilia = _inscricao.membrosFamilia != null ? _inscricao.membrosFamilia : [];

          /* eslint-disable no-console */
          console.log("inscricao1", self.membrosFamilia );
          /* eslint-enable no-console */

          for (var s = 0; s < self.membrosFamilia.length; s++) {
            var dia1 = self.membrosFamilia[s].DT_NASCIMENTO.substr(8, 2);
            var mes = self.membrosFamilia[s].DT_NASCIMENTO.substr(5, 2);
            var ano = self.membrosFamilia[s].DT_NASCIMENTO.substr(0, 4);
            var data = dia1 + "/" + mes + "/" + ano;            
            self.membrosFamilia[s].DT_NASCIMENTO = data;
          }





          self.corresponsaveisFinanceiros = _inscricao.corresponsaveisFinanceiros != null ? _inscricao.corresponsaveisFinanceiros : [];
          self.lead = _inscricao.lead;
          self.alunoVeterano = _inscricao.lead.alunoVeterano ? 'S' : 'N';
          self.pagaVeterano = itf4 != undefined && itf4.length > 0 && self.alunoVeterano == 'S' ? itf4[0].VALOR : 'S';
          self.selected = _inscricao.selected;
          self.estados = _inscricao.estados;
          self.cidades = _inscricao.cidades;
          self.instituicoes = _inscricao.instituicoes;
          self.cursos = _inscricao.cursos;
          self.passoDadosAcademicos = _inscricao.passoDadosAcademicos;
          self.passoDadosPessoais = _inscricao.passoDadosPessoais;
          self.passoDadosMembrosFamilia = _inscricao.passoDadosMembrosFamilia;
          self.passoDadosFinanceiros = _inscricao.passoDadosFinanceiros;
          self.passoDadosDocumentos = _inscricao.passoDadosDocumentos;
          self.passoDadosTermoCompromiso = _inscricao.passoDadosTermoCompromiso;
          self.passoPagamento = _inscricao.passoPagamento;
          self.passoConclusao = _inscricao.passoConclusao;

          self.selected.estadoCivil = _inscricao.lead.estadoCivil
          self.exibeDadosResponsavel();

        }

        if (self.lead && self.lead.hasOwnProperty('ID_CAMPUS') && self.lead.ID_CAMPUS) {
          var idCampus = self.lead.ID_CAMPUS;

          $API.get('/campus/' + idCampus + '/documentos/checklist/T').then(function (r) {

            if (r.data.Dados) {
              localStorage.setItem("docs", JSON.stringify(r.data.Dados));
              self.documentos = r.data.Dados;
              var existe = [];

              angular.forEach(self.documentos, function (e) {
                e.Enviado = false;
                e.Status = "";

                switch (e.FL_TIPO_DOC) {
                  case 'A':
                    if (self.ListaDocumentosAnexadosAluno) {
                      existe = $filter('filter')(self.ListaDocumentosAnexadosAluno, { 'ID_CHECK_LIST_DOC_CAMPUS': e.ID_CHECK_LIST_DOC_CAMPUS });
                      if (existe != undefined && existe.length > 0) {
                        e.Enviado = true;
                        e.Status = existe[0] != null ? existe[0].Status : "";

                      }
                    }
                    self.documentosAluno.push(e);
                    break;
                  case 'M':
                    //////console.log(self.ListaDocumentosAnexadosFamilia);
                    //////console.log($filter('filter')(self.ListaDocumentosAnexadosFamilia, { 'ID_CHECK_LIST_DOC_CAMPUS': e.ID_CHECK_LIST_DOC_CAMPUS }));
                    if (self.ListaDocumentosAnexadosFamilia) {
                      existe = $filter('filter')(self.ListaDocumentosAnexadosFamilia, { 'ID_CHECK_LIST_DOC_CAMPUS': e.ID_CHECK_LIST_DOC_CAMPUS });
                      //////console.log(self.ListaDocumentosAnexadosFamilia);
                      //////console.log(existe);
                      //existe.forEach(function (valor, chave) {
                      //  var check = e;
                      //  e.Enviado = true;
                      //  e.Status = valor != null ? valor.Status : "";
                      //  e.ID_PESSOA = valor.IdPessoa;
                      //  ////console.log(e.ID_PESSOA);
                      //  ////console.log(e);
                      //  self.documentosFamilia.push(e);
                      //});
                      //for (let i = 0; i < existe.length; i = i + 1) {
                      //  var check = e;
                      //  check.Enviado = true;
                      //  check.Status = existe[i] != null ? existe[i].Status : "";
                      //  check.ID_PESSOA = existe[i].IdPessoa;
                      // // ////console.log(check.ID_PESSOA);
                      // // ////console.log(check);
                      //  self.documentosFamilia.push(check);
                      //}
                      //if (existe != undefined && existe.length > 0) {
                      //  e.Enviado = true;
                      //  e.Status = existe[0] != null ? existe[0].Status : "";
                      //}
                    }
                    self.documentosFamilia.push(e);
                    break;
                  case 'F':
                    if (self.ListaDocumentosAnexadosFiador || _inscricao.corresponsaveisFinanceiros) {

                      existe = $filter('filter')(self.ListaDocumentosAnexadosFiador, { 'ID_CHECK_LIST_DOC_CAMPUS': e.ID_CHECK_LIST_DOC_CAMPUS });
                      if (existe == undefined && existe.length == 0) {
                        existe = $filter('filter')(_inscricao.corresponsaveisFinanceiros, { 'ID_CHECK_LIST_DOC_CAMPUS': e.ID_CHECK_LIST_DOC_CAMPUS });

                      }


                      if (existe != undefined && existe.length > 0) {
                        e.Enviado = true;
                        e.Status = existe[0] != null ? existe[0].Status : "";

                        e.FAKE_ID = e.ID_CHECK_LIST_DOC_CAMPUS;

                      }
                    }


                    self.documentosFiador.push(e);

                    break;
                  case 'C':

                    if (self.ListaDocumentosAnexadosConjuge) {
                      existe = $filter('filter')(self.ListaDocumentosAnexadosConjuge, { 'ID_CHECK_LIST_DOC_CAMPUS': e.ID_CHECK_LIST_DOC_CAMPUS });
                      if (existe != undefined && existe.length > 0) {
                        e.Enviado = true;
                        e.Status = existe[0] != null ? existe[0].Status : "";
                      }
                    }
                    self.documentosConjuge.push(e);
                    break;
                  case 'R':

                    if (self.ListaDocumentosAnexadosResponsavel) {
                      existe = $filter('filter')(self.ListaDocumentosAnexadosResponsavel, { 'ID_CHECK_LIST_DOC_CAMPUS': e.ID_CHECK_LIST_DOC_CAMPUS });
                      if (existe != undefined && existe.length > 0) {
                        e.Enviado = true;
                        e.Status = existe[0] != null ? existe[0].Status : "";
                      }
                    }
                    self.documentosResponsavel.push(e);
                    break;
                }
              });

            }

            /* eslint-disable no-console */
            // ////console.log(self.documentosFamilia);
          /* eslint-enable no-console */
            

            angular.forEach(self.lead.documentosAluno, function (e) {
              var it = $filter('filter')(self.documentos, { 'ID_CHECK_LIST_DOC_CAMPUS': e.ID_CHECK_LIST_DOC_CAMPUS, 'DESCRICAO': e.DESCRICAO });
              if (it == undefined || it.length == 0) {
                e.OBRIGATORIO = true;
                self.documentosAluno.push(e)
              }
            });

            angular.forEach(self.lead.documentosFiador, function (e) {
              var it = $filter('filter')(self.documentosFiador, { 'ID_CHECK_LIST_DOC_CAMPUS': e.ID_CHECK_LIST_DOC_CAMPUS, 'DESCRICAO': e.DESCRICAO });
              if (it == undefined || it.length == 0) {
                e.OBRIGATORIO = true;
                self.documentosFiador.push(e)
              }
            });

            angular.forEach(self.lead.documentosConjuge, function (e) {
              var it = $filter('filter')(self.documentosConjuge, { 'ID_CHECK_LIST_DOC_CAMPUS': e.ID_CHECK_LIST_DOC_CAMPUS, 'DESCRICAO': e.DESCRICAO });
              if (it == undefined || it.length == 0) {
                e.OBRIGATORIO = true;
                self.documentosConjuge.push(e)
              }
            });

            angular.forEach(self.lead.documentosFamilia, function (e) {
              var it = $filter('filter')(self.documentosFamilia, { 'ID_CHECK_LIST_DOC_CAMPUS': e.ID_CHECK_LIST_DOC_CAMPUS, 'DESCRICAO': e.DESCRICAO });
              if (it == undefined || it.length == 0) {
                e.OBRIGATORIO = true;
                self.documentosFamilia.push(e)
              }
            });

            angular.forEach(self.lead.documentosResponsavel, function (e) {
              var it = $filter('filter')(self.documentosResponsavel, { 'ID_CHECK_LIST_DOC_CAMPUS': e.ID_CHECK_LIST_DOC_CAMPUS, 'DESCRICAO': e.DESCRICAO });
              if (it == undefined || it.length == 0) {
                e.OBRIGATORIO = true;
                self.documentosResponsavel.push(e)
              }
            });

            Instituicao.dataAsync().then(function (data) {
              self.instituicao = data;
              localStorage.setItem("instituicao", JSON.stringify(self.instituicao));

              Estado.campus.all(self.instituicao.ID_CAMPUS).then(promiseEstadoSuccess);

            });
          });

        }

        self.ListaDocumentosAnexadosFiador = _inscricao.lead.documentosFiador;
        self.ListaDocumentosAnexadosAluno = _inscricao.lead.documentosAluno;
        self.ListaDocumentosAnexadosFamilia = _inscricao.lead.documentosFamilia;
        self.ListaDocumentosAnexadosConjuge = _inscricao.lead.documentosConjuge;
        self.ListaDocumentosAnexadosResponsavel = _inscricao.lead.documentosResponsavel;

        var selectedInstituicao = Instituicao.data();
        self.listaBannerConclusao = $filter("filter")(selectedInstituicao.BANNER_HOTSITE, { TIPO: "Conclusao" });
        self.textoConclusao = selectedInstituicao.TEXTO_CONCLUSAO ? selectedInstituicao.TEXTO_CONCLUSAO : '';
        self.exibeImgTextoConclusao = selectedInstituicao.EXIBE_IMG_TEXTO_CONCLUSAO ? selectedInstituicao.EXIBE_IMG_TEXTO_CONCLUSAO : 'N';

        self.MontarListaConsultores();



        self.enderecoAluno.UF = self.lead.UF;
        self.enderecoAluno.LOGRADOURO = self.lead.LOGRADOURO;
        self.enderecoAluno.CIDADE = self.lead.CIDADE;
        self.enderecoAluno.BAIRRO = self.lead.BAIRRO;
        self.enderecoAluno.ESTADO = self.lead.ESTADO;
        self.enderecoAluno.CEP = self.lead.CEP;
        self.enderecoAluno.NUMERO = self.lead.NUMERO;
        self.enderecoAluno.COMPLEMENTO = self.lead.COMPLEMENTO;

        if (typeof self.lead.CEP == 'number') {
          self.lead.CEP = self.lead.CEP.toString();
        }

        if (((self.lead.UF == null || self.lead.UF == '')
          || (self.lead.LOGRADOURO == null || self.lead.LOGRADOURO == '')
          || (self.lead.CIDADE == null || self.lead.CIDADE == '')
          || (self.lead.BAIRRO == null || self.lead.BAIRRO == '')
          || (self.lead.ESTADO == null || self.lead.ESTADO == ''))
          && (self.lead.CEP != null && self.lead.CEP != '')) {
          self.consultarCepAlunoRet();
        }

      }


    };

    self.getOS = function () {
      var os;
      var osVersao;
      var userAgent = navigator.userAgent;
      var appVersion = navigator.appVersion;

      var clientStrings = [
        { s: 'Windows 10', r: /(Windows 10.0|Windows NT 10.0)/ },
        { s: 'Windows 8.1', r: /(Windows 8.1|Windows NT 6.3)/ },
        { s: 'Windows 8', r: /(Windows 8|Windows NT 6.2)/ },
        { s: 'Windows 7', r: /(Windows 7|Windows NT 6.1)/ },
        { s: 'Windows Vista', r: /Windows NT 6.0/ },
        { s: 'Windows Server 2003', r: /Windows NT 5.2/ },
        { s: 'Windows XP', r: /(Windows NT 5.1|Windows XP)/ },
        { s: 'Windows 2000', r: /(Windows NT 5.0|Windows 2000)/ },
        { s: 'Windows ME', r: /(Win 9x 4.90|Windows ME)/ },
        { s: 'Windows 98', r: /(Windows 98|Win98)/ },
        { s: 'Windows 95', r: /(Windows 95|Win95|Windows_95)/ },
        { s: 'Windows NT 4.0', r: /(Windows NT 4.0|WinNT4.0)/ },
        { s: 'Windows CE', r: /Windows CE/ },
        { s: 'Windows 3.11', r: /Win16/ },
        { s: 'Android', r: /Android/ },
        { s: 'Open BSD', r: /OpenBSD/ },
        { s: 'Sun OS', r: /SunOS/ },
        { s: 'Chrome OS', r: /CrOS/ },
        { s: 'Linux', r: /(Linux|X11(?!.*CrOS))/ },
        { s: 'iOS', r: /(iPhone|iPad|iPod)/ },
        { s: 'Mac OS X', r: /Mac OS X/ },
        { s: 'Mac OS', r: /(Mac OS|MacPPC|MacIntel|Mac_PowerPC|Macintosh)/ },
        { s: 'QNX', r: /QNX/ },
        { s: 'UNIX', r: /UNIX/ },
        { s: 'BeOS', r: /BeOS/ },
        { s: 'OS/2', r: /OS\/2/ },
        { s: 'Search Bot', r: /(nuhk|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask Jeeves\/Teoma|ia_archiver)/ },
        { s: 'Windows', r: /Windows/ }
      ];
      for (var id in clientStrings) {
        var cs = clientStrings[id];
        if (cs.r.test(userAgent)) {
          os = cs.s;
          break;
        }
      }

      if (/Windows/.test(os)) {
        if (/Windows (.*)/.exec(os))
          osVersao = /Windows (.*)/.exec(os)[1];
        else {
          osVersao = /Windows (.*)/.exec(userAgent)[1].split(";")[0];
        }
        os = 'Windows';
      }

      switch (os) {
        case 'Mac OS':
        case 'Mac OS X':
        case 'Android':
          osVersao = /(?:Android|Mac OS|Mac OS X|MacPPC|MacIntel|Mac_PowerPC|Macintosh) ([\.\_\d]+)/.exec(userAgent)[1];
          break;

        case 'iOS':
          osVersao = /OS (\d+)_(\d+)_?(\d+)?/.exec(appVersion);
          osVersao = osVersao[1] + '.' + osVersao[2] + '.' + (osVersao[3] | 0);
          break;
      }

      return os + ' ' + osVersao
    }

    self.getBrowser = function () {
      var userAgent = navigator.userAgent;
      var browser = navigator.appName;
      var versao = '' + parseFloat(navigator.appVersion);
      var versaoMaior = parseInt(navigator.appVersion, 10);
      var versaoIndex, nomeIndex, ix;

      // Opera
      if ((versaoIndex = userAgent.indexOf('Opera')) != -1) {
        browser = 'Opera';
        versao = userAgent.substring(versaoIndex + 6);
        if ((versaoIndex = userAgent.indexOf('Version')) != -1) {
          versao = userAgent.substring(versaoIndex + 8);
        }
      }
      // Opera Next
      if ((versaoIndex = userAgent.indexOf('OPR')) != -1) {
        browser = 'Opera';
        versao = userAgent.substring(versaoIndex + 4);
      }
      // Legacy Edge
      else if ((versaoIndex = userAgent.indexOf('Edge')) != -1) {
        browser = 'Microsoft Legacy Edge';
        versao = userAgent.substring(versaoIndex + 5);
      }
      // Edge (Chromium)
      else if ((versaoIndex = userAgent.indexOf('Edg')) != -1) {
        browser = 'Microsoft Edge';
        versao = userAgent.substring(versaoIndex + 4);
      }
      // MSIE
      else if ((versaoIndex = userAgent.indexOf('MSIE')) != -1) {
        browser = 'Microsoft Internet Explorer';
        versao = userAgent.substring(versaoIndex + 5);
      }
      // Chrome
      else if ((versaoIndex = userAgent.indexOf('Chrome')) != -1) {
        browser = 'Chrome';
        versao = userAgent.substring(versaoIndex + 7);
      }
      // Safari
      else if ((versaoIndex = userAgent.indexOf('Safari')) != -1) {
        browser = 'Safari';
        versao = userAgent.substring(versaoIndex + 7);
        if ((versaoIndex = userAgent.indexOf('Version')) != -1) {
          versao = userAgent.substring(versaoIndex + 8);
        }
      }
      // Firefox
      else if ((versaoIndex = userAgent.indexOf('Firefox')) != -1) {
        browser = 'Firefox';
        versao = userAgent.substring(versaoIndex + 8);
      }
      // MSIE 11+
      else if (userAgent.indexOf('Trident/') != -1) {
        browser = 'Microsoft Internet Explorer';
        versao = userAgent.substring(userAgent.indexOf('rv:') + 3);
      }
      // Outros
      else if ((nomeIndex = userAgent.lastIndexOf(' ') + 1) < (versaoIndex = userAgent.lastIndexOf('/'))) {
        browser = userAgent.substring(nomeIndex, versaoIndex);
        versao = userAgent.substring(versaoIndex + 1);
        if (browser.toLowerCase() == browser.toUpperCase()) {
          browser = navigator.appName;
        }
      }

      // trim the version string
      if ((ix = versao.indexOf(';')) != -1) versao = versao.substring(0, ix);
      if ((ix = versao.indexOf(' ')) != -1) versao = versao.substring(0, ix);
      if ((ix = versao.indexOf(')')) != -1) versao = versao.substring(0, ix);

      versaoMaior = parseInt('' + versao, 10);
      if (isNaN(versaoMaior)) {
        versao = '' + parseFloat(navigator.appVersion);
        versaoMaior = parseInt(navigator.appVersion, 10);
      }

      return browser + ' ' + versaoMaior + ' (' + versao + ')'
    }

    self.verificarDocumento = function (mr, doc) {
      var existe = $filter('filter')(self.ListaDocumentosAnexadosFamilia, { 'ID_CHECK_LIST_DOC_CAMPUS': doc.ID_CHECK_LIST_DOC_CAMPUS, 'IdPessoa': mr.ID_MEMBROS_FAMILIA });

      return existe && existe.length == 1 && existe[0].Status == "VAL";
    }

    self.verificarDocumentoFiador = function (mr, doc) {
      var existe = $filter('filter')(self.ListaDocumentosAnexadosFiador, { 'ID_CHECK_LIST_DOC_CAMPUS': doc.ID_CHECK_LIST_DOC_CAMPUS, 'IdPessoa': mr.ID_RESPONSAVEL_SERASA });

      return existe && existe.length == 1 && existe[0].Status == "VAL";
    }

    self.GerarSenhaPortalAluno = function () {

      var data = {
        cpf: self.lead.CPF.replace(/[^\d]+/g, ''),
        GerarNovaSenha: 'false',
        idCandidato: self.lead.ID_CANDIDATO,
        IdLogin: self.lead.IdLogin
      };


      $API.postUpload('/GerarGuid', data).then(function (r) {

        if (r) {
          window.location.href = API_SETTINGS[ENV].PORTAL_ALUNO_CREDUC + '/alterar-senha/?t=' + r.data.Dados + '&site=true';
        }

      }, function (err) {
        $log.error(err);
        DialogService.error({
          message: 'Ocorreu um erro ao gerar guid'
        });
      }, function (e) {
        $rootScope.modalComponentProgressPercentage = parseInt(100.0 * e.loaded / e.total);
      });

    }

    self.enviou = function (idPessoa, idCheklist, tipo) {
      var enviado = false;

      if (tipo == "fiador") {
        if ($filter('filter')(self.ListaDocumentosAnexadosFiador, { 'ID_CHECK_LIST_DOC_CAMPUS': idCheklist, 'IdPessoa': idPessoa, 'Enviado': true }).length > 0) {
          enviado = true;
          var divDoc = document.getElementById(idCheklist + "_" + idPessoa);
          if (divDoc != null) {
            divDoc.classList.add('btn-has-file')
          }
        } else {
          enviado = false;
        }

      }



      if (tipo == "familia") {

        if ($filter('filter')(self.ListaDocumentosAnexadosFamilia, { 'ID_CHECK_LIST_DOC_CAMPUS': idCheklist, 'IdPessoa': idPessoa, 'Enviado': true }).length > 0) {
          enviado = true;

          var divDoc1 = document.getElementById(idCheklist + "_" + idPessoa);
          if (divDoc1 != null) {
            divDoc1.classList.add('btn-has-file')
          }
        } else {
          enviado = false;
        }
      }



      return enviado;
    }


    self.MontarListaConsultores = function () {
      var data = {
        idInstituicaoFiltro: self.lead.instituicaoSelecionado.ID_PAI,
      };

      $API.post('api/Consultor/Filter', data).then(function (r) {

        if (r) {
          self.listaConsultor = r.data.ReturnData;
        }

      }, function () {

      }, function (e) {
        $rootScope.modalComponentProgressPercentage = parseInt(100.0 * e.loaded / e.total);
      });

    }

    self.getTituloRenda = function () {
      return self.instituicao.TEXTO_CAMPO_RENDA;
    };

    self.Menor = function (data) {
      return getIdade(data) < 18;
    };

    self.mudarRota = function (rota) {

      var ies = localStorage.getItem("lastInstituicao")
      $state.go('instituicao-inscricao-' + rota, { instituicao: ies });


    };

    self.mudarRotaTopo = function (rota) {

      var ies = localStorage.getItem("lastInstituicao");
      if (ENV == "DEV") {
        $state.go('instituicao-inscricao-' + rota, { instituicao: ies });

      }


    };

    self.gravaDadosaAcademicos = function () {
      var insc = JSON.parse(localStorage.getItem("_inscricao"));
      insc.lead = self.lead;
      insc.lead.alunoVeterano = self.alunoVeterano;
      insc.lead.estadoCivil = self.selected.estadoCivil;
      localStorage.setItem("_inscricao", JSON.stringify(insc));
    };
    self.getDicaRenda = function () {
      return self.instituicao.TEXTO_INFORMATIVO_RENDA;
    };

    //================================================================================================================================================
    // Consulta endereço a partir do CEP digitado
    //================================================================================================================================================        
    self.consultarCepAluno = function () {
      //////console.log(typeof self.lead.CEP);
      //////console.log(self.lead.CEP.length);
      if (self.lead && self.lead.CEP && self.lead.CEP.length == 8) {

        var url = '/endereco/cep/{idCep}';
        url = url.replace('{idCep}', self.lead.CEP);

        $API.get(url).then(function (result) {
          if (result.data.Dados) {
            self.enderecoAluno.UF = result.data.Dados.UF;
            self.enderecoAluno.LOGRADOURO = result.data.Dados.Logradouro;
            self.enderecoAluno.CIDADE = result.data.Dados.Cidade;
            self.enderecoAluno.BAIRRO = result.data.Dados.Bairro;
            self.enderecoAluno.ESTADO = result.data.Dados.Estado;
            self.enderecoAluno.CEP = result.data.Dados.CEP;
          }
        });
      }
    }

    //========================================
    //ConsultaAlunoAprovado
    //=======================================
    self.VerificarStatusAprovado = function () {
      var userInfo = JSON.parse(localStorage.getItem("user_info"));
      $API.get(API_SETTINGS[ENV].CREDUC_API + '/api/Candidato/VerificarStatusAprovado?cpf=' + userInfo.CPF + '&idCampus=' + userInfo.ID_CAMPUS + '&idCampusCurso=' + userInfo.CURSO.ID_CAMPUS_CURSO).then(function (res) {
        return res.data.ReturnData;
      },
        function (err) {
          if (err && err.status === 500) {
            DialogService.error({
              title: 'Ocorreu um problema interno no servidor.',
              message:
                'Ocorreu um problema interno no servidor. </br> Tente novamente. Se o problema persistir entre em contato com a instituição. </br>'
            });
          }
        });
    };

    //================================================================================================================================================
    // Consulta endereço a partir do CEP digitado
    //================================================================================================================================================        
    self.consultarCepAlunoRet = function () {
      //////console.log(typeof self.lead.CEP);
      //////console.log(self.lead.CEP.length);
      if (self.lead && self.lead.CEP && self.lead.CEP.length == 8) {

        var url = '/endereco/cep/{idCep}';
        url = url.replace('{idCep}', self.lead.CEP);

        $API.get(url).then(function (result) {
          if (result.data.Dados) {
            if ((self.enderecoAluno.UF == null || self.enderecoAluno.UF == '')) {
              self.enderecoAluno.UF = result.data.Dados.UF;
            }
            if (self.enderecoAluno.LOGRADOURO == null || self.enderecoAluno.LOGRADOURO == '') {
              self.enderecoAluno.LOGRADOURO = result.data.Dados.Logradouro;
            }
            if (self.enderecoAluno.CIDADE == null || self.enderecoAluno.CIDADE == '') {
              self.enderecoAluno.CIDADE = result.data.Dados.Cidade;
            }
            if (self.enderecoAluno.BAIRRO == null || self.enderecoAluno.BAIRRO == '') {
              self.enderecoAluno.BAIRRO = result.data.Dados.Bairro;
            }
            if (self.enderecoAluno.ESTADO == null || self.enderecoAluno.ESTADO == '') {
              self.enderecoAluno.ESTADO = result.data.Dados.Estado;
            }
            if (self.enderecoAluno.CEP == null || self.enderecoAluno.CEP == '') {
              self.enderecoAluno.CEP = result.data.Dados.CEP;
            }
          }
        });
      }
    }

    function fileExists(obj, index) {
      if (typeof obj === "object" && obj.hasOwnProperty(index)) {
        return true;
      }
      return false;
    }

    function removeFile(obj, index) {
      if (fileExists(obj, index)) {
        delete obj[index];
      }
    }

    function getParentescoDescricao(FL_PARENTESCO) {
      switch (FL_PARENTESCO) {
        case 'P': return 'Pai/Mãe';
        case 'I': return 'Irmão/Irmã';
        case 'F': return 'Filho/Filha';
        case 'R': return 'Primo/Prima';
        case 'A': return 'Avô/Avó';
        case 'T': return 'Tio/Tia';
        case 'O': return 'Outros';
        default: return '';
      }
    }

    function adicionarMembroResponsavel(tipoCadastro) {
      var responsavel = null;

      if (tipoCadastro == "fiador") {
        if (document.getElementById('PARENTESCO').value != '' && document.getElementById('PARENTESCO').value != null && (self.membroResponsavel == null || self.membroResponsavel.FL_PARENTESCO == null)) {

          self.membroResponsavel = {};
          self.membroResponsavel.NOME = document.getElementById('nome').value;
          self.membroResponsavel.CPF = document.getElementById('cpf').value.replace(".", "").replace(".", "").replace("-", "");
          var arrdt = document.getElementById('DT_NASCIMENTO').value.split('/');
          self.membroResponsavel.DT_NASCIMENTO = new Date(arrdt[2], arrdt[1], arrdt[0]);
          self.membroResponsavel.FL_PARENTESCO = document.getElementById('PARENTESCO').value;
          self.membroResponsavel.EMAIL = document.getElementById('EMAIL').value;
          localStorage.removeItem("inscricaoFK");
        }
        responsavel = angular.extend({}, self.membroResponsavel);
      } else if (tipoCadastro == "familia") {
        if (document.getElementById('PARENTESCO').value != '' && document.getElementById('PARENTESCO').value != null && (self.membroFamilia == null || self.membroFamilia.FL_PARENTESCO == null)) {

          self.membroFamilia = {};
          self.membroFamilia.NOME = document.getElementById('NOME').value;
          self.membroFamilia.CPF = document.getElementById('CPF').value.replace(".", "").replace(".", "").replace("-", "");
          var arrdt1 = document.getElementById('DT_NASCIMENTO').value.split('/');
          self.membroFamilia.DT_NASCIMENTO = new Date(arrdt1[2], arrdt1[1], arrdt1[0]);

   

          self.membroFamilia.FL_PARENTESCO = document.getElementById('PARENTESCO').value;
          self.membroFamilia.RENDA = parseFloat(document.getElementById('RENDA').value.replace("R$ ", "").replace(".", "").replace(".", "").replace(".", "").replace(".", "").replace(".", "").replace(",", "."));
          localStorage.removeItem("inscricaoFK");

        }
        

        

        responsavel = angular.extend({}, self.membroFamilia);
      }


      var isValid = true;
      var tipoResponsavel = tipoCadastro == "fiador" ? 'Responsável Financeiro' : 'Membro da família';

      var keys = ['NOME', 'DT_NASCIMENTO', 'FL_PARENTESCO'];

      if (typeof responsavel !== "object" || !Object.keys(responsavel).length) {

        isValid = false;
        DialogService.alert({
          message: 'Informe os dados de <b>' + tipoResponsavel + '</b> corretamente!'
        });
        return false;
      }

      angular.forEach(keys, function (e) {
        if (!responsavel.hasOwnProperty(e) || !responsavel[e]) {
          isValid = false;
        }
      });


      if (tipoCadastro == "fiador") {

        if (!responsavel.EMAIL && self.habilitaAceiteContratoOnline) {
          isValid = false;
          DialogService.alert({
            message: 'Informe um email</b>!'
          });
          return false;
        }

        if (!responsavel.CPF) {
          isValid = false;
          DialogService.alert({
            message: 'Informe um cpf válido</b>!'
          });
          return false;
        }

        if (self.lead && responsavel.hasOwnProperty('CPF') && responsavel.CPF == self.lead.CPF) {
          isValid = false;
          DialogService.alert({
            message: 'O CPF do <b>' + tipoResponsavel + '</b> não pode ser igual ao do candidato!'
          });
          return false;
        }
      } else if (tipoCadastro == "familia") {
        var idade = getIdade(responsavel.DT_NASCIMENTO);
        if (idade == 'NAN') {
          idade = 20;
        }

        if (!responsavel.CPF) {
          isValid = false;
          DialogService.alert({
            message: 'Informe um cpf válido</b>!'
          });
          return false;
        }

        if ((!responsavel.hasOwnProperty('CPF') || (responsavel.CPF == undefined || responsavel.CPF.CPF == '')) && (idade >= 18)) {
          isValid = false;
          DialogService.alert({
            message: 'O CPF para maiores de 18 anos é obrigatorio para <b>' + tipoResponsavel + '</b>!'
          });
          return false;
        }
      }

      var idaderesponsavel = getIdade(responsavel.DT_NASCIMENTO);

      if (tipoCadastro == "fiador" && (self.exibeResponsaveisFinanceiros() || self.exigeResponsaveisFinanceiros()) && responsavel.hasOwnProperty('DT_NASCIMENTO') && (idaderesponsavel < 18)) {
        isValid = false;
        DialogService.alert({
          message: 'O <b>' + tipoResponsavel + '</b> não pode ter idade menor que 18 anos!'
        });
        return false;
      }

      var listaMembros = null;

      if (tipoCadastro == "fiador") {
        listaMembros = self.corresponsaveisFinanceiros;
      } else if (tipoCadastro == "familia") {
        listaMembros = self.membrosFamilia;
      }

      if (listaMembros != null && responsavel.CPF != undefined && responsavel.CPF != '' && verificaCpfRepetido(listaMembros, responsavel.CPF)) {
        isValid = false;
        DialogService.alert({
          message: 'Você já adicionou um <b>' + tipoResponsavel + '</b> com o CPF informado. Por favor, informe outro CPF!'
        });
        return false;
      }

      if (!isValid) {
        DialogService.alert({
          message: 'Informe os dados de <b>' + tipoResponsavel + '</b> corretamente!'
        });
        return false;
      }

      if (tipoCadastro == 'familia') {
        self.SalvarMembroFamilia(responsavel);
      } else if (tipoCadastro == 'fiador') {
        self.SalvarResponsavelFinanceiro(responsavel);
      }

      self.membroResponsavel = {};
      self.membroFamilia = {};
      self.showFormFamilia = false;
      self.showFormFiador = false;
      window["limpaDadosTeste"]();


    }

    function removerMembroResponsavel(i, tipo, objeto) {
      if (tipo == "fiador") {
        self.RemoverResponsavelFinanceiro(i, tipo, objeto);
      } else if (tipo == "familia") {
        self.RemoverMembroFamilia(i, tipo, objeto);

      }
      window["limpaDadosTeste"]();
    }

    function verificaCpfRepetido(lista, CPF) {
      var repetido = false;
      angular.forEach(lista, function (e) {
        if (e.CPF == CPF) {
          repetido = true;
        }
      });
      return repetido;
    }
    self.exibeMembrosDaFamilia = function () {
      return exibeCampo("EXIBIR_CAMPO_PESSOAS_FAMILIA");
    }
    self.exigeMembrosDaFamilia = function () {
      return exibeCampo("EXIGIR_CAMPO_PESSOAS_FAMILIA");
    }
    function exibeCampo(parametro) {
      var exibe = false;
      var existe = $filter('filter')(self.parametros, { 'SLUG': parametro });

      if (self.parametros && existe != undefined && existe.length > 0 && existe[0].VALOR == "S") {

        return true;
      }
      return exibe;
    }

    function exibeDocumentos() {
      var ret = false;
      if (localStorage.getItem("docs") != null && JSON.parse(localStorage.getItem("docs")).length > 0) {
        ret = true;
      }

      return ret;
    }

    self.exibeResponsaveisFinanceiros = function () {

      return exibeCampo("EXIBIR_CAMPO_FIADOR");
    }
    self.exibeResponsaveisFinanceirosDoc = function () {

      if (self.corresponsaveisFinanceiros.length > 0) {
        return true;
      }
      return exibeCampo("EXIBIR_CAMPO_FIADOR");

    }

    self.exigeResponsaveisFinanceiros = function () {

      return exibeCampo("EXIGIR_CAMPO_FIADOR");
    }

    function getIdade(DT_NASCIMENTO) {
      var birth = new Date(DT_NASCIMENTO) || null;

      if (!birth) {
        return 0
      }

      var d = new Date(),
        currentMonth = d.getMonth() + 1,
        currentDay = d.getDate(),

        birthMonth = birth.getMonth() + 1,
        birthDay = birth.getDate(),

        age = d.getFullYear() - birth.getFullYear();

      if (currentMonth < birthMonth || (currentMonth == birthMonth && currentDay < birthDay)) {
        age--;
      }

      return age < 0 ? 0 : age;
    }

    function candidatoMenorIdade() {
      return getIdade(self.lead.DT_NASCIMENTO) < 18;
    }

    function exibeDadosResponsavel() {
      var rt = self.selected && self.selected.estadoCivil == 'SOL' && self && self.lead && self.lead.DT_NASCIMENTO && candidatoMenorIdade();
      if (rt) {
        self.lead.CONJUGE_NOME = null;
        self.lead.CONJUGE_CPF = null;
      }
      return rt;
    }

    function validaEndereco() {
      if ((self.enderecoAluno.LOGRADOURO == null || self.enderecoAluno.LOGRADOURO == '')
        || (self.enderecoAluno.ESTADO == null || self.enderecoAluno.ESTADO == '')
        || (self.enderecoAluno.BAIRRO == null || self.enderecoAluno.BAIRRO == '')
        || (self.enderecoAluno.NUMERO == null || self.enderecoAluno.NUMERO == '')) {
        return false;
      } else {
        return true;
      }
    }

    function exibeDadosConjuge() {
      var rt = self.selected && (self.selected.estadoCivil == 'CAS' || self.selected.estadoCivil == 'UES');
      if (rt) {
        self.lead.RESPONSAVEL_NOME = null;
        self.lead.RESPONSAVEL_CPF = null;
      }
      return rt;
    }

    function promiseEstadoSuccess(result) {
      self.estados = result.data.Dados;
      localStorage.setItem("estados", JSON.stringify(self.estados));
    }

    function deleteEmptyFile(files) {
      angular.forEach(Object.keys(files || []), function (k) {
        if (files.hasOwnProperty(k) && typeof files[k] === "object" && !files[k]) {
          delete files[k];
        }
      });
    }

    function clearEmptyFiles() {
      if (self.hasOwnProperty('lead') && self.lead) {
        deleteEmptyFile(self.lead.file);
      }

      if (self.hasOwnProperty('conjuge') && self.conjuge) {
        deleteEmptyFile(self.conjuge.file);
      }

      if (self.hasOwnProperty('responsavel') && self.responsavel) {
        deleteEmptyFile(self.responsavel.file);
      }

      angular.forEach(self.membrosFamilia || [], function (e) {
        deleteEmptyFile(e.file);
      });

      angular.forEach(self.corresponsaveisFinanceiros || [], function (e) {
        deleteEmptyFile(e.file);
      });
    }



    self.salvarPasso = function () {
      var inscricao = JSON.parse(localStorage.getItem("_inscricao"));
      ////console.log(inscricao);
      var jaAprovado = false;
      $API.get(API_SETTINGS[ENV].CREDUC_API + '/api/Candidato/VerificarStatusAprovado?idCandidato=' + inscricao.lead.ID_CANDIDATO).then(function (res) {
        jaAprovado = res.data.ReturnData;
        if (jaAprovado) {
          DialogService.error({
            message:
              'Candidato já aprovado. Não é possível modificar. </br>'
          });
          return false;
        } else {
          window.scrollTo(0, 0);

          switch (pId) {
            case 'dados-academicos':
              self.SalvarDadosAcademicos();
              break;
            case 'dados-pessoais':
              self.SalvarDadosPessoais();
              break;
            case 'dados-familia':
              self.SalvarDadosFamilia();
              break;
            case 'dados-financeiros':
              self.SalvarDadosFinanceiro();
              self.InfoPasso.BTNSalvar = "SALVAR DADOS FINANCEIROS";
              break;
            case 'termo-candidato':
              if (self.temPendenciaTermo && !self.temAceiteTermo) {
                self.aceitarTermo();
              } else {
                self.mudarPasso('termo-candidato', true);
              }
              
              self.InfoPasso.BTNSalvar = "SALVAR DADOS FINANCEIROS";
              break;
            case 'documentos-candidato':
              self.Concluir();
              self.InfoPasso.BTNPular = "PULAR ENVIO DE DOCUMENTOS";
              break;
            case 'pagar-taxa':
              self.mudarPasso('pagar-taxa', true);
              self.InfoPasso.BTNPular = "PULAR ENVIO DE DOCUMENTOS";
              break;
            case 'conclusao':
              self.Concluir();
              break;
          }
        };
      },
        function (err) {
          if (err && err.status === 500) {
            DialogService.error({
              title: 'Ocorreu um problema interno no servidor.',
              message:
                'Ocorreu um problema interno no servidor. </br> Tente novamente. Se o problema persistir entre em contato com a instituição. </br>'
            });
          }
        });
    }

    self.pulaDocumentos = function () {
      var $dialogProgress = DialogService.success({
        title: "Atenção!",
        message: 'Você não enviou todos os Documentos obrigatórios, deseja continuar assim mesmo? Lembre-se que você precisará retornar para finalizar sua inscrição',
        secondButton: ["Enviar Documentos", "Enviar Depois"]
      });
      $dialogProgress.result.then(function (resp) {
        if (resp) {
          $state.go('instituicao-inscricao-' + 'conclusao', { instituicao: self.instituicao.SITE });
        }
      });
    }

    self.ExibirPagamento = function () {
      if (localStorage.getItem("recebivel") != null) {
        var ret = JSON.parse(localStorage.getItem("recebivel"));
        if (ret.IdRecebivel > 0) {
          return true;
        } else {
          return false;

        }
      } else {

        return false;
      }

    }
    self.SalvarDadosAcademicos = function () {

      clearEmptyFiles();

      if (self.alunoVeterano == undefined || self.alunoVeterano == '') {
        DialogService.error({
          message: 'Preencha o campo: Em qual semestre você está matriculado nessa IES?'
        });
        return;
      }
      var verterna = self.alunoVeterano == 'Y' ? 'N' : self.alunoVeterano;
      var candidato = {
        ID_CAMPUS: self.lead.ID_CAMPUS,
        NOTA_ENEM: self.lead.NOTA_ENEM,
        FL_VETERANO: verterna,
        MATRICULA: self.lead.MATRICULA,
        ID_CANDIDATO: self.lead.ID_CANDIDATO,
        ID_CONSULTOR: self.idConsultor.IdConsultor
      };

      $rootScope.modalComponentProgressPercentage = 0;

      var $dialogProgress = DialogService.progress($rootScope.modalComponentProgressPercentage, {
        title: 'Salvando dados!'
      });

      // se tudo OK, chama a api com endpoint novo
      $API.postUpload('/candidato/SalvarDadosAcademicos', candidato).then(function () {

        $dialogProgress.close();

        var insc = JSON.parse(localStorage.getItem("_inscricao"));
        insc.passoDadosAcademicos = true;
        localStorage.setItem("_inscricao", JSON.stringify(insc));

        $state.go('instituicao-inscricao-dados-pessoais', {
          instituicao: self.instituicao.SITE
        });


      }, function (err) {
        $log.error(err);
        $dialogProgress.close();
        DialogService.error({
          message: 'Ocorreu um erro ao concluir a inscrição. Tente novamente!'
        });
      }, function (e) {
        $rootScope.modalComponentProgressPercentage = parseInt(100.0 * e.loaded / e.total);
      });
    }
    self.contrato = {};
    self.mudarPasso = function (passoAtual, conclusaoOk) {
      if (passoAtual == "dados-pessoais") {
        self.buscarVagasDisponiveis();
        if (self.exibeMembrosDaFamilia() || self.exigeMembrosDaFamilia()) {
          $state.go('instituicao-inscricao-dados-familia', {
            instituicao: self.instituicao.SITE
          });
        } else if (self.exibeResponsaveisFinanceiros() || self.exigeResponsaveisFinanceiros()) {
          $state.go('instituicao-inscricao-dados-financeiros', {
            instituicao: self.instituicao.SITE
          });
        } else if (exibeDocumentos()) {
          $state.go('instituicao-inscricao-documentos-candidato', {
            instituicao: self.instituicao.SITE
          });
        } else if (self.showPagamento) {
          self.conclusaoInscricao();
        } else {
          self.conclusaoInscricao();
        }
      } else if (passoAtual == "dados-membros-familia") {
        if (self.exibeResponsaveisFinanceiros() || self.exigeResponsaveisFinanceiros()) {
          $state.go('instituicao-inscricao-dados-financeiros', {
            instituicao: self.instituicao.SITE
          });
        } else if (exibeDocumentos()) {
          $state.go('instituicao-inscricao-documentos-candidato', {
            instituicao: self.instituicao.SITE
          });
        } else if (self.showPagamento) {
          self.conclusaoInscricao();
        } else {
          self.conclusaoInscricao();
        }
      }
      else if (passoAtual == "dados-financeiros") {
        if (self.paramTermoCompromisso == 'S') {
          $state.go('instituicao-inscricao-termo-candidato', {
            instituicao: self.instituicao.SITE
          });
        } else if (exibeDocumentos()) {
          $state.go('instituicao-inscricao-documentos-candidato', {
            instituicao: self.instituicao.SITE
          });
        } else if (self.showPagamento) {
          self.conclusaoInscricao();
        } else {
          if (conclusaoOk) {
            self.conclusaoInscricao();
          } else {
            $state.go('instituicao-inscricao-conclusao', {
              instituicao: self.instituicao.SITE
            });
          }

        }

      } else if (passoAtual == "documentos-candidato") {

        if (self.showPagamento) {
          self.conclusaoInscricao();
        }
        else {
          if (conclusaoOk) {
            self.conclusaoInscricao();
          } else {
            $state.go('instituicao-inscricao-conclusao', {
              instituicao: self.instituicao.SITE
            });
          }
        }


      } else if (passoAtual == "pagar-taxa") {

        $state.go('instituicao-inscricao-conclusao', {
          instituicao: self.instituicao.SITE
        });

      } else if (passoAtual == "termo-candidato") {
        if (exibeDocumentos()) {
          $state.go('instituicao-inscricao-documentos-candidato', {
            instituicao: self.instituicao.SITE
          });
        } else if (self.showPagamento) {
          self.conclusaoInscricao();
        } else {
          if (conclusaoOk) {
            self.conclusaoInscricao();
          } else {
            $state.go('instituicao-inscricao-conclusao', {
              instituicao: self.instituicao.SITE
            });
          }

        }

      }
      else if (passoAtual == "instituicao-inscricao-conclusao") {
        if (conclusaoOk) {
          self.conclusaoInscricao();
        }
      }

    }

    self.buscarVagasDisponiveis = function () {
      $API.postUpload('/candidato/BuscarVagasDisponiveis/?idCandidato=' + self.lead.ID_CANDIDATO, null).then(function (e) {

        if (e.data.Dados == false) {
          localStorage.setItem("vagasDisponiveis", "N");
        } else {
          localStorage.setItem("vagasDisponiveis", "S");
        }
      });

    };

    self.conclusaoInscricao = function () {
      localStorage.removeItem("recebivel");
      $API.postUpload('/candidato/Concluir/?id=' + self.lead.ID_CANDIDATO, null).then(function (e) {
        var ret = e.data.Dados.ReturnData;
        localStorage.setItem("recebivel", JSON.stringify(ret));
        if (self.showPagamento) {
          $state.go('instituicao-inscricao-pagar-taxa', {
            instituicao: self.instituicao.SITE
          });
        } else {
          $state.go('instituicao-inscricao-conclusao', {
            instituicao: self.instituicao.SITE
          });
        }


      }, function (err) {
        $log.error(err);

        DialogService.error({
          message: 'Ocorreu um erro ao concluir a inscrição. Tente novamente!'
        });
      }, function (e) {
        $rootScope.modalComponentProgressPercentage = parseInt(100.0 * e.loaded / e.total);
      });


    }

    self.AtualizarEnderecoAluno = function (idCandidato) {
      var endereco = {
        IdCandidato: idCandidato,
        UF: self.enderecoAluno.UF,
        Estado: self.enderecoAluno.ESTADO,
        Logradouro: self.enderecoAluno.LOGRADOURO,
        Bairro: self.enderecoAluno.BAIRRO,
        Cidade: self.enderecoAluno.CIDADE,
        Numero: self.enderecoAluno.NUMERO,
        Complemento: self.enderecoAluno.COMPLEMENTO
      };

      $API.post(API_SETTINGS[ENV].CREDUC_API + '/api/Candidato/AtuaizaEnderecoCandidato', endereco).then(function (res) {
        if (res.data.ReturnData == null) {
          DialogService.error({
            title: 'Erro ao gravar o endereço.',
            message: res.data.ReturnData.MensagemCustom
          });
        }
      },
        function (err) {
          if (err && err.status === 500) {
            DialogService.error({
              title: 'Erro ao gravar o endereço.',
              message:
                'Ocorreu um problema interno no servidor. </br> Tente novamente. Se o problema persistir entre em contato com a instituição. </br>'
            });
          }
        });
    }

    self.SalvarDadosPessoais = function () {

      clearEmptyFiles();

      if (document.getElementById('dtNascimento').value != '' && document.getElementById('dtNascimento').value != null && (self.lead.DT_NASCIMENTO == undefined || self.lead.DT_NASCIMENTO == null)) {


        var arrdt1 = document.getElementById('dtNascimento').value.split('/');
        self.lead.DT_NASCIMENTO = new Date(arrdt1[2], arrdt1[1], arrdt1[0]);

      }
      if (document.getElementById('cep').value != '' && document.getElementById('cep').value != null && (self.lead.CEP == undefined || self.lead.CEP == null)) {
        self.lead.CEP = document.getElementById('cep').value.replace('-', '');
      }

      if (document.getElementById('logradouro').value != '' && document.getElementById('logradouro').value != null && (self.enderecoAluno.LOGRADOURO == undefined || self.enderecoAluno.LOGRADOURO == null || self.enderecoAluno.LOGRADOURO == "")) {
        self.enderecoAluno.LOGRADOURO = document.getElementById('logradouro').value;
      }
      if (document.getElementById('bairro').value != '' && document.getElementById('bairro').value != null && (self.enderecoAluno.BAIRRO == undefined || self.enderecoAluno.BAIRRO == null || self.enderecoAluno.BAIRRO == "")) {
        self.enderecoAluno.BAIRRO = document.getElementById('bairro').value;
      }
      if (document.getElementById('cidade').value != '' && document.getElementById('cidade').value != null && (self.enderecoAluno.CIDADE == undefined || self.enderecoAluno.CIDADE == null || self.enderecoAluno.CIDADE == "")) {
        self.enderecoAluno.CIDADE = document.getElementById('cidade').value;
      }
      if (document.getElementById('estado').value != '' && document.getElementById('estado').value != null && (self.enderecoAluno.ESTADO == undefined || self.enderecoAluno.ESTADO == null || self.enderecoAluno.ESTADO == "")) {
        self.enderecoAluno.ESTADO = document.getElementById('estado').value;
      }
      if (document.getElementById('numero').value != '' && document.getElementById('numero').value != null && (self.enderecoAluno.NUMERO == undefined || self.enderecoAluno.NUMERO == null || self.enderecoAluno.NUMERO == "")) {
        self.enderecoAluno.NUMERO = document.getElementById('numero').value;
      }



      if (document.getElementById('estadocivil').value != '' && document.getElementById('estadocivil').value != null && (self.lead.estadoCivil == undefined || self.lead.estadoCivil == null)) {
        self.lead.estadoCivil = document.getElementById('estadocivil').value;
        self.selected.estadoCivil = document.getElementById('estadocivil').value;
      }

      var insc = JSON.parse(localStorage.getItem("_inscricao"));
      insc.lead = self.lead;
      localStorage.setItem("_inscricao", JSON.stringify(insc));


      if (self.lead.DT_NASCIMENTO == undefined || self.lead.DT_NASCIMENTO == null) {
        DialogService.error({
          message: 'Por favor preencha a data de nascimento!'
        });
        return;
      }
      if (self.lead.CEP == undefined || self.lead.CEP == null) {
        DialogService.error({
          message: 'Por favor preencha o CEP!'
        });
        return;
      }
      if (self.lead.estadoCivil == undefined || self.lead.estadoCivil == null) {
        DialogService.error({
          message: 'Por favor preencha o estado civil!'
        });
        return;
      }

      if (exibeDadosConjuge() && (self.lead.CONJUGE_CPF == null || self.lead.CONJUGE_CPF == '')) {
        DialogService.error({
          message: 'Por favor preencha o CPF do Cônjuge!'
        });
        return;
      }
      if (exibeDadosConjuge() && (self.lead.CONJUGE_NOME == null || self.lead.CONJUGE_NOME == '')) {
        DialogService.error({
          message: 'Por favor preencha o NOME do Cônjuge!'
        });
        return;
      }
      if (exibeDadosResponsavel() && (self.lead.RESPONSAVEL_CPF == null || self.lead.RESPONSAVEL_CPF == '')) {
        DialogService.error({
          message: 'Por favor preencha o CPF do Responsável!'
        });
        return;
      }
      if (exibeDadosResponsavel() && (self.lead.RESPONSAVEL_NOME == null || self.lead.RESPONSAVEL_NOME == '')) {
        DialogService.error({
          message: 'Por favor preencha o NOME do Responsável!'
        });
        return;
      }

      if (!validaEndereco()) {
        DialogService.error({
          message: 'Preencha corretamente o endereço!'
        });
        return;
      }

      var dtMon = null;
      if (self.lead.DT_NASCIMENTO.toString().indexOf('/') == -1)
        dtMon = self.lead.DT_NASCIMENTO;
      else {
        var dtMont = self.lead.DT_NASCIMENTO.split('/');
        dtMon = new Date(dtMont[2], dtMont[1] - 1, dtMont[0]);
      }



      //return;
      // mapeia
      var candidato = {
        ID_CAMPUS: self.lead.ID_CAMPUS,
        CPF: self.lead.CPF,
        NOME: self.lead.NOME.toUpperCase(),
        EMAIL: self.lead.EMAIL.toLowerCase(),
        CELULAR: self.lead.CELULAR,
        TELEFONE: self.lead.TELEFONE,
        DT_NASCIMENTO: dtMon,
        CEP: self.lead.CEP,
        FL_ESTADO_CIVIL: self.selected.estadoCivil,
        ID_CANDIDATO: self.lead.ID_CANDIDATO,
        CONJUGE_NOME: self.lead.CONJUGE_NOME,
        CONJUGE_CPF: self.lead.CONJUGE_CPF,
        RESPONSAVEL_NOME: self.lead.RESPONSAVEL_NOME,
        RESPONSAVEL_CPF: self.lead.RESPONSAVEL_CPF,
        UF: self.enderecoAluno.UF,
        ESTADO: self.enderecoAluno.ESTADO,
        LOGRADOURO: self.enderecoAluno.LOGRADOURO,
        BAIRRO: self.enderecoAluno.BAIRRO,
        CIDADE: self.enderecoAluno.CIDADE,
        NUMERO: self.enderecoAluno.NUMERO,
        COMPLEMENTO: self.enderecoAluno.COMPLEMENTO,
      };

      $rootScope.modalComponentProgressPercentage = 0;

      var $dialogProgress = DialogService.progress($rootScope.modalComponentProgressPercentage, {
        title: 'Salvando dados!'
      });

      // se tudo OK, chama a api com endpoint novo
      $API.postUpload('/candidato/SalvarDadosPessoais', candidato).then(function (saida) {
        self.AtualizarEnderecoAluno(candidato.ID_CANDIDATO);

        $dialogProgress.close();

        var insc = JSON.parse(localStorage.getItem("_inscricao"));
        insc.lead.ID_CANDIDATO_RESPONSAVEL = saida.data.Dados.ID_CANDIDATO_RESPONSAVEL;
        insc.lead.ID_CANDIDATO_CONJUGE = saida.data.Dados.ID_CANDIDATO_CONJUGE;

        insc.passoDadosPessoais = true;
        localStorage.setItem("_inscricao", JSON.stringify(insc));

        self.mudarPasso('dados-pessoais', true);



      }, function (err) {
        $log.error(err);
        $dialogProgress.close();
        DialogService.error({
          message: 'Ocorreu um erro ao concluir a inscrição. Tente novamente!'
        });
      }, function (e) {
        $rootScope.modalComponentProgressPercentage = parseInt(100.0 * e.loaded / e.total);
      });
    }

    self.SalvarMembroFamilia = function (responsavel) {


      clearEmptyFiles();


      // mapeia
      var objeto = {
        ID_CAMPUS: self.lead.ID_CAMPUS,
        ID_CANDIDATO: self.lead.ID_CANDIDATO,
        MEMBROS_FAMILIA: [{
          NOME: self.membroFamilia.NOME,
          CPF: self.membroFamilia.CPF,
          DT_NASCIMENTO: self.membroFamilia.DT_NASCIMENTO,
          FL_PARENTESCO: self.membroFamilia.FL_PARENTESCO,
          RENDA: self.membroFamilia.RENDA,
        }]
      };


      $rootScope.modalComponentProgressPercentage = 0;

      var $dialogProgress = DialogService.progress($rootScope.modalComponentProgressPercentage, {
        title: 'Salvando dados!'
      });

      // se tudo OK, chama a api com endpoint novo
      $API.postUpload('/candidato/SalvarMembroFamilia', objeto).then(function (r) {

        $dialogProgress.close();
        responsavel.ID_MEMBROS_FAMILIA = r.data.Dados;
        self.membrosFamilia.push(responsavel);
        var insc = JSON.parse(localStorage.getItem("_inscricao"));

        insc.membrosFamilia = self.membrosFamilia;
        localStorage.setItem("_inscricao", JSON.stringify(insc));
        self.rendaPercapita();

      }, function (err) {
        $log.error(err);
        $dialogProgress.close();
        DialogService.error({
          message: 'Ocorreu um erro ao concluir a inscrição. Tente novamente!'
        });
      }, function (e) {
        $rootScope.modalComponentProgressPercentage = parseInt(100.0 * e.loaded / e.total);
      });
    }
    self.RemoverMembroFamilia = function (i, tipo, objeto) {



      clearEmptyFiles();


      // mapeia
      var objetosend = {
        ID_CAMPUS: self.lead.ID_CAMPUS,
        ID_CANDIDATO: self.lead.ID_CANDIDATO,
        MEMBROS_FAMILIA: [{
          NOME: objeto.NOME,
          CPF: objeto.CPF,
          DT_NASCIMENTO: objeto.DT_NASCIMENTO,
          FL_PARENTESCO: objeto.FL_PARENTESCO,
          RENDA: objeto.RENDA,
          ID_MEMBROS_FAMILIA: objeto.ID_MEMBROS_FAMILIA,
        }]
      };


      $rootScope.modalComponentProgressPercentage = 0;

      var $dialogProgress = DialogService.progress($rootScope.modalComponentProgressPercentage, {
        title: 'Salvando dados!'
      });

      // se tudo OK, chama a api com endpoint novo
      $API.postUpload('/candidato/RemoverMembroFamilia', objetosend).then(function () {
        $dialogProgress.close();
        self.membrosFamilia.splice(i, 1);
        var insc = JSON.parse(localStorage.getItem("_inscricao"));

        insc.membrosFamilia = self.membrosFamilia;
        localStorage.setItem("_inscricao", JSON.stringify(insc));
        self.rendaPercapita();

      }, function (err) {
        $log.error(err);
        $dialogProgress.close();
        DialogService.error({
          message: 'Ocorreu um erro ao concluir a inscrição. Tente novamente!'
        });
      }, function (e) {
        $rootScope.modalComponentProgressPercentage = parseInt(100.0 * e.loaded / e.total);
      });
    }

    self.RemoverResponsavelFinanceiro = function (i, tipo, objeto) {



      clearEmptyFiles();


      // mapeia
      var objetosend = {
        ID_CAMPUS: self.lead.ID_CAMPUS,
        ID_CANDIDATO: self.lead.ID_CANDIDATO,
        RESPONSAVEL_SERASA: [{
          NOME: objeto.NOME,
          CPF: objeto.CPF,
          DT_NASCIMENTO: objeto.DT_NASCIMENTO,
          FL_PARENTESCO: objeto.FL_PARENTESCO,
          RENDA: objeto.RENDA,
          ID_RESPONSAVEL_SERASA: objeto.ID_RESPONSAVEL_SERASA,
        }]
      };


      $rootScope.modalComponentProgressPercentage = 0;

      var $dialogProgress = DialogService.progress($rootScope.modalComponentProgressPercentage, {
        title: 'Salvando dados!'
      });

      // se tudo OK, chama a api com endpoint novo
      $API.postUpload('/candidato/RemoverResponsavelFinanceiro', objetosend).then(function () {
        $dialogProgress.close();
        self.corresponsaveisFinanceiros.splice(i, 1);
        var insc = JSON.parse(localStorage.getItem("_inscricao"));

        insc.corresponsaveisFinanceiros = self.corresponsaveisFinanceiros;
        localStorage.setItem("_inscricao", JSON.stringify(insc));
      }, function (err) {
        $log.error(err);
        $dialogProgress.close();
        DialogService.error({
          message: 'Ocorreu um erro ao concluir a inscrição. Tente novamente!'
        });
      }, function (e) {
        $rootScope.modalComponentProgressPercentage = parseInt(100.0 * e.loaded / e.total);
      });
    }

    self.SalvarResponsavelFinanceiro = function (responsavel) {


      clearEmptyFiles();


      // mapeia
      var objeto = {
        ID_CAMPUS: self.lead.ID_CAMPUS,
        ID_CANDIDATO: self.lead.ID_CANDIDATO,
        RESPONSAVEL_SERASA: [responsavel]
      };


      $rootScope.modalComponentProgressPercentage = 0;

      var $dialogProgress = DialogService.progress($rootScope.modalComponentProgressPercentage, {
        title: 'Salvando dados!'
      });

      // se tudo OK, chama a api com endpoint novo
      $API.postUpload('/candidato/SalvarResponsavelFinanceiro', objeto).then(function (r) {

        $dialogProgress.close();
        responsavel.ID_RESPONSAVEL_SERASA = r.data.Dados;
        self.corresponsaveisFinanceiros.push(responsavel);
        var insc = JSON.parse(localStorage.getItem("_inscricao"));

        insc.corresponsaveisFinanceiros = self.corresponsaveisFinanceiros;
        localStorage.setItem("_inscricao", JSON.stringify(insc));
        self.membroResponsavel = {};

      }, function (err) {
        $log.error(err);
        $dialogProgress.close();
        DialogService.error({
          message: 'Ocorreu um erro ao concluir a inscrição. Tente novamente!'
        });
      }, function (e) {
        $rootScope.modalComponentProgressPercentage = parseInt(100.0 * e.loaded / e.total);
      });
    }

    self.SalvarDadosFamilia = function () {

      var existe = $filter('filter')(self.parametros, { 'SLUG': "EXIGIR_CAMPO_PESSOAS_FAMILIA" });

      var EXIGIR_CAMPO_PESSOAS_FAMILIA = existe != undefined && existe.length > 0 && existe[0].VALOR == 'S';

      if (EXIGIR_CAMPO_PESSOAS_FAMILIA && (self.membrosFamilia == undefined || self.membrosFamilia.length == 0)) {
        DialogService.error({
          message: 'Adicione no mínimo um membro da família!'
        });
        return;
      }

      existe = $filter('filter')(self.parametros, { 'SLUG': "SOLICITAR_RENDA" });
      self.instituicao.SOLICITAR_RENDA = existe != undefined && existe.length > 0 && existe[0].VALOR == 'S';

      if (self.instituicao.SOLICITAR_RENDA && (self.lead.RENDA == undefined || self.lead.RENDA <= 0)) {
        DialogService.error({
          message: 'Preencha o campo RENDA PER CAPITA!'
        });
        return;
      }
      var objeto = {
        ID_CAMPUS: self.lead.ID_CAMPUS,
        ID_CANDIDATO: self.lead.ID_CANDIDATO,
        RENDA: self.lead.RENDA
      };


      $rootScope.modalComponentProgressPercentage = 0;

      var $dialogProgress = DialogService.progress($rootScope.modalComponentProgressPercentage, {
        title: 'Salvando dados!'
      });

      // se tudo OK, chama a api com endpoint novo
      $API.postUpload('/candidato/SalvarPassoMembroFamilia', objeto).then(function () {

        $dialogProgress.close();
        var insc = JSON.parse(localStorage.getItem("_inscricao"));
        insc.passoDadosMembrosFamilia = true;
        insc.lead.RENDA = self.lead.RENDA;
        localStorage.setItem("_inscricao", JSON.stringify(insc));
        self.mudarPasso('dados-membros-familia', true);



      }, function (err) {
        $log.error(err);
        $dialogProgress.close();
        DialogService.error({
          message: 'Ocorreu um erro ao concluir a inscrição. Tente novamente!'
        });
      }, function (e) {
        $rootScope.modalComponentProgressPercentage = parseInt(100.0 * e.loaded / e.total);
      });


    }
    self.SalvarDadosFinanceiro = function () {
      if (self.corresponsaveisFinanceiros == undefined || self.corresponsaveisFinanceiros.length == 0) {
        DialogService.error({
          message: 'Preencha no mínimo 1 corresponsável financeiro!'
        });
      } else {
        var objeto = {
          ID_CAMPUS: self.lead.ID_CAMPUS,
          ID_CANDIDATO: self.lead.ID_CANDIDATO
        };


        $rootScope.modalComponentProgressPercentage = 0;

        var $dialogProgress = DialogService.progress($rootScope.modalComponentProgressPercentage, {
          title: 'Salvando dados!'
        });

        // se tudo OK, chama a api com endpoint novo
        $API.postUpload('/candidato/SalvarDadosFinanceiro', objeto).then(function () {


          $dialogProgress.close();
          var insc = JSON.parse(localStorage.getItem("_inscricao"));
          insc.passoDadosFinanceiros = true;
          localStorage.setItem("_inscricao", JSON.stringify(insc));

          self.mudarPasso('dados-financeiros', true);


        }, function (err) {
          $log.error(err);
          $dialogProgress.close();
          DialogService.error({
            message: 'Ocorreu um erro ao salvar os dados, tente novamente!'
          });
        }, function (e) {
          $rootScope.modalComponentProgressPercentage = parseInt(100.0 * e.loaded / e.total);
        });

      }

    }

    self.uploadImage = function (doc, file, tipo, item, descricao) {      

      if (file != null) {

        var data = {
          files: file
        };
        var inscricao = JSON.parse(localStorage.getItem("_inscricao"));
        var idPessoa = 0;
        var idDoc = 0;
        var desc= descricao;

        if (tipo == "candidatoconjuge") {
          idPessoa = inscricao.lead.ID_CANDIDATO_CONJUGE;
          idDoc = doc.ID_CHECK_LIST_DOC_CAMPUS;
        }

        else if (tipo == "Responsavelserasa") {
          idPessoa = item.ID_RESPONSAVEL_SERASA;
          idDoc = doc.ID_CHECK_LIST_DOC_CAMPUS + "_" + item.ID_RESPONSAVEL_SERASA;
        }


        if (tipo == "membrosfamilia") {

          idPessoa = item.ID_MEMBROS_FAMILIA;
          idDoc = doc.ID_CHECK_LIST_DOC_CAMPUS + '_' + item.ID_MEMBROS_FAMILIA;
        }

        if (tipo == 'Responsavel') {
          idPessoa = inscricao.lead.ID_CANDIDATO_RESPONSAVEL;
          idDoc = doc.ID_CHECK_LIST_DOC_CAMPUS;
        }

        var addSpinner = document.getElementById(idDoc);
        if (addSpinner != null) {
          addSpinner.classList.add('spinner')
        }

        $API
          .upload('api/arquivo/UploadArquivosInscricao/?tipo=' + tipo + '&IdCandidato=' + inscricao.lead.ID_CANDIDATO + '&Id=' + doc.ID_CHECK_LIST_DOC_CAMPUS + '&IdPessoa=' + idPessoa + '&descricao=' + doc.DESCRICAO, data)
          .then(function (e) {

            if (inscricao.lead.listaArquivos == null || inscricao.lead.listaArquivos == undefined) {
              inscricao.lead.listaArquivos = [];
            }
            if (self.lead.listaArquivos == null || self.lead.listaArquivos == undefined) {
              self.lead.listaArquivos = [];
            }

            var documentoPessoa = { 'ID_CHECK_LIST_DOC_CAMPUS': doc.ID_CHECK_LIST_DOC_CAMPUS, 'IdPessoa': idPessoa };
            var subiu = $filter('filter')(self.lead.listaArquivos, documentoPessoa);
            if (subiu == undefined || subiu.length == 0) {
              inscricao.lead.listaArquivos.push(documentoPessoa);
              self.lead.listaArquivos.push(documentoPessoa);

            }
            var item = [];
            if (e.data.StrCode == "ResulOk") {
              var obj = { ID_CHECK_LIST_DOC_CAMPUS: doc.ID_CHECK_LIST_DOC_CAMPUS, NOME_DOCUMENTO: tipo, Status: "ENV", IdPessoa: idPessoa };

              if (tipo == "candidato") {
                item = $filter('filter')(self.ListaDocumentosAnexadosAluno, doc.ID_CHECK_LIST_DOC_CAMPUS);
                if (item == undefined || item.length == 0) {
                  self.ListaDocumentosAnexadosAluno.push(obj);
                  inscricao.lead.documentosAluno = self.ListaDocumentosAnexadosAluno;

                  var divDoc4 = document.getElementById(doc.ID_CHECK_LIST_DOC_CAMPUS);
                  if (divDoc4 != null) {
                    divDoc4.classList.add('btn-has-file')
                  }
                }
              }

              if (tipo == "candidatoconjuge") {
                item = $filter('filter')(self.ListaDocumentosAnexadosConjuge, doc.ID_CHECK_LIST_DOC_CAMPUS);
                if (item == undefined || item.length == 0) {
                  self.ListaDocumentosAnexadosConjuge.push(obj);
                  inscricao.lead.documentosConjuge = self.ListaDocumentosAnexadosConjuge;
                }
              }

              if (tipo == "Responsavel") {
                item = $filter('filter')(self.ListaDocumentosAnexadosAluno, doc.ID_CHECK_LIST_DOC_CAMPUS);
                if (item == undefined || item.length == 0) {
                  self.ListaDocumentosAnexadosResponsavel.push(obj);
                  inscricao.lead.documentosResponsavel = self.ListaDocumentosAnexadosResponsavel;
                }

                var divDoc5 = document.getElementById(doc.ID_CHECK_LIST_DOC_CAMPUS + "_" + doc.IdPessoa);
                if (divDoc5 != null) {
                  divDoc5.classList.add('btn-has-file')
                }
              }

              if (tipo == "Responsavelserasa") {
                item = $filter('filter')(self.ListaDocumentosAnexadosFiador, documentoPessoa);
                if (item == undefined || item.length == 0) {
                  self.ListaDocumentosAnexadosFiador.push(obj);
                  inscricao.lead.documentosFiador = self.ListaDocumentosAnexadosFiador;

                }


                var divDoc6 = document.getElementById(doc.ID_CHECK_LIST_DOC_CAMPUS + "_" + doc.IdPessoa);
                if (divDoc6 != null) {
                  divDoc6.classList.add('btn-has-file')
                }
              }

              if (tipo == "membrosfamilia") {
                item = $filter('filter')(self.ListaDocumentosAnexadosFamilia, documentoPessoa);
                if (item == undefined || item.length == 0) {
                  self.ListaDocumentosAnexadosFamilia.push(obj);

                  inscricao.lead.documentosFamilia = self.ListaDocumentosAnexadosFamilia;
                }
                var divDoc7 = document.getElementById(doc.ID_CHECK_LIST_DOC_CAMPUS + "_" + doc.IdPessoa);
                if (divDoc7 != null) {
                  divDoc7.classList.add('btn-has-file')
                }
              }

              if (addSpinner != null) {
                addSpinner.classList.add('btn-has-file')
              }
            }

            localStorage.setItem("_inscricao", JSON.stringify(inscricao));
            if (addSpinner != null) {
              addSpinner.classList.remove('spinner')
            }
          }, function () {
            DialogService.alert({
              message: 'Não foi possível enviar o arquivo, tente novamente!!'
            });
          });

      }
      
    }

    self.VerificarArquivo = function (idfile) {
      var inscricao = JSON.parse(localStorage.getItem("_inscricao"));
      if (inscricao.lead.docs != undefined) {
        for (var i = 0; i < inscricao.lead.docs.length; i++) {

          if (inscricao.lead.docs[i] == idfile) {
            i = inscricao.lead.docs.length + 2;
            return true;
          }
        }
      }
    }

    self.rendaPercapita = function () {

      var valor = 0;
      if (self.membrosFamilia != null) {
        var _familiaRenda = self.membrosFamilia;

        var aux = 0


        for (var i = 0; i < _familiaRenda.length; i++) {

          aux = _familiaRenda[i].RENDA;
          valor = (valor + aux);


        }
        self.lead.RENDA = (valor / (_familiaRenda.length + 1));

      } else {
        self.lead.RENDA = 0;
      }


    }

    self.exibeCampoMatricula = function () {
      var exibe = false;

      if (self.alunoVeterano == 'S' || self.alunoVeterano == 'Y') {
        exibe = true;
      } else {
        exibe = false;
      }

      return exibe;
    }
    self.exibeCampoNotaEnem = function () {
      var exibe = false;
      exibe = exibeCampo("EXIBIR_CAMPO_NOTA_ENEM");

      if (exibe && self.alunoVeterano == 'N') {
        exibe = true;
      } else {
        exibe = false;
      }

      return exibe;
    }
    self.exibirSolicitaRenda = function () {
      return exibeCampo("SOLICITAR_RENDA")
    }



    self.Concluir = function () {
      if (self.lead.listaArquivos == undefined) {
        self.lead.listaArquivos = [];
      }
      var ok = true;



      ok = true;
      angular.forEach(self.documentosAluno, function (e) {
        if (e.OBRIGATORIO && ok) {
          var subiu = $filter('filter')(self.lead.listaArquivos, e.ID_CHECK_LIST_DOC_CAMPUS);
          var subiuAntes = $filter('filter')(self.lead.documentosAluno, e.ID_CHECK_LIST_DOC_CAMPUS);
          if ((subiu == undefined || subiu.length == 0) && (subiuAntes == undefined || subiuAntes.length == 0)) {

            var $dialogProgress = DialogService.success({
              title: "Atenção!",
              // message: "É necessário anexar todos os documentos obrigatórios do aluno!",
              message: 'Você não enviou todos os Documentos obrigatórios, deseja continuar assim mesmo? Lembre-se que você precisará retornar para finalizar sua inscrição',
              secondButton: ["Enviar Documentos", "Enviar Depois"]
            });
            $dialogProgress.result.then(function (resp) {
              if (resp) {
                self.mudarPasso('documentos-candidato', false);
                // $state.go('instituicao-inscricao-' + 'conclusao', { instituicao: self.instituicao.SITE });
              }
            });
            ok = false;
            return;
          }
        }
      });

      if (!ok) {
        return
      }
      ok = true;
      if (exibeDadosConjuge()) {

        angular.forEach(self.documentosConjuge, function (e) {
          if (e.OBRIGATORIO && ok) {
            var subiu = $filter('filter')(self.lead.listaArquivos, e.ID_CHECK_LIST_DOC_CAMPUS);
            var subiuAntes = $filter('filter')(self.lead.documentosConjuge, e.ID_CHECK_LIST_DOC_CAMPUS);
            if ((subiu == undefined || subiu.length == 0) && (subiuAntes == undefined || subiuAntes.length == 0)) {
              var $dialogProgress = DialogService.success({
                title: "Atenção!",
                message: 'Você não enviou todos os Documentos obrigatórios, deseja continuar assim mesmo? Lembre-se que você precisará retornar para finalizar sua inscrição',
                secondButton: ["Enviar Documentos", "Enviar Depois"]
              });
              $dialogProgress.result.then(function (resp) {
                if (resp) {
                  self.mudarPasso('documentos-candidato', false);
                }
              });
              ok = false;
              return;
            }
          }
        });
        if (!ok) {
          return
        }
      }
      ok = true;
      if (exibeDadosResponsavel()) {

        angular.forEach(self.documentosResponsavel, function (e) {
          if (e.OBRIGATORIO && ok) {
            var subiu = $filter('filter')(self.lead.listaArquivos, e.ID_CHECK_LIST_DOC_CAMPUS);
            var subiuAntes = $filter('filter')(self.lead.documentosResponsavel, e.ID_CHECK_LIST_DOC_CAMPUS);
            if ((subiu == undefined || subiu.length == 0) && (subiuAntes == undefined || subiuAntes.length == 0)) {
              var $dialogProgress = DialogService.success({
                title: "Atenção!",
                message: 'Você não enviou todos os Documentos obrigatórios, deseja continuar assim mesmo? Lembre-se que você precisará retornar para finalizar sua inscrição',
                secondButton: ["Enviar Documentos", "Enviar Depois"]
              });
              $dialogProgress.result.then(function (resp) {
                if (resp) {
                  self.mudarPasso('documentos-candidato', false);
                }
              });
              ok = false;
              return;
            }
          }
        });

      }
      ok = true;

      if (self.exibeMembrosDaFamilia()) {
        angular.forEach(self.membrosFamilia, function (f) {
          angular.forEach(self.documentosFamilia, function (e) {
            if (e.OBRIGATORIO && ok) {
              var subiu = $filter('filter')(self.lead.listaArquivos, { ID_CHECK_LIST_DOC_CAMPUS: e.ID_CHECK_LIST_DOC_CAMPUS, IdPessoa: f.ID_MEMBROS_FAMILIA });
              var subiuAntes = $filter('filter')(self.lead.documentosFamilia, e.ID_CHECK_LIST_DOC_CAMPUS);
              if ((subiu == undefined || subiu.length == 0) && (subiuAntes == undefined || subiuAntes.length == 0)) {
                var $dialogProgress = DialogService.success({
                  title: "Atenção!",
                  message: 'Você não enviou todos os Documentos obrigatórios, deseja continuar assim mesmo? Lembre-se que você precisará retornar para finalizar sua inscrição',
                  secondButton: ["Enviar Documentos", "Enviar Depois"]
                });
                $dialogProgress.result.then(function (resp) {
                  if (resp) {
                    self.mudarPasso('documentos-candidato', false);
                  }
                });
                ok = false;
                return;
              }
            }
          });
        });
      }
      if (!ok) {
        return
      }

      if (self.exibeResponsaveisFinanceirosDoc() && self.documentosFiador.length) {
        angular.forEach(self.corresponsaveisFinanceiros, function (f) {
          angular.forEach(self.documentosFiador, function (e) {

            if (e.OBRIGATORIO && ok) {
              var subiu = $filter('filter')(self.lead.listaArquivos, { ID_CHECK_LIST_DOC_CAMPUS: e.ID_CHECK_LIST_DOC_CAMPUS, IdPessoa: f.ID_RESPONSAVEL_SERASA });

              var subiuAntes = $filter('filter')(self.lead.documentosFiador, e.ID_CHECK_LIST_DOC_CAMPUS);
              if ((subiu == undefined || subiu.length == 0) && (subiuAntes == undefined || subiuAntes.length == 0)) {
                var $dialogProgress = DialogService.success({
                  title: "Atenção!",
                  message: 'Você não enviou todos os Documentos obrigatórios, deseja continuar assim mesmo? Lembre-se que você precisará retornar para finalizar sua inscrição',
                  secondButton: ["Enviar Documentos", "Enviar Depois"]
                });
                $dialogProgress.result.then(function (resp) {
                  if (resp) {
                    self.mudarPasso('documentos-candidato', false);
                  }
                });
                ok = false;
                return;
              }
            }
          });
        });

        if (!ok) {
          return
        }
      }
      var insc = JSON.parse(localStorage.getItem("_inscricao"));
      insc.passoDadosDocumentos = true;
      localStorage.setItem("_inscricao", JSON.stringify(insc));

      self.mudarPasso('instituicao-inscricao-conclusao', true);

    }




    self.verificarPendenciaAluno = function () {
      var candInfo = JSON.parse(localStorage.getItem('_inscricao'));
      var url = API_SETTINGS[ENV].CREDUC_API + '/api/Aluno/VerificarPendenciaAluno/?cpf=' + candInfo.lead.CPF.replace('.', '').replace('.', '').replace('-', '') + '&idAluno=' + candInfo.lead.ID_CANDIDATO + '&idCampus=' + candInfo.lead.ID_CAMPUS;

      $API.get(url).then(function (result) {
        if (result.data.ReturnData != null && result.data.ReturnData.length > 0) {
          var resultado = result.data.ReturnData.find(function (p) { return p.TipoPendencia.trim() == "TERMO_COMPROMISSO" });
          if (resultado != null) {
            self.nomeArquivo = $sce.trustAsResourceUrl("https://docs.google.com/gview?url=http://static.creduc.com.br/contrato/TermoCompromisso" + resultado.Chave + ".docx&embedded=true");
            
            //self.nomeArquivo = window.open("C:\inetpub\wwwroot\creduc_static\contrato\TermoCompromisso" + resultado.Chave + ".docx&embedded=true");
            self.Chave = resultado.Chave;
            self.temPendenciaTermo = true;
            self.aceite = "aceite-termo"
            var insc = JSON.parse(localStorage.getItem("_inscricao"));
            insc.passoDadosTermoCompromiso = true;
            localStorage.setItem("_inscricao", JSON.stringify(insc));
            self.InfoPasso.BTNSalvar = "ACEITAR";
          }
        } else {
          var url = API_SETTINGS[ENV].CREDUC_API + '/api/Aluno/VerificaSeExisteAceiteTermo/?idCandidato=' + candInfo.lead.ID_CANDIDATO;
          $API.get(url).then(function (result) {
            if (result.data.ReturnData != null && result.data.ReturnData == true) {
              self.temAceiteTermo = true;
              var insc = JSON.parse(localStorage.getItem("_inscricao"));
              insc.passoDadosTermoCompromiso = true;
              localStorage.setItem("_inscricao", JSON.stringify(insc));
              self.InfoPasso.BTNSalvar = "PROSSEGUIR";
            }
          })
        }
      }, function () {
        DialogService.success({
          title: 'Atencão',
          message: 'Houve um erro ao verificar pendências. </br>'
        });
      });

    }


    self.aceitarTermo = function () {

      var url = API_SETTINGS[ENV].CREDUC_API;

      url = url + '/api/ContratoAceite/AceiteTermoCompromisso/?chave=' + self.Chave + '&userIp=' + self.userIp;

      $API.get(url).then(function (result) {
        if (result.data.ReturnData != null) {
          self.mudarPasso('termo-candidato', true);
          DialogService.success({
            title: 'Atencão',
            message: result.data.MessageAlert
          });
        }
      }, function () {
        DialogService.success({
          title: 'Atencão',
          message: 'Houve um erro ao aceitar o termo. </br>'
        });
      });

    }

    self.buscarIP = function () {

      $.getJSON("https://api.ipify.org?format=jsonp&callback=?",
        function (json) {
          self.userIp = json.ip;
        }
      );
    }


  }

})();

(function () {
  'use strict';

  angular
    .module('creduc.controllers')
    .controller('HomeController', HomeController);

  /** @ngInject */
  function HomeController($stateParams, $scope, $filter, $location, $anchorScroll, DialogService, $uibModal, $API) {
    var self = this;

    self.slides = [];

    var min = 1;
    var max = 6;
    self.random = parseInt(Math.random() * (+max - +min) + +min);

    self.imgURL = 'ies' + self.random + '.jpg';
    self.imgURLA = 'aluno' + self.random + '.jpg';

    self.NomeCidade = '';
    self.inputInstituicao = '';
    self.modalCadastroOpen = false;
    self.selected = {};

    $scope.campi = [];

    $scope.Escolha = false;
    localStorage.removeItem("parametros");
    localStorage.removeItem("inscricoes");
    localStorage.removeItem("_inscricao");
    localStorage.removeItem("inscricaoFK");

    self.$onInit = function () {

      if ($location.search().new == 1) {
        localStorage.setItem("Escolha", 3);
        document.location = '/';
      } else if ($location.search().new == 4) {
        localStorage.removeItem("Escolha")
        document.location = '/';
      }
      
      if (localStorage.getItem("Escolha") == null) {
        $scope.Escolha = false;
      } else if (localStorage.getItem("Escolha") == 3) {
        $scope.Escolha = true;
      }

      self.slides.push({
        title: 'Slide 1',
        src: {
          sm: $filter('assets_url')('images/CREDUC-slide-480x340.jpg'),
          md: $filter('assets_url')('images/CREDUC-slide-1024x400.jpg'),
          lg: $filter('assets_url')('images/CREDUC-slide-1500x420.jpg')
        }
      });
    }

    $scope.buscarCampus = function (cidade) {
      localStorage.setItem("ciu", JSON.stringify(cidade));
      $API.post('api/campus/BuscarPorLocalidade_a', cidade).then(function (r) {
        $scope.campi = r.data.ReturnData;
      }, function () {
      });

    };
    // BUSCAR CIDADES
    self.BuscarCidade = function (nome) {
      self.isLoading = false;

      if (nome.length == '') {
        self.disabled = true;
        self.isLoading = false;
        self.cidades = [];
        self.instituicoes = [];
      }

      if (nome.length > 2) {
        self.disabled = false;
        self.isLoading = true;
        $API.get('api/cidade/GetFiltro?nome=' + nome).then(function (r) {
          self.isLoading = false;
          self.cidades = r.data.ReturnData;
        }, function () {
        });
      }
    };

    $scope.onSelect = function ($item) {
      document.location = document.location+ '/' + $item.HotSite;
    };
    
    self.formInscricao = function () {
      DialogService.alert({
        title: "Faça sua inscrição!",
        message: document.getElementById('quero-parcelar-meu-curso').innerHTML
      })
    }

    // ANCORA SCROLL LINKS
    self.linkIrPara = function (id) {
      setTimeout(function () {
        $location.hash(id);
        $anchorScroll();
      }, 100);
    };

    self.openOrCloseModalCadastro = function (entrada) {
      self.modalCadastroOpen = entrada;
    };

  }

})();

(function () {
  'use strict';

  angular
    .module('creduc.controllers')
    .controller('FaleConoscoController', FaleConoscoController);

  /** @ngInject */
  function FaleConoscoController(Estado, $scope, HelperService, $stateParams, $state, ContatoService, PathService, Instituicao, DialogService, $API, $rootScope) {

    var self = this;
    self.estados = [];
    self.campi = [];
    self.cidades = [];
    self.selected = {};
    self.emailInstituicao = "";
    self.telefoneInstituicao = "";
    self.isHotsite = PathService.$isHotsite();
    self.$onInit = function () {
      if (PathService.$isHotsite()) {
        var slug = $stateParams.instituicao || $state.params.instituicao;
        self.getContactInfo(slug);
      }

      Estado
        .all()
        .then(function (result) {
          self.estados = result.data.Dados || [];
        })
    }

    self.getCidades = function (estado) {
      HelperService.deleteSelected(self.selected, 'cidade');
      Estado
        .cidades(estado.ID_ESTADO)
        .then(function (result) {
          self.cidades = result.data.Dados;
        });
    };

    self.getCampi = function () {



      $API.get('api/candidato/GetCampiWithCpf?cpf=' + $scope.contato.cpf).then(function (r) {

        if (r) {
          self.campi = r.data.ReturnData
        }

      }, function () {
        //console.log(err);

      }, function (e) {
        $rootScope.modalComponentProgressPercentage = parseInt(100.0 * e.loaded / e.total);
      });
    };

    self.submit = function () {
      var contato = angular.copy($scope.contato);

      if (PathService.$isHotsite()) {
        contato.ID_CAMPUS = Instituicao.data().ID_CAMPUS;
      }

      if (contato.campusSelecionado != null) {
        contato.ID_CAMPUS = contato.campusSelecionado.IdCampus;
        contato.EmailCampus = contato.campusSelecionado.Email;
      } else {
        contato.EmailCampus = 'contato@creduc.com.br';
      }


      ContatoService
        .faleConosco(contato)
        .then(function (result) {
          if (result.data.CodigoResposta == 1) {
            var dialog = DialogService.success({
              message: 'Sua mensagem foi enviada com sucesso!'
            });
            dialog.result.then(function () {
              $scope.contato = {};
            });
          } else {
            DialogService.error();
          }
        }, function () {
          DialogService.error();
        });
    };
    self.getContactInfo = function (slug) {
      ContatoService
        .getContactInfos(slug)
        .then(function (result) {
          if (result.data.Dados) {
            self.emailInstituicao = result.data.Dados.EMAIL;
            self.telefoneInstituicao = result.data.Dados.TELEFONE;
          }
        }, function () {
          //console.log('Erro ao buscar informações de contato.');
        });
    };
    self.$onInit();
  }

})();

(function () {
  'use strict';

  angular
    .module('creduc.controllers')
    .controller('EducaMaisBrasilController', EducaMaisBrasilController);

  /** @ngInject */
  function EducaMaisBrasilController($stateParams, $filter) {
    var self = this;

    self.slides = [];

    self.$onInit = function () {
      self.slides.push({
        title: 'Slide 1',
        src: {
          sm: $filter('assets_url')('images/CREDUC-slide-480x340.jpg'),
          md: $filter('assets_url')('images/CREDUC-slide-1024x400.jpg'),
          lg: $filter('assets_url')('images/CREDUC-slide-1500x420.jpg')
        }
      });
    }
  }

})();

(function () {
  'use strict';

  angular
    .module("creduc.app")
    .run(runBlock);

  /** @ngInject */
  function runBlock($log, $rootScope, $window, $anchorScroll, $state, $stateParams, PathService, $http) {
    //$log.debug('runBlock end');


    $rootScope.$state = $state;
    $rootScope.$instituicao = $stateParams.instituicao;
    $rootScope.$stateParams = angular.copy($stateParams);
    $rootScope.$path = PathService.init($stateParams);
    $rootScope.$status = "";
    $rootScope.custom_theme_dynamic;
    $rootScope.filecss;


    $rootScope.$on('$stateChangeStart', stateChangeStart);
    $rootScope.$on('$stateNotFound', stateNotFound);
    $rootScope.$on('$viewContentLoaded', viewContentLoaded);
    $rootScope.$on('$toggleNavbar', toggleNavbar);

    $rootScope.$watch(function () {
      return $http.pendingRequests.length > 0
    }, function (v) {
      $rootScope.$status = v ? "" : "ready";
      var instituicao = location.pathname.split('/')[1];
      $rootScope.filecss = '/assets/css/' + instituicao + '.css';
      /* eslint-disable no-console */
      console.log($rootScope.filecss);
          /* eslint-enable no-console */
        
    });

    angular.element($window).on('scroll', windowScroll);

    /**
     * Listener state change
     * @return {void}
     */
    function stateChangeStart(e, toState) {
      $rootScope.title = toState.title;
      $rootScope.$seo_keywords = '';
      $rootScope.$seo_description = '';

      $rootScope.pageClass = toState.name;
      $rootScope.$path = PathService.init($stateParams);

      $anchorScroll.yOffset = 60;
      $anchorScroll();
    }

    /**
     * Listener state not found
     * @return {void}
     */
    function stateNotFound() {
      $log.log('state not found');
    }

    /**
     * Listener view content is loaded
     * @return {void}
     */
    function viewContentLoaded() {
      //$window.ga('send', 'pageview', { page: $location.url() });
      //$log.log('view loaded');
    }

    /**
     * Listener of toggleNavbar
     * @param {object} e: event
     * @param {bool} d: navbar status
     * @return {void}
     */
    function toggleNavbar(e, d) {
      $rootScope.navbarIsOpened = d;
    }

    /**
     * scroll event
     * @return {void}
     */
    function windowScroll() {
      $rootScope.isScrolling = this.pageYOffset >= 60;
      $rootScope.$apply();
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('creduc.routes')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {

    /**
     * @name home state
     * @memberOf creduc.routes
     */
    var home = {
      name: 'home',
      url: '/',
      title: 'CREDUC - Crédito Educativo',
      templateUrl: 'app/home/home.html',
      controller: 'HomeController',
      controllerAs: '$ctrl'
    };
    /**
     * @name educamais state
     * @memberOf creduc.routes
     */
    var educaMais = {
      name: 'educa-mais-brasil',
      url: '/educa-mais-brasil',
      title: 'CREDUC - Crédito Educativo',
      templateUrl: 'app/educamaisbrasil/educamaisbrasil.html',
      controller: 'EducaMaisBrasilController',
      controllerAs: '$ctrl'
    };


      /**
   * @name simulador hotsite state
   * @memberOf creduc.routes
   */
    var simulador = {
      name: 'simulador',
      url: '/simulador',
      title: 'CREDUC - Crédito Educativo',
      templateUrl: 'app/simulador/simulador.html',
      controller: 'SimuladorController',
      controllerAs: '$ctrl'
    };

    /**
     * @name simulador hotsite state
     * @memberOf creduc.routes
     */
    var simuladorIesb = {
      name: 'simuladorIesb',
      url: '/{instituicao}/simulador',
      title: 'CREDUC - Crédito Educativo',
      templateUrl: 'app/simulador/simulador.html',
      controller: 'SimuladorController',
      controllerAs: '$ctrl'
    };


    /**
     * @name politica de privacidade state
     * @memberOf creduc.routes
     */
    var politicaPrivacidade = {
      name: 'politica-de-privacidade',
      url: '/politica-de-privacidade',
      title: 'Política de Privacidade - CREDUC',
      templateUrl: 'app/politica-de-privacidade/politica-de-privacidade.html'
    };

    /**
     * @name termos de uso state
     * @memberOf creduc.routes
     */
    var termosUso = {
      name: 'termos-de-uso',
      url: '/termos-de-uso',
      title: 'Termos de Uso - CREDUC',
      templateUrl: 'app/termos-de-uso/termos-de-uso.html'
    };

    /**
     * @name fale conosco state
     * @memberOf creduc.routes
     */
    var faleConosco = {
      name: 'fale-conosco',
      url: '/fale-conosco',
      title: 'Fale Conosco - CREDUC',
      templateUrl: 'app/fale-conosco/fale-conosco.html',
      controller: 'FaleConoscoController',
      controllerAs: '$ctrl'
    };

    /**
     * @name quero ser parceiro state
     * @memberOf creduc.routes
     */
    var queroSerParceiro = {
      name: 'quero-ser-parceiro',
      url: '/quero-ser-parceiro',
      title: 'Quero Ser Parceiro - CREDUC',
      templateUrl: 'app/quero-ser-parceiro/quero-ser-parceiro.html',
      controller: 'QueroSerParceiroController',
      controllerAs: '$ctrl'
    };

    /**
     * @name instituicao hotsite state
     * @memberOf creduc.routes
     */
    var instituicao = {
      name: 'instituicao',
      url: '/{instituicao}',
      title: 'CREDUC - Crédito Educativo',
      templateUrl: 'app/instituicao/instituicao-home.html',
      controller: 'InstituicaoController',
      controllerAs: '$ctrl'
    };




    /**
     * @name parceiros parceiros state
     * @memberOf creduc.routes
     */
    var parceiros = {
      name: 'parceiros',
      url: '/parceiros',
      title: 'Parceiros - CREDUC',
      templateUrl: 'app/parceiros/parceiros.html',
      controller: 'ParceirosController',
      controllerAs: '$ctrl'
    };

    /**
     * @name instituicao hotsite state
     * @memberOf creduc.routes
     */
    var instituicaoFaleConosco = {
      name: 'instituicao-fale-conosco',
      url: '/{instituicao}/fale-conosco',
      title: 'Fale Conosco - CREDUC',
      templateUrl: 'app/fale-conosco/fale-conosco.html',
      controller: 'FaleConoscoController',
      controllerAs: '$ctrl'
    };

    /**
     * @name instituicao hotsite state
     * @memberOf creduc.routes
     */
    var instituicaoTermosDeUso = {
      name: 'instituicao-termos-de-uso',
      url: '/{instituicao}/termos-de-uso',
      title: 'Termos de Uso - CREDUC',
      templateUrl: 'app/termos-de-uso/termos-de-uso.html',
      // controller: 'FaleConoscoController',
      controllerAs: '$ctrl'
    };

    /**
     * @name instituicao hotsite state
     * @memberOf creduc.routes
     */
    var instituicaoPoliticaPrivacidade = {
      name: 'instituicao-politica-de-privacidade',
      url: '/{instituicao}/politica-de-privacidade',
      title: 'Política de Privacidade - CREDUC',
      templateUrl: 'app/politica-de-privacidade/politica-de-privacidade.html',
      // controller: 'FaleConoscoController',
      controllerAs: '$ctrl'
    };

    /**
     * @name instituicao inscricao hotsite state
     * @memberOf creduc.routes
     */
    var instituicaoInscricao = {
      name: 'instituicao-inscricao',
      url: '/{instituicao}/inscricao',
      title: 'Inscrição - CREDUC',
      templateUrl: 'app/inscricao/inscricao.html',
      controller: 'InscricaoController',
      controllerAs: '$ctrl',
      params: {
        candidato: null,
        selected: null,
        estados: null,
        cidades: null,
        instituicoes: null,
        cursos: null
      }
    };

    var instituicaoInscricaoPasso1 = {
      name: 'instituicao-inscricao-dados-pessoais',
      url: '/{instituicao}/inscricao/dados-pessoais',
      title: 'Inscrição - CREDUC',
      templateUrl: 'app/inscricao/inscricao.html',
      controller: 'InscricaoController',
      controllerAs: '$ctrl',
      params: {
        candidato: null,
        selected: null,
        estados: null,
        cidades: null,
        instituicoes: null,
        cursos: null
      }
    };

    var instituicaoInscricaoPasso2 = {
      name: 'instituicao-inscricao-dados-familia',
      url: '/{instituicao}/inscricao/dados-familia',
      title: 'Inscrição - CREDUC',
      templateUrl: 'app/inscricao/inscricao.html',
      controller: 'InscricaoController',
      controllerAs: '$ctrl',
      params: {
        candidato: null,
        selected: null,
        estados: null,
        cidades: null,
        instituicoes: null,
        cursos: null
      }
    };


    var instituicaoInscricaoPasso3 = {
      name: 'instituicao-inscricao-dados-financeiros',
      url: '/{instituicao}/inscricao/dados-financeiros',
      title: 'Inscrição - CREDUC',
      templateUrl: 'app/inscricao/inscricao.html',
      controller: 'InscricaoController',
      controllerAs: '$ctrl',
      params: {
        candidato: null,
        selected: null,
        estados: null,
        cidades: null,
        instituicoes: null,
        cursos: null
      }
    };

    var instituicaoInscricaoPasso4 = {
      name: 'instituicao-inscricao-dados-academicos',
      url: '/{instituicao}/inscricao/dados-academicos',
      title: 'Inscrição - CREDUC',
      templateUrl: 'app/inscricao/inscricao.html',
      controller: 'InscricaoController',
      controllerAs: '$ctrl',
      params: {
        candidato: null,
        selected: null,
        estados: null,
        cidades: null,
        instituicoes: null,
        cursos: null
      }
    };

    var instituicaoInscricaoPasso5= {
      name: 'instituicao-inscricao-dados-corresponsavel-financeiro',
      url: '/{instituicao}/inscricao/dados-corresponsavel-financeiro',
      title: 'Inscrição - CREDUC',
      templateUrl: 'app/inscricao/inscricao.html',
      controller: 'InscricaoController',
      controllerAs: '$ctrl',
      params: {
        candidato: null,
        selected: null,
        estados: null,
        cidades: null,
        instituicoes: null,
        cursos: null
      }
    };
    var instituicaoInscricaoPasso6 = {
      name: 'instituicao-inscricao-documentos-candidato',
      url: '/{instituicao}/inscricao/documentos-candidato',
      title: 'Inscrição - CREDUC',
      templateUrl: 'app/inscricao/inscricao.html',
      controller: 'InscricaoController',
      controllerAs: '$ctrl',
      params: {
        candidato: null,
        selected: null,
        estados: null,
        cidades: null,
        instituicoes: null,
        cursos: null
      }
    };

    var instituicaoInscricaoPassoTermo = {
      name: 'instituicao-inscricao-termo-candidato',
      url: '/{instituicao}/inscricao/termo-candidato',
      title: 'Inscrição - CREDUC',
      templateUrl: 'app/inscricao/inscricao.html',
      controller: 'InscricaoController',
      controllerAs: '$ctrl',
      params: {
        candidato: null,
        selected: null,
        estados: null,
        cidades: null,
        instituicoes: null,
        cursos: null
      }
    };


    var instituicaoInscricaoPasso7 = {
      name: 'instituicao-inscricao-pagar-taxa',
      url: '/{instituicao}/inscricao/pagar-taxa',
      title: 'Inscrição - CREDUC',
      templateUrl: 'app/inscricao/inscricao.html',
      controller: 'InscricaoController',
      controllerAs: '$ctrl',
      params: {
        candidato: null,
        selected: null,
        estados: null,
        cidades: null,
        instituicoes: null,
        cursos: null
      }
    };

    var instituicaoInscricaoPasso8 = {
      name: 'instituicao-inscricao-conclusao',
      url: '/{instituicao}/inscricao/conclusao',
      title: 'Inscrição - CREDUC',
      templateUrl: 'app/inscricao/inscricao.html',
      controller: 'InscricaoController',
      controllerAs: '$ctrl',
      params: {
        candidato: null,
        selected: null,
        estados: null,
        cidades: null,
        instituicoes: null,
        cursos: null
      }
    };
    /**
     * @name instituicao inscricao hotsite state
     * @memberOf creduc.routes
     */
    var instituicaoPendencia = {
      name: 'instituicao-pendencia',
      url: '/{instituicao}/pendencias?cpf&email&ies',
      title: 'Pendências - CREDUC',
      templateUrl: 'app/pendencia/pendencia.html',
      controller: 'PendenciaController',
      controllerAs: '$ctrl',
      params: {
        candidato: null,
        situacao: null
      }
    };

    $stateProvider
      .state(home)
      .state(educaMais)
      .state(simulador)
      .state(simuladorIesb)
      .state(politicaPrivacidade)
      .state(termosUso)
      .state(faleConosco)
      .state(queroSerParceiro)
      .state(parceiros)
      .state(instituicao)
      .state(instituicaoFaleConosco)
      .state(instituicaoTermosDeUso)
      .state(instituicaoPoliticaPrivacidade)
      .state(instituicaoInscricao)
      .state(instituicaoInscricaoPasso1)
      .state(instituicaoInscricaoPasso2)
      .state(instituicaoInscricaoPasso3)
      .state(instituicaoInscricaoPasso4)
      .state(instituicaoInscricaoPasso5)
      .state(instituicaoInscricaoPasso6)
      .state(instituicaoInscricaoPasso7)
      .state(instituicaoInscricaoPasso8)
      .state(instituicaoInscricaoPassoTermo)
      .state(instituicaoPendencia);

    $urlRouterProvider.otherwise('/');
  }

})();

(function () {
  'use strict';

  var API_SETTINGS = {
    PROD: {
      BASE_URL: 'https://api-site.creduc.com.br',
      BASE_API_CREDUC: 'https://api.creduc.com.br/',
      PORTAL_ALUNO_CREDUC: 'https://portal-aluno.creduc.com.br',
      AUTENTICAR: 'https://auth.creduc.com.br',
      CREDUC_API: 'https://api.creduc.com.br'
    },
    HOMOLOGACAO: {
      BASE_URL: 'https://hml-api-site.creduc.com.br',
      BASE_API_CREDUC: 'https://hml-api.creduc.com.br/',
      PORTAL_ALUNO_CREDUC: 'https://hml-portal-aluno.creduc.com.br',
      AUTENTICAR: 'https://hml-auth.creduc.com.br',
      CREDUC_API: 'https://hml-api.creduc.com.br'
    },
    DEV: {
      BASE_URL: 'http://localhost:37069',
      BASE_API_CREDUC: 'http://localhost:44085/',
      //PORTAL_ALUNO_CREDUC: 'http://localhost:3002',
      AUTENTICAR: 'http://localhost:59002',
      //AUTENTICAR: 'https://hml-auth.creduc.com.br',
      CREDUC_API: 'http://localhost:44085'
    }
  };

  var PATH_SETTINGS = {
    PROD: {
      STATIC_URL: 'https://hml-static.creduc.com.br',
      ASSETS_URL: 'https://www.creduc.com.br/assets'
    },
    HOMOLOGACAO: {
      STATIC_URL: 'https://hml-static.creduc.com.br',
      ASSETS_URL: 'https://hml.creduc.com.br/assets'
    },
    DEV: {
      STATIC_URL: 'https://hml-static.creduc.com.br',
      ASSETS_URL: 'assets'
    }
  };

  var CREDUC = {
    ID: 21
  };

  var local = {};

  local.pregQuote = function (string, delimiter) {
    return (string + '').replace(new RegExp('[.\\\\+*?\\[\\^\\]$(){}=!<>|:\\' + (delimiter || '') + '-]', 'g'), '\\$&');
  };

  local.stringToRegex = function (string) {
    return new RegExp(local.pregQuote(string).replace(/\\\*/g, '.*').replace(/\\\?/g, '.'), 'g');
  };

  var ENVIRONMENT = 'DEV';

  if (window.location.host.match(local.stringToRegex('creduc.com.br'))) {
    ENVIRONMENT = 'PROD';
  }

  if (window.location.host.match(local.stringToRegex('hml'))) {
    ENVIRONMENT = 'HOMOLOGACAO';
  }

  if (ENVIRONMENT != 'PROD') {
    //console.info('SETTINGS:', PATH_SETTINGS);// eslint-disable-line no-console
    console.info('Application environment:', ENVIRONMENT);// eslint-disable-line no-console
  }

  angular
    .module('creduc.constants')
    .constant('API_SETTINGS', API_SETTINGS)
    .constant('PATH_SETTINGS', PATH_SETTINGS)
    .constant('CREDUC', CREDUC)
    .constant('ENV', ENVIRONMENT);
})();

(function () {
  'use strict';

  angular
    .module('creduc.config')
    .config(config);


  angular.module('creduc.app');
  /** @ngInject */
  function config($logProvider, $locationProvider, $urlRouterProvider, $compileProvider) {
    // Enable log
    var debug = true;

    $logProvider.debugEnabled(debug);
    $compileProvider.debugInfoEnabled(debug);

    $locationProvider.html5Mode(true);

    $urlRouterProvider.rule(function ($injector, $location) {
      var path = $location.path(), normalized = path.toLowerCase();
      if (path != normalized) {
        $location.replace().path(normalized);
      }
    });
  }

})();
